
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jZACz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8e01efd3250665d$var$_react = $e8e01efd3250665d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $e8e01efd3250665d$var$_peopleGroup = $e8e01efd3250665d$var$_interopRequireDefault((parcelRequire("j1BAi")));
function $e8e01efd3250665d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8e01efd3250665d$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $e8e01efd3250665d$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $e8e01efd3250665d$var$_peopleGroup.default
    }));
$e8e01efd3250665d$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $e8e01efd3250665d$var$_default = module.exports.default = $e8e01efd3250665d$var$PeopleGroupIcon;

});
parcelRegister("j1BAi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c2c434ab24649808044e93163bd51c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd9b43cc44243668$var$_react = $dd9b43cc44243668$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dd9b43cc44243668$var$_UNSAFE_baseNew = $dd9b43cc44243668$var$_interopRequireDefault((parcelRequire("li861")));
function $dd9b43cc44243668$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd9b43cc44243668$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $dd9b43cc44243668$var$_react.default.createElement($dd9b43cc44243668$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$dd9b43cc44243668$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $dd9b43cc44243668$var$_default = module.exports.default = $dd9b43cc44243668$var$PeopleGroupIcon;

});


parcelRegister("lvevd", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $b17c7602e98263cb$export$c4b5b1f965d8b3eb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Edzt = parcelRequire("4Edzt");

var $aj9D5 = parcelRequire("aj9D5");

var $l87sQ = parcelRequire("l87sQ");

var $3axaQ = parcelRequire("3axaQ");
const $b17c7602e98263cb$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $l87sQ.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $b17c7602e98263cb$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $aj9D5.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $aj9D5.defaultLogoParams).textColor, iconColor: iconColor = (0, $aj9D5.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $4Edzt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3axaQ.default), {
        appearance: appearance,
        label: label,
        svg: $b17c7602e98263cb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("4Edzt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c2b62648c9763e4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4rZaP = parcelRequire("4rZaP");

var $fte8R = parcelRequire("fte8R");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $8c2b62648c9763e4$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $eUqFw.useState)((0, $4rZaP.default)());
    (0, $eUqFw.useEffect)(()=>{
        const observer = new (0, $fte8R.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $8c2b62648c9763e4$export$2e2bcd8739ae039 = $8c2b62648c9763e4$var$useThemeObserver;

});
parcelRegister("4rZaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd8fd363bf63ac7$export$2e2bcd8739ae039);

var $jDQ57 = parcelRequire("jDQ57");

var $e6GUV = parcelRequire("e6GUV");

var $8bL6n = parcelRequire("8bL6n");
const $abd8fd363bf63ac7$var$isThemeColorMode = (colorMode)=>{
    return (0, $e6GUV.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $abd8fd363bf63ac7$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $jDQ57.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $jDQ57.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $8bL6n.themeStringToObject)(theme),
        ...$abd8fd363bf63ac7$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $abd8fd363bf63ac7$export$2e2bcd8739ae039 = $abd8fd363bf63ac7$var$getGlobalTheme;

});
parcelRegister("e6GUV", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $495a70cd71a9038a$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $495a70cd71a9038a$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $495a70cd71a9038a$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $495a70cd71a9038a$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $495a70cd71a9038a$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ const $495a70cd71a9038a$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $495a70cd71a9038a$export$8ce7e340c74e86c5 = [
    'more',
    'no-preference',
    'auto'
];
const $495a70cd71a9038a$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
const $495a70cd71a9038a$export$ba8a43b83ecc69f8 = [];
const $495a70cd71a9038a$export$92ba366331403db2 = [
    ...$495a70cd71a9038a$export$7d43e72a58e3283f,
    ...$495a70cd71a9038a$export$ba8a43b83ecc69f8
];
const $495a70cd71a9038a$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $495a70cd71a9038a$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var $495a70cd71a9038a$export$2e2bcd8739ae039 = $495a70cd71a9038a$var$themeConfig;

});

parcelRegister("8bL6n", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $064b6dc37a6fecce$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $064b6dc37a6fecce$export$62c37ab81302621a);

var $e6GUV = parcelRequire("e6GUV");
const $064b6dc37a6fecce$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $064b6dc37a6fecce$var$customThemeOptions = 'UNSAFE_themeOptions';
const $064b6dc37a6fecce$var$isThemeKind = (themeKind)=>{
    return $064b6dc37a6fecce$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $064b6dc37a6fecce$var$isThemeIds = (themeId)=>{
    return (0, $e6GUV.themeIds).find((id)=>id === themeId) !== undefined;
};
const $064b6dc37a6fecce$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $064b6dc37a6fecce$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $064b6dc37a6fecce$var$isColorMode(id)) themeObject[kind] = id;
        if ($064b6dc37a6fecce$var$isThemeKind(kind) && $064b6dc37a6fecce$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $064b6dc37a6fecce$var$customThemeOptions) try {
            themeObject[$064b6dc37a6fecce$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $064b6dc37a6fecce$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $064b6dc37a6fecce$var$isColorMode(id) || // custom theme state
        kind === $064b6dc37a6fecce$var$customThemeOptions && typeof id === 'object' || // other theme states
        $064b6dc37a6fecce$var$isThemeKind(kind) && typeof id === 'string' && $064b6dc37a6fecce$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("fte8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54ec6a1cb752cfd$export$2e2bcd8739ae039);

var $jDQ57 = parcelRequire("jDQ57");

var $4rZaP = parcelRequire("4rZaP");
class $a54ec6a1cb752cfd$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $a54ec6a1cb752cfd$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$a54ec6a1cb752cfd$export$2e2bcd8739ae039.observer) {
            $a54ec6a1cb752cfd$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $4rZaP.default)();
                $a54ec6a1cb752cfd$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $a54ec6a1cb752cfd$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $jDQ57.THEME_DATA_ATTRIBUTE),
                    (0, $jDQ57.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $a54ec6a1cb752cfd$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($a54ec6a1cb752cfd$export$2e2bcd8739ae039.callbacks.size === 0 && $a54ec6a1cb752cfd$export$2e2bcd8739ae039.observer) {
            $a54ec6a1cb752cfd$export$2e2bcd8739ae039.observer.disconnect();
            $a54ec6a1cb752cfd$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});


parcelRegister("aj9D5", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", () => $47baec44e57336f1$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $47baec44e57336f1$export$793fba32aed8942a);
$parcel$export(module.exports, "sizes", () => $47baec44e57336f1$export$c647cb0ee6e282fe);
const $47baec44e57336f1$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $47baec44e57336f1$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
const $47baec44e57336f1$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $47baec44e57336f1$export$31d7044b7540a6d8 = $47baec44e57336f1$export$438460117ae6b7ee;

});

parcelRegister("l87sQ", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $1e849915ca1170ef$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $1e849915ca1170ef$export$bbacc3980e0f3029);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $1e849915ca1170ef$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $753dd713deeb1c87$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $753dd713deeb1c87$export$215b7063051591f1);
            iconColor = (0, $753dd713deeb1c87$export$215b7063051591f1);
            textColor = `var(--ds-text, ${0, $753dd713deeb1c87$export$7d61b15e0da132af})`;
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $753dd713deeb1c87$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $753dd713deeb1c87$export$7090862dc3038a9f);
            iconGradientStop = (0, $753dd713deeb1c87$export$d6447c357493214f);
            iconColor = (0, $753dd713deeb1c87$export$d6447c357493214f);
            textColor = (0, $753dd713deeb1c87$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $753dd713deeb1c87$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $1e849915ca1170ef$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $753dd713deeb1c87$export$29a4f05edc054374);
            textColor = (0, $753dd713deeb1c87$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $753dd713deeb1c87$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $1e849915ca1170ef$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $1e849915ca1170ef$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $1e849915ca1170ef$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
var $753dd713deeb1c87$exports = {};

$parcel$export($753dd713deeb1c87$exports, "R50", () => $753dd713deeb1c87$export$4b84fd0e2c617bd);
$parcel$export($753dd713deeb1c87$exports, "R75", () => $753dd713deeb1c87$export$b34b069eff244586);
$parcel$export($753dd713deeb1c87$exports, "R100", () => $753dd713deeb1c87$export$be802dd0d8b57f35);
$parcel$export($753dd713deeb1c87$exports, "R200", () => $753dd713deeb1c87$export$60847d42f9da92a6);
$parcel$export($753dd713deeb1c87$exports, "R300", () => $753dd713deeb1c87$export$4a7404f376229999);
$parcel$export($753dd713deeb1c87$exports, "R400", () => $753dd713deeb1c87$export$2010d0fb4295b346);
$parcel$export($753dd713deeb1c87$exports, "R500", () => $753dd713deeb1c87$export$2837b5a1a71d5c02);
$parcel$export($753dd713deeb1c87$exports, "Y50", () => $753dd713deeb1c87$export$8d9596b529bbb9cf);
$parcel$export($753dd713deeb1c87$exports, "Y75", () => $753dd713deeb1c87$export$41060a744ab0b7ae);
$parcel$export($753dd713deeb1c87$exports, "Y100", () => $753dd713deeb1c87$export$1cc05bbbf340e559);
$parcel$export($753dd713deeb1c87$exports, "Y200", () => $753dd713deeb1c87$export$5aae31392d72caaa);
$parcel$export($753dd713deeb1c87$exports, "Y300", () => $753dd713deeb1c87$export$c6930421db9fa514);
$parcel$export($753dd713deeb1c87$exports, "Y400", () => $753dd713deeb1c87$export$59619663aa6500fb);
$parcel$export($753dd713deeb1c87$exports, "Y500", () => $753dd713deeb1c87$export$874739ea9e379ab6);
$parcel$export($753dd713deeb1c87$exports, "G50", () => $753dd713deeb1c87$export$8a6341c32b6a3ee6);
$parcel$export($753dd713deeb1c87$exports, "G75", () => $753dd713deeb1c87$export$69a3bf21b9686c2b);
$parcel$export($753dd713deeb1c87$exports, "G100", () => $753dd713deeb1c87$export$afbce1382ec95f73);
$parcel$export($753dd713deeb1c87$exports, "G200", () => $753dd713deeb1c87$export$747d86715d4175de);
$parcel$export($753dd713deeb1c87$exports, "G300", () => $753dd713deeb1c87$export$940e1f69e873f202);
$parcel$export($753dd713deeb1c87$exports, "G400", () => $753dd713deeb1c87$export$a49394138f7b8e85);
$parcel$export($753dd713deeb1c87$exports, "G500", () => $753dd713deeb1c87$export$6fa04827ac68a4fb);
$parcel$export($753dd713deeb1c87$exports, "B50", () => $753dd713deeb1c87$export$226de0355ed012f8);
$parcel$export($753dd713deeb1c87$exports, "B75", () => $753dd713deeb1c87$export$8c13c2ee36917869);
$parcel$export($753dd713deeb1c87$exports, "B100", () => $753dd713deeb1c87$export$ecfc1dff386a3e7a);
$parcel$export($753dd713deeb1c87$exports, "B200", () => $753dd713deeb1c87$export$215b7063051591f1);
$parcel$export($753dd713deeb1c87$exports, "B300", () => $753dd713deeb1c87$export$e62e8919cca44969);
$parcel$export($753dd713deeb1c87$exports, "B400", () => $753dd713deeb1c87$export$b3de0ae08da2ce64);
$parcel$export($753dd713deeb1c87$exports, "B500", () => $753dd713deeb1c87$export$a6ee3d71bc067634);
$parcel$export($753dd713deeb1c87$exports, "P50", () => $753dd713deeb1c87$export$363e4475840015bb);
$parcel$export($753dd713deeb1c87$exports, "P75", () => $753dd713deeb1c87$export$4b0a4417ed59760f);
$parcel$export($753dd713deeb1c87$exports, "P100", () => $753dd713deeb1c87$export$6011520a64d9a187);
$parcel$export($753dd713deeb1c87$exports, "P200", () => $753dd713deeb1c87$export$a7175d4e9206bc80);
$parcel$export($753dd713deeb1c87$exports, "P300", () => $753dd713deeb1c87$export$b48405b95304b5a1);
$parcel$export($753dd713deeb1c87$exports, "P400", () => $753dd713deeb1c87$export$c71e4279dd54a18d);
$parcel$export($753dd713deeb1c87$exports, "P500", () => $753dd713deeb1c87$export$147899de772240ec);
$parcel$export($753dd713deeb1c87$exports, "T50", () => $753dd713deeb1c87$export$2cf711fe14c66f06);
$parcel$export($753dd713deeb1c87$exports, "T75", () => $753dd713deeb1c87$export$7a8f4d33f6f9772c);
$parcel$export($753dd713deeb1c87$exports, "T100", () => $753dd713deeb1c87$export$776c9c497ef08533);
$parcel$export($753dd713deeb1c87$exports, "T200", () => $753dd713deeb1c87$export$69cb3ca10c1e330e);
$parcel$export($753dd713deeb1c87$exports, "T300", () => $753dd713deeb1c87$export$9dc1ef0f3f48059b);
$parcel$export($753dd713deeb1c87$exports, "T400", () => $753dd713deeb1c87$export$7c835c78b6fcdef8);
$parcel$export($753dd713deeb1c87$exports, "T500", () => $753dd713deeb1c87$export$6036577f95c3877e);
$parcel$export($753dd713deeb1c87$exports, "N0", () => $753dd713deeb1c87$export$29a4f05edc054374);
$parcel$export($753dd713deeb1c87$exports, "N10", () => $753dd713deeb1c87$export$e655ef011c4aa1a2);
$parcel$export($753dd713deeb1c87$exports, "N20", () => $753dd713deeb1c87$export$9fdfb749e33cdf97);
$parcel$export($753dd713deeb1c87$exports, "N30", () => $753dd713deeb1c87$export$3e51e8f1440314ba);
$parcel$export($753dd713deeb1c87$exports, "N40", () => $753dd713deeb1c87$export$1ce2d1575d444ceb);
$parcel$export($753dd713deeb1c87$exports, "N50", () => $753dd713deeb1c87$export$8754fc7e6d8b3000);
$parcel$export($753dd713deeb1c87$exports, "N60", () => $753dd713deeb1c87$export$c2e91cbeada39b8b);
$parcel$export($753dd713deeb1c87$exports, "N70", () => $753dd713deeb1c87$export$5f71e19f3a7ad9de);
$parcel$export($753dd713deeb1c87$exports, "N80", () => $753dd713deeb1c87$export$eaa8c8a70ac22806);
$parcel$export($753dd713deeb1c87$exports, "N90", () => $753dd713deeb1c87$export$7c87d337fb91a97d);
$parcel$export($753dd713deeb1c87$exports, "N100", () => $753dd713deeb1c87$export$d6447c357493214f);
$parcel$export($753dd713deeb1c87$exports, "N200", () => $753dd713deeb1c87$export$f563ee71e9ee74cd);
$parcel$export($753dd713deeb1c87$exports, "N300", () => $753dd713deeb1c87$export$e2ef2124cf4024b1);
$parcel$export($753dd713deeb1c87$exports, "N400", () => $753dd713deeb1c87$export$eece5f492e429f08);
$parcel$export($753dd713deeb1c87$exports, "N500", () => $753dd713deeb1c87$export$c39c0fe0f26207ae);
$parcel$export($753dd713deeb1c87$exports, "N600", () => $753dd713deeb1c87$export$7090862dc3038a9f);
$parcel$export($753dd713deeb1c87$exports, "N700", () => $753dd713deeb1c87$export$ad0bacf983b7ddaa);
$parcel$export($753dd713deeb1c87$exports, "N800", () => $753dd713deeb1c87$export$7d61b15e0da132af);
$parcel$export($753dd713deeb1c87$exports, "N900", () => $753dd713deeb1c87$export$fbda843f0a27fe96);
$parcel$export($753dd713deeb1c87$exports, "N10A", () => $753dd713deeb1c87$export$791e57b27ca738ef);
$parcel$export($753dd713deeb1c87$exports, "N20A", () => $753dd713deeb1c87$export$8d43898f60b96a82);
$parcel$export($753dd713deeb1c87$exports, "N30A", () => $753dd713deeb1c87$export$920c0d5c49070351);
$parcel$export($753dd713deeb1c87$exports, "N40A", () => $753dd713deeb1c87$export$46987b49aab6d1a8);
$parcel$export($753dd713deeb1c87$exports, "N50A", () => $753dd713deeb1c87$export$7d3359664e8bb0e5);
$parcel$export($753dd713deeb1c87$exports, "N60A", () => $753dd713deeb1c87$export$d2d3bedfb276cac0);
$parcel$export($753dd713deeb1c87$exports, "N70A", () => $753dd713deeb1c87$export$6e5e7499ff054f6d);
$parcel$export($753dd713deeb1c87$exports, "N80A", () => $753dd713deeb1c87$export$59264b346c877fa7);
$parcel$export($753dd713deeb1c87$exports, "N90A", () => $753dd713deeb1c87$export$d092757d7c64925c);
$parcel$export($753dd713deeb1c87$exports, "N100A", () => $753dd713deeb1c87$export$486ab785e4bac3c6);
$parcel$export($753dd713deeb1c87$exports, "N200A", () => $753dd713deeb1c87$export$fba592bbc6419fea);
$parcel$export($753dd713deeb1c87$exports, "N300A", () => $753dd713deeb1c87$export$13609db0e6812ab8);
$parcel$export($753dd713deeb1c87$exports, "N400A", () => $753dd713deeb1c87$export$fbae4efaa892d883);
$parcel$export($753dd713deeb1c87$exports, "N500A", () => $753dd713deeb1c87$export$f13946d26f440ce6);
$parcel$export($753dd713deeb1c87$exports, "N600A", () => $753dd713deeb1c87$export$19f58225ac52a306);
$parcel$export($753dd713deeb1c87$exports, "N700A", () => $753dd713deeb1c87$export$6384f09da70e7b62);
$parcel$export($753dd713deeb1c87$exports, "N800A", () => $753dd713deeb1c87$export$d0dccc730683edc2);
$parcel$export($753dd713deeb1c87$exports, "DN900", () => $753dd713deeb1c87$export$2f6319cf7d736c2a);
$parcel$export($753dd713deeb1c87$exports, "DN800", () => $753dd713deeb1c87$export$95126bc8884d6634);
$parcel$export($753dd713deeb1c87$exports, "DN700", () => $753dd713deeb1c87$export$8338d8c35d44ff1);
$parcel$export($753dd713deeb1c87$exports, "DN600", () => $753dd713deeb1c87$export$5368d76ae4fbbda7);
$parcel$export($753dd713deeb1c87$exports, "DN500", () => $753dd713deeb1c87$export$9f0a771d16ec8d36);
$parcel$export($753dd713deeb1c87$exports, "DN400", () => $753dd713deeb1c87$export$abcf8c38338b4aa5);
$parcel$export($753dd713deeb1c87$exports, "DN300", () => $753dd713deeb1c87$export$97e81faa16a182c7);
$parcel$export($753dd713deeb1c87$exports, "DN200", () => $753dd713deeb1c87$export$bfe21c59123ecf33);
$parcel$export($753dd713deeb1c87$exports, "DN100", () => $753dd713deeb1c87$export$ee82aa2ea6a1558);
$parcel$export($753dd713deeb1c87$exports, "DN90", () => $753dd713deeb1c87$export$682927c6ed76be02);
$parcel$export($753dd713deeb1c87$exports, "DN80", () => $753dd713deeb1c87$export$91fd9994c5be9757);
$parcel$export($753dd713deeb1c87$exports, "DN70", () => $753dd713deeb1c87$export$d281fbfe3cff2df6);
$parcel$export($753dd713deeb1c87$exports, "DN60", () => $753dd713deeb1c87$export$3902c91d8b98a753);
$parcel$export($753dd713deeb1c87$exports, "DN50", () => $753dd713deeb1c87$export$8e8133c1ba5845b5);
$parcel$export($753dd713deeb1c87$exports, "DN40", () => $753dd713deeb1c87$export$33ff357f6620b39);
$parcel$export($753dd713deeb1c87$exports, "DN30", () => $753dd713deeb1c87$export$633847cf062b69e0);
$parcel$export($753dd713deeb1c87$exports, "DN20", () => $753dd713deeb1c87$export$9776a6e503bdbf76);
$parcel$export($753dd713deeb1c87$exports, "DN10", () => $753dd713deeb1c87$export$6c813d5160dff5db);
$parcel$export($753dd713deeb1c87$exports, "DN0", () => $753dd713deeb1c87$export$3d4f271a500072a);
$parcel$export($753dd713deeb1c87$exports, "DN800A", () => $753dd713deeb1c87$export$fe151285c22759ec);
$parcel$export($753dd713deeb1c87$exports, "DN700A", () => $753dd713deeb1c87$export$a101c6190d0da34);
$parcel$export($753dd713deeb1c87$exports, "DN600A", () => $753dd713deeb1c87$export$4b16f52932fda51);
$parcel$export($753dd713deeb1c87$exports, "DN500A", () => $753dd713deeb1c87$export$a74bcd7b9845b0d8);
$parcel$export($753dd713deeb1c87$exports, "DN400A", () => $753dd713deeb1c87$export$9209c179316d1751);
$parcel$export($753dd713deeb1c87$exports, "DN300A", () => $753dd713deeb1c87$export$88f55133f636c8dd);
$parcel$export($753dd713deeb1c87$exports, "DN200A", () => $753dd713deeb1c87$export$51126f85d1009512);
$parcel$export($753dd713deeb1c87$exports, "DN100A", () => $753dd713deeb1c87$export$a069b547bd23af78);
$parcel$export($753dd713deeb1c87$exports, "DN90A", () => $753dd713deeb1c87$export$40cce05af3b2600a);
$parcel$export($753dd713deeb1c87$exports, "DN80A", () => $753dd713deeb1c87$export$b78942185925a0d);
$parcel$export($753dd713deeb1c87$exports, "DN70A", () => $753dd713deeb1c87$export$e058fb44b8eaafca);
$parcel$export($753dd713deeb1c87$exports, "DN60A", () => $753dd713deeb1c87$export$92b0b8de26920c18);
$parcel$export($753dd713deeb1c87$exports, "DN50A", () => $753dd713deeb1c87$export$67564f7459d3fc9e);
$parcel$export($753dd713deeb1c87$exports, "DN40A", () => $753dd713deeb1c87$export$77868e1ca884ffa3);
$parcel$export($753dd713deeb1c87$exports, "DN30A", () => $753dd713deeb1c87$export$2afd71d7d3ea2cd5);
$parcel$export($753dd713deeb1c87$exports, "DN20A", () => $753dd713deeb1c87$export$f2a0acaab9972c70);
$parcel$export($753dd713deeb1c87$exports, "DN10A", () => $753dd713deeb1c87$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $753dd713deeb1c87$export$4b84fd0e2c617bd = '#FFEBE6';
const $753dd713deeb1c87$export$b34b069eff244586 = '#FFBDAD';
const $753dd713deeb1c87$export$be802dd0d8b57f35 = '#FF8F73';
const $753dd713deeb1c87$export$60847d42f9da92a6 = '#FF7452';
const $753dd713deeb1c87$export$4a7404f376229999 = '#FF5630';
const $753dd713deeb1c87$export$2010d0fb4295b346 = '#DE350B';
const $753dd713deeb1c87$export$2837b5a1a71d5c02 = '#BF2600';
const $753dd713deeb1c87$export$8d9596b529bbb9cf = '#FFFAE6';
const $753dd713deeb1c87$export$41060a744ab0b7ae = '#FFF0B3';
const $753dd713deeb1c87$export$1cc05bbbf340e559 = '#FFE380';
const $753dd713deeb1c87$export$5aae31392d72caaa = '#FFC400';
const $753dd713deeb1c87$export$c6930421db9fa514 = '#FFAB00';
const $753dd713deeb1c87$export$59619663aa6500fb = '#FF991F';
const $753dd713deeb1c87$export$874739ea9e379ab6 = '#FF8B00';
const $753dd713deeb1c87$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $753dd713deeb1c87$export$69a3bf21b9686c2b = '#ABF5D1';
const $753dd713deeb1c87$export$afbce1382ec95f73 = '#79F2C0';
const $753dd713deeb1c87$export$747d86715d4175de = '#57D9A3';
const $753dd713deeb1c87$export$940e1f69e873f202 = '#36B37E';
const $753dd713deeb1c87$export$a49394138f7b8e85 = '#00875A';
const $753dd713deeb1c87$export$6fa04827ac68a4fb = '#006644';
const $753dd713deeb1c87$export$226de0355ed012f8 = '#DEEBFF';
const $753dd713deeb1c87$export$8c13c2ee36917869 = '#B3D4FF';
const $753dd713deeb1c87$export$ecfc1dff386a3e7a = '#4C9AFF';
const $753dd713deeb1c87$export$215b7063051591f1 = '#2684FF';
const $753dd713deeb1c87$export$e62e8919cca44969 = '#0065FF';
const $753dd713deeb1c87$export$b3de0ae08da2ce64 = '#0052CC';
const $753dd713deeb1c87$export$a6ee3d71bc067634 = '#0747A6';
const $753dd713deeb1c87$export$363e4475840015bb = '#EAE6FF';
const $753dd713deeb1c87$export$4b0a4417ed59760f = '#C0B6F2';
const $753dd713deeb1c87$export$6011520a64d9a187 = '#998DD9';
const $753dd713deeb1c87$export$a7175d4e9206bc80 = '#8777D9';
const $753dd713deeb1c87$export$b48405b95304b5a1 = '#6554C0';
const $753dd713deeb1c87$export$c71e4279dd54a18d = '#5243AA';
const $753dd713deeb1c87$export$147899de772240ec = '#403294';
const $753dd713deeb1c87$export$2cf711fe14c66f06 = '#E6FCFF';
const $753dd713deeb1c87$export$7a8f4d33f6f9772c = '#B3F5FF';
const $753dd713deeb1c87$export$776c9c497ef08533 = '#79E2F2';
const $753dd713deeb1c87$export$69cb3ca10c1e330e = '#00C7E6';
const $753dd713deeb1c87$export$9dc1ef0f3f48059b = '#00B8D9';
const $753dd713deeb1c87$export$7c835c78b6fcdef8 = '#00A3BF';
const $753dd713deeb1c87$export$6036577f95c3877e = '#008DA6';
const $753dd713deeb1c87$export$29a4f05edc054374 = '#FFFFFF';
const $753dd713deeb1c87$export$e655ef011c4aa1a2 = '#FAFBFC';
const $753dd713deeb1c87$export$9fdfb749e33cdf97 = '#F4F5F7';
const $753dd713deeb1c87$export$3e51e8f1440314ba = '#EBECF0';
const $753dd713deeb1c87$export$1ce2d1575d444ceb = '#DFE1E6';
const $753dd713deeb1c87$export$8754fc7e6d8b3000 = '#C1C7D0';
const $753dd713deeb1c87$export$c2e91cbeada39b8b = '#B3BAC5';
const $753dd713deeb1c87$export$5f71e19f3a7ad9de = '#A5ADBA';
const $753dd713deeb1c87$export$eaa8c8a70ac22806 = '#97A0AF';
const $753dd713deeb1c87$export$7c87d337fb91a97d = '#8993A4';
const $753dd713deeb1c87$export$d6447c357493214f = '#7A869A';
const $753dd713deeb1c87$export$f563ee71e9ee74cd = '#6B778C';
const $753dd713deeb1c87$export$e2ef2124cf4024b1 = '#5E6C84';
const $753dd713deeb1c87$export$eece5f492e429f08 = '#505F79';
const $753dd713deeb1c87$export$c39c0fe0f26207ae = '#42526E';
const $753dd713deeb1c87$export$7090862dc3038a9f = '#344563';
const $753dd713deeb1c87$export$ad0bacf983b7ddaa = '#253858';
const $753dd713deeb1c87$export$7d61b15e0da132af = '#172B4D';
const $753dd713deeb1c87$export$fbda843f0a27fe96 = '#091E42';
const $753dd713deeb1c87$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $753dd713deeb1c87$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $753dd713deeb1c87$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $753dd713deeb1c87$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $753dd713deeb1c87$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $753dd713deeb1c87$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $753dd713deeb1c87$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $753dd713deeb1c87$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $753dd713deeb1c87$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $753dd713deeb1c87$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $753dd713deeb1c87$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $753dd713deeb1c87$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $753dd713deeb1c87$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $753dd713deeb1c87$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $753dd713deeb1c87$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $753dd713deeb1c87$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $753dd713deeb1c87$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $753dd713deeb1c87$export$2f6319cf7d736c2a = '#E6EDFA';
const $753dd713deeb1c87$export$95126bc8884d6634 = '#DCE5F5';
const $753dd713deeb1c87$export$8338d8c35d44ff1 = '#CED9EB';
const $753dd713deeb1c87$export$5368d76ae4fbbda7 = '#B8C7E0';
const $753dd713deeb1c87$export$9f0a771d16ec8d36 = '#ABBBD6';
const $753dd713deeb1c87$export$abcf8c38338b4aa5 = '#9FB0CC';
const $753dd713deeb1c87$export$97e81faa16a182c7 = '#8C9CB8';
const $753dd713deeb1c87$export$bfe21c59123ecf33 = '#7988A3';
const $753dd713deeb1c87$export$ee82aa2ea6a1558 = '#67758F';
const $753dd713deeb1c87$export$682927c6ed76be02 = '#56637A';
const $753dd713deeb1c87$export$91fd9994c5be9757 = '#455166';
const $753dd713deeb1c87$export$d281fbfe3cff2df6 = '#3B475C';
const $753dd713deeb1c87$export$3902c91d8b98a753 = '#313D52';
const $753dd713deeb1c87$export$8e8133c1ba5845b5 = '#283447';
const $753dd713deeb1c87$export$33ff357f6620b39 = '#202B3D';
const $753dd713deeb1c87$export$633847cf062b69e0 = '#1B2638';
const $753dd713deeb1c87$export$9776a6e503bdbf76 = '#121A29';
const $753dd713deeb1c87$export$6c813d5160dff5db = '#0E1624';
const $753dd713deeb1c87$export$3d4f271a500072a = '#0D1424';
const $753dd713deeb1c87$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $753dd713deeb1c87$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $753dd713deeb1c87$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $753dd713deeb1c87$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $753dd713deeb1c87$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $753dd713deeb1c87$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $753dd713deeb1c87$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $753dd713deeb1c87$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $753dd713deeb1c87$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $753dd713deeb1c87$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $753dd713deeb1c87$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $753dd713deeb1c87$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $753dd713deeb1c87$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $753dd713deeb1c87$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $753dd713deeb1c87$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $753dd713deeb1c87$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $753dd713deeb1c87$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("3axaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $741d0e294b0e0bb7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $aj9D5 = parcelRequire("aj9D5");
function $741d0e294b0e0bb7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $741d0e294b0e0bb7$var$CSS_VAR_COLOR = '--logo-color';
const $741d0e294b0e0bb7$var$CSS_VAR_FILL = '--logo-fill';
const $741d0e294b0e0bb7$var$baseWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    color: `var(${$741d0e294b0e0bb7$var$CSS_VAR_COLOR})`,
    fill: `var(${$741d0e294b0e0bb7$var$CSS_VAR_FILL})`,
    lineHeight: 1,
    userSelect: 'none',
    whiteSpace: 'normal',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': {
        height: '100%',
        fill: 'inherit'
    }
});
const $741d0e294b0e0bb7$var$stopColorStyles = {
    name: "1hl44m8",
    styles: "stop{stop-color:currentColor;}"
};
const $741d0e294b0e0bb7$var$sizeStyles = Object.entries((0, $aj9D5.sizes)).reduce((acc, [key, val])=>{
    acc[key] = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${val}px`
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $741d0e294b0e0bb7$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $741d0e294b0e0bb7$var$baseWrapperStyles,
            shouldApplyStopColor && $741d0e294b0e0bb7$var$stopColorStyles,
            size && $741d0e294b0e0bb7$var$sizeStyles[size]
        ],
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$741d0e294b0e0bb7$var$CSS_VAR_COLOR]: iconColor,
            [$741d0e294b0e0bb7$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest
    });
};
var $741d0e294b0e0bb7$export$2e2bcd8739ae039 = $741d0e294b0e0bb7$var$Wrapper;

});


parcelRegister("gmIql", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bea1291775398a0d$var$_react = $bea1291775398a0d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $bea1291775398a0d$var$_error = $bea1291775398a0d$var$_interopRequireDefault((parcelRequire("4a9V1")));
function $bea1291775398a0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bea1291775398a0d$var$ErrorIcon = (props)=>/*#__PURE__*/ $bea1291775398a0d$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $bea1291775398a0d$var$_error.default
    }));
$bea1291775398a0d$var$ErrorIcon.displayName = 'ErrorIcon';
var $bea1291775398a0d$var$_default = module.exports.default = $bea1291775398a0d$var$ErrorIcon;

});
parcelRegister("4a9V1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8547c3f91abc335ca9c5bbfd88dd7340>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $307fca41ad2e135d$var$_react = $307fca41ad2e135d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $307fca41ad2e135d$var$_UNSAFE_baseNew = $307fca41ad2e135d$var$_interopRequireDefault((parcelRequire("li861")));
function $307fca41ad2e135d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $307fca41ad2e135d$var$ErrorIcon = (props)=>/*#__PURE__*/ $307fca41ad2e135d$var$_react.default.createElement($307fca41ad2e135d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$307fca41ad2e135d$var$ErrorIcon.displayName = 'ErrorIcon';
var $307fca41ad2e135d$var$_default = module.exports.default = $307fca41ad2e135d$var$ErrorIcon;

});


parcelRegister("2jWWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b0b1391087888dd$var$_react = $1b0b1391087888dd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $1b0b1391087888dd$var$_dashboard = $1b0b1391087888dd$var$_interopRequireDefault((parcelRequire("9Anpu")));
function $1b0b1391087888dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b0b1391087888dd$var$ActivityIcon = (props)=>/*#__PURE__*/ $1b0b1391087888dd$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
    }, props, {
        newIcon: $1b0b1391087888dd$var$_dashboard.default
    }));
$1b0b1391087888dd$var$ActivityIcon.displayName = 'ActivityIcon';
var $1b0b1391087888dd$var$_default = module.exports.default = $1b0b1391087888dd$var$ActivityIcon;

});
parcelRegister("9Anpu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c9db1d77431cb9a8a939a1ea2268662>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fa9a2989db4c280$var$_react = $6fa9a2989db4c280$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6fa9a2989db4c280$var$_UNSAFE_baseNew = $6fa9a2989db4c280$var$_interopRequireDefault((parcelRequire("li861")));
function $6fa9a2989db4c280$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fa9a2989db4c280$var$DashboardIcon = (props)=>/*#__PURE__*/ $6fa9a2989db4c280$var$_react.default.createElement($6fa9a2989db4c280$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h5m0-12.5h5c.69 0 1.25.56 1.25 1.25v5M8 1.75V8m0 6.25h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25V8m0 0h6.25"/>`
    }, props));
$6fa9a2989db4c280$var$DashboardIcon.displayName = 'DashboardIcon';
var $6fa9a2989db4c280$var$_default = module.exports.default = $6fa9a2989db4c280$var$DashboardIcon;

});


parcelRegister("kuCD7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeb493147f0e8eb2$var$_react = $eeb493147f0e8eb2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $eeb493147f0e8eb2$var$_app = $eeb493147f0e8eb2$var$_interopRequireDefault((parcelRequire("dyayV")));
function $eeb493147f0e8eb2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eeb493147f0e8eb2$var$AddonIcon = (props)=>/*#__PURE__*/ $eeb493147f0e8eb2$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
    }, props, {
        newIcon: $eeb493147f0e8eb2$var$_app.default
    }));
$eeb493147f0e8eb2$var$AddonIcon.displayName = 'AddonIcon';
var $eeb493147f0e8eb2$var$_default = module.exports.default = $eeb493147f0e8eb2$var$AddonIcon;

});
parcelRegister("dyayV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e11375a86a4981bad5d408142ebed2ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dd6a4c8a7c4deb9$var$_react = $9dd6a4c8a7c4deb9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9dd6a4c8a7c4deb9$var$_UNSAFE_baseNew = $9dd6a4c8a7c4deb9$var$_interopRequireDefault((parcelRequire("li861")));
function $9dd6a4c8a7c4deb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9dd6a4c8a7c4deb9$var$AppIcon = (props)=>/*#__PURE__*/ $9dd6a4c8a7c4deb9$var$_react.default.createElement($9dd6a4c8a7c4deb9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2.357 4.136 5-3a1.25 1.25 0 0 1 1.286 0l5 3c.377.226.607.633.607 1.072v5.584c0 .44-.23.846-.607 1.072l-5 3a1.25 1.25 0 0 1-1.286 0l-5-3a1.25 1.25 0 0 1-.607-1.072V5.208c0-.44.23-.846.607-1.072Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$9dd6a4c8a7c4deb9$var$AppIcon.displayName = 'AppIcon';
var $9dd6a4c8a7c4deb9$var$_default = module.exports.default = $9dd6a4c8a7c4deb9$var$AppIcon;

});


parcelRegister("4IX1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37090d922703c9e8$var$_react = $37090d922703c9e8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $37090d922703c9e8$var$_appSwitcher = $37090d922703c9e8$var$_interopRequireDefault((parcelRequire("4bym0")));
function $37090d922703c9e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $37090d922703c9e8$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $37090d922703c9e8$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
    }, props, {
        newIcon: $37090d922703c9e8$var$_appSwitcher.default
    }));
$37090d922703c9e8$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $37090d922703c9e8$var$_default = module.exports.default = $37090d922703c9e8$var$AppSwitcherIcon;

});
parcelRegister("4bym0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a5e285a3bba2a66c1485c62dcb0ecce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30c2d6793bc0d8b2$var$_react = $30c2d6793bc0d8b2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $30c2d6793bc0d8b2$var$_UNSAFE_baseNew = $30c2d6793bc0d8b2$var$_interopRequireDefault((parcelRequire("li861")));
function $30c2d6793bc0d8b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30c2d6793bc0d8b2$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $30c2d6793bc0d8b2$var$_react.default.createElement($30c2d6793bc0d8b2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25zm-8 8c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25z"/>`
    }, props));
$30c2d6793bc0d8b2$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $30c2d6793bc0d8b2$var$_default = module.exports.default = $30c2d6793bc0d8b2$var$AppSwitcherIcon;

});


parcelRegister("cxv9M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9210bc30f3b81033$var$_react = $9210bc30f3b81033$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");
function $9210bc30f3b81033$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9210bc30f3b81033$var$BillingIcon = (props)=>/*#__PURE__*/ $9210bc30f3b81033$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
    }, props));
$9210bc30f3b81033$var$BillingIcon.displayName = 'BillingIcon';
var $9210bc30f3b81033$var$_default = module.exports.default = $9210bc30f3b81033$var$BillingIcon;

});

parcelRegister("56VCK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b8a3633f0b3e99e$var$_react = $3b8a3633f0b3e99e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $3b8a3633f0b3e99e$var$_chevronDown = $3b8a3633f0b3e99e$var$_interopRequireDefault((parcelRequire("8iF3A")));
function $3b8a3633f0b3e99e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b8a3633f0b3e99e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $3b8a3633f0b3e99e$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $3b8a3633f0b3e99e$var$_chevronDown.default,
        iconType: "utility"
    }));
$3b8a3633f0b3e99e$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $3b8a3633f0b3e99e$var$_default = module.exports.default = $3b8a3633f0b3e99e$var$ChevronDownIcon;

});

parcelRegister("80wun", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d47867096e0a57b$var$_react = $5d47867096e0a57b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $5d47867096e0a57b$var$_chevronRight = $5d47867096e0a57b$var$_interopRequireDefault((parcelRequire("lxmMN")));
function $5d47867096e0a57b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5d47867096e0a57b$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $5d47867096e0a57b$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $5d47867096e0a57b$var$_chevronRight.default,
        iconType: "utility"
    }));
$5d47867096e0a57b$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $5d47867096e0a57b$var$_default = module.exports.default = $5d47867096e0a57b$var$ChevronRightIcon;

});
parcelRegister("lxmMN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9bfbdf898b5516a0a7c630d609b6042>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fade5ae01cfdf489$var$_react = $fade5ae01cfdf489$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $fade5ae01cfdf489$var$_UNSAFE_baseNew = $fade5ae01cfdf489$var$_interopRequireDefault((parcelRequire("li861")));
function $fade5ae01cfdf489$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fade5ae01cfdf489$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $fade5ae01cfdf489$var$_react.default.createElement($fade5ae01cfdf489$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: 'utility'
    }, props));
$fade5ae01cfdf489$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $fade5ae01cfdf489$var$_default = module.exports.default = $fade5ae01cfdf489$var$ChevronRightIcon;

});


parcelRegister("aQ2zk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e40c0d287a31387$var$_react = $7e40c0d287a31387$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $7e40c0d287a31387$var$_creditCard = $7e40c0d287a31387$var$_interopRequireDefault((parcelRequire("W8S5m")));
function $7e40c0d287a31387$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e40c0d287a31387$var$CreditcardFilledIcon = (props)=>/*#__PURE__*/ $7e40c0d287a31387$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 10.99h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM6.01 16h2v-2h-2zM21 8.99V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.99"/></svg>`
    }, props, {
        newIcon: $7e40c0d287a31387$var$_creditCard.default
    }));
$7e40c0d287a31387$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
var $7e40c0d287a31387$var$_default = module.exports.default = $7e40c0d287a31387$var$CreditcardFilledIcon;

});
parcelRegister("W8S5m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90dd9235cd3699dbed7874d76b759b8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aec4c8f03b36f1e$var$_react = $0aec4c8f03b36f1e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0aec4c8f03b36f1e$var$_UNSAFE_baseNew = $0aec4c8f03b36f1e$var$_interopRequireDefault((parcelRequire("li861")));
function $0aec4c8f03b36f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0aec4c8f03b36f1e$var$CreditCardIcon = (props)=>/*#__PURE__*/ $0aec4c8f03b36f1e$var$_react.default.createElement($0aec4c8f03b36f1e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 6.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.25m-14.5 0V4c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v2.25m-14.5 0h14.5m-2.25 4H9"/>`
    }, props));
$0aec4c8f03b36f1e$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $0aec4c8f03b36f1e$var$_default = module.exports.default = $0aec4c8f03b36f1e$var$CreditCardIcon;

});


parcelRegister("l4CRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5781e5c26ecb61b$var$_react = $f5781e5c26ecb61b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $f5781e5c26ecb61b$var$_dashboard = $f5781e5c26ecb61b$var$_interopRequireDefault((parcelRequire("9Anpu")));
function $f5781e5c26ecb61b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f5781e5c26ecb61b$var$DashboardIcon = (props)=>/*#__PURE__*/ $f5781e5c26ecb61b$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props, {
        newIcon: $f5781e5c26ecb61b$var$_dashboard.default
    }));
$f5781e5c26ecb61b$var$DashboardIcon.displayName = 'DashboardIcon';
var $f5781e5c26ecb61b$var$_default = module.exports.default = $f5781e5c26ecb61b$var$DashboardIcon;

});

parcelRegister("8qoI9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6223eb8dea459f6b$var$_react = $6223eb8dea459f6b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $6223eb8dea459f6b$var$_add = $6223eb8dea459f6b$var$_interopRequireDefault((parcelRequire("jUKjH")));
function $6223eb8dea459f6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6223eb8dea459f6b$var$EditorAddIcon = (props)=>/*#__PURE__*/ $6223eb8dea459f6b$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $6223eb8dea459f6b$var$_add.default
    }));
$6223eb8dea459f6b$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $6223eb8dea459f6b$var$_default = module.exports.default = $6223eb8dea459f6b$var$EditorAddIcon;

});
parcelRegister("jUKjH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28198ce9e0c3202094e2855b88c09086>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7f72cd7ef4a2008$var$_react = $e7f72cd7ef4a2008$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e7f72cd7ef4a2008$var$_UNSAFE_baseNew = $e7f72cd7ef4a2008$var$_interopRequireDefault((parcelRequire("li861")));
function $e7f72cd7ef4a2008$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7f72cd7ef4a2008$var$AddIcon = (props)=>/*#__PURE__*/ $e7f72cd7ef4a2008$var$_react.default.createElement($e7f72cd7ef4a2008$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
    }, props));
$e7f72cd7ef4a2008$var$AddIcon.displayName = 'AddIcon';
var $e7f72cd7ef4a2008$var$_default = module.exports.default = $e7f72cd7ef4a2008$var$AddIcon;

});


parcelRegister("9oDE0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d751b7f15a5e8f3$var$_react = $6d751b7f15a5e8f3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");
function $6d751b7f15a5e8f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d751b7f15a5e8f3$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $6d751b7f15a5e8f3$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$6d751b7f15a5e8f3$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $6d751b7f15a5e8f3$var$_default = module.exports.default = $6d751b7f15a5e8f3$var$EmojiAtlassianIcon;

});

parcelRegister("1uYEg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1177a3496bc3e1a5$var$_react = $1177a3496bc3e1a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $1177a3496bc3e1a5$var$_filter = $1177a3496bc3e1a5$var$_interopRequireDefault((parcelRequire("6tHS1")));
function $1177a3496bc3e1a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1177a3496bc3e1a5$var$FilterIcon = (props)=>/*#__PURE__*/ $1177a3496bc3e1a5$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $1177a3496bc3e1a5$var$_filter.default
    }));
$1177a3496bc3e1a5$var$FilterIcon.displayName = 'FilterIcon';
var $1177a3496bc3e1a5$var$_default = module.exports.default = $1177a3496bc3e1a5$var$FilterIcon;

});
parcelRegister("6tHS1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e33235fde7b24564b92256907cba586>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b777b37f691bd96$var$_react = $4b777b37f691bd96$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4b777b37f691bd96$var$_UNSAFE_baseNew = $4b777b37f691bd96$var$_interopRequireDefault((parcelRequire("li861")));
function $4b777b37f691bd96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b777b37f691bd96$var$FilterIcon = (props)=>/*#__PURE__*/ $4b777b37f691bd96$var$_react.default.createElement($4b777b37f691bd96$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
    }, props));
$4b777b37f691bd96$var$FilterIcon.displayName = 'FilterIcon';
var $4b777b37f691bd96$var$_default = module.exports.default = $4b777b37f691bd96$var$FilterIcon;

});


parcelRegister("484y5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $301b7016c5bafec3$var$_react = $301b7016c5bafec3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $301b7016c5bafec3$var$_folderClosed = $301b7016c5bafec3$var$_interopRequireDefault((parcelRequire("6PUCb")));
function $301b7016c5bafec3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $301b7016c5bafec3$var$FolderIcon = (props)=>/*#__PURE__*/ $301b7016c5bafec3$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $301b7016c5bafec3$var$_folderClosed.default
    }));
$301b7016c5bafec3$var$FolderIcon.displayName = 'FolderIcon';
var $301b7016c5bafec3$var$_default = module.exports.default = $301b7016c5bafec3$var$FolderIcon;

});
parcelRegister("6PUCb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d71c64ea47adf7a6a3a18ed2b2d7150>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fa36c0658e113d6$var$_react = $4fa36c0658e113d6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4fa36c0658e113d6$var$_UNSAFE_baseNew = $4fa36c0658e113d6$var$_interopRequireDefault((parcelRequire("li861")));
function $4fa36c0658e113d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4fa36c0658e113d6$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $4fa36c0658e113d6$var$_react.default.createElement($4fa36c0658e113d6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h3.25L8 3.5h5c.69 0 1.25.56 1.25 1.25v2m-12.5 0h12.5"/>`
    }, props));
$4fa36c0658e113d6$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $4fa36c0658e113d6$var$_default = module.exports.default = $4fa36c0658e113d6$var$FolderClosedIcon;

});


parcelRegister("k769W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea493d3be1d6973d$var$_react = $ea493d3be1d6973d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $ea493d3be1d6973d$var$_issues = $ea493d3be1d6973d$var$_interopRequireDefault((parcelRequire("3T0be")));
function $ea493d3be1d6973d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ea493d3be1d6973d$var$IssuesIcon = (props)=>/*#__PURE__*/ $ea493d3be1d6973d$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $ea493d3be1d6973d$var$_issues.default
    }));
$ea493d3be1d6973d$var$IssuesIcon.displayName = 'IssuesIcon';
var $ea493d3be1d6973d$var$_default = module.exports.default = $ea493d3be1d6973d$var$IssuesIcon;

});
parcelRegister("3T0be", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d33323342a8c0c4ced0e7d17cd24d31>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d46a5e8ae685aa2$var$_react = $2d46a5e8ae685aa2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2d46a5e8ae685aa2$var$_UNSAFE_baseNew = $2d46a5e8ae685aa2$var$_interopRequireDefault((parcelRequire("li861")));
function $2d46a5e8ae685aa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Issues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d46a5e8ae685aa2$var$IssuesIcon = (props)=>/*#__PURE__*/ $2d46a5e8ae685aa2$var$_react.default.createElement($2d46a5e8ae685aa2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.125 7 1.583 1.875 3.167-3.75M.75 10V4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M5 14.25h7.75a2.5 2.5 0 0 0 2.5-2.5V7"/>`
    }, props));
$2d46a5e8ae685aa2$var$IssuesIcon.displayName = 'IssuesIcon';
var $2d46a5e8ae685aa2$var$_default = module.exports.default = $2d46a5e8ae685aa2$var$IssuesIcon;

});


parcelRegister("i9cYU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0368d3257ae34a7f$var$_react = $0368d3257ae34a7f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $0368d3257ae34a7f$var$_showMoreHorizontal = $0368d3257ae34a7f$var$_interopRequireDefault((parcelRequire("6zj6G")));
function $0368d3257ae34a7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0368d3257ae34a7f$var$MoreIcon = (props)=>/*#__PURE__*/ $0368d3257ae34a7f$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $0368d3257ae34a7f$var$_showMoreHorizontal.default
    }));
$0368d3257ae34a7f$var$MoreIcon.displayName = 'MoreIcon';
var $0368d3257ae34a7f$var$_default = module.exports.default = $0368d3257ae34a7f$var$MoreIcon;

});
parcelRegister("6zj6G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b6fc123789ae26535b6e4ca13d1b4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c84d52e1daa0e40$var$_react = $4c84d52e1daa0e40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4c84d52e1daa0e40$var$_UNSAFE_baseNew = $4c84d52e1daa0e40$var$_interopRequireDefault((parcelRequire("li861")));
function $4c84d52e1daa0e40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c84d52e1daa0e40$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $4c84d52e1daa0e40$var$_react.default.createElement($4c84d52e1daa0e40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$4c84d52e1daa0e40$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $4c84d52e1daa0e40$var$_default = module.exports.default = $4c84d52e1daa0e40$var$ShowMoreHorizontalIcon;

});


parcelRegister("2eQxx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a15a4e589ba7f06$var$_react = $1a15a4e589ba7f06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $1a15a4e589ba7f06$var$_notification = $1a15a4e589ba7f06$var$_interopRequireDefault((parcelRequire("25Z5d")));
function $1a15a4e589ba7f06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a15a4e589ba7f06$var$NotificationIcon = (props)=>/*#__PURE__*/ $1a15a4e589ba7f06$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.49 17.67a2 2 0 0 0 2.83 0l-2.83-2.83a2 2 0 0 0 0 2.83m4.89-12.19-.72.73c-.78.78-2.21 1.81-3.21 2.31l-3.02 1.51c-.49.25-.58.77-.19 1.17l8.56 8.56c.4.4.92.31 1.17-.19l1.51-3.02c.49-.99 1.53-2.42 2.31-3.21l.73-.73a5.05 5.05 0 0 0 .64-6.36 1.01 1.01 0 1 0-1.35-1.49q-.04.04-.07.08A5.04 5.04 0 0 0 14.95 4a5.04 5.04 0 0 0-3.57 1.48"/></svg>`
    }, props, {
        newIcon: $1a15a4e589ba7f06$var$_notification.default
    }));
$1a15a4e589ba7f06$var$NotificationIcon.displayName = 'NotificationIcon';
var $1a15a4e589ba7f06$var$_default = module.exports.default = $1a15a4e589ba7f06$var$NotificationIcon;

});
parcelRegister("25Z5d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b08dd8b52bcbb9a433f2fc665f1c81b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $186b6e3f7f149df1$var$_react = $186b6e3f7f149df1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $186b6e3f7f149df1$var$_UNSAFE_baseNew = $186b6e3f7f149df1$var$_interopRequireDefault((parcelRequire("li861")));
function $186b6e3f7f149df1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $186b6e3f7f149df1$var$NotificationIcon = (props)=>/*#__PURE__*/ $186b6e3f7f149df1$var$_react.default.createElement($186b6e3f7f149df1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 12.75a2.5 2.5 0 0 1-5 0m6.75-4.114V5a4.25 4.25 0 0 0-8.5 0v3.636a.4.4 0 0 1-.06.21l-1.842 2.948a.625.625 0 0 0 .53.956h11.244c.491 0 .79-.54.53-.956l-1.841-2.947a.4.4 0 0 1-.061-.211Z"/>`
    }, props));
$186b6e3f7f149df1$var$NotificationIcon.displayName = 'NotificationIcon';
var $186b6e3f7f149df1$var$_default = module.exports.default = $186b6e3f7f149df1$var$NotificationIcon;

});


parcelRegister("6oyBv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a7fd392ccca7bc3$var$_react = $4a7fd392ccca7bc3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $4a7fd392ccca7bc3$var$_notification = $4a7fd392ccca7bc3$var$_interopRequireDefault((parcelRequire("25Z5d")));
function $4a7fd392ccca7bc3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4a7fd392ccca7bc3$var$NotificationDirectIcon = (props)=>/*#__PURE__*/ $4a7fd392ccca7bc3$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.59 17.83a2 2 0 0 0 2.83 0L6.59 15a2 2 0 0 0 0 2.83m4.79-12.35A5.04 5.04 0 0 1 14.95 4c.97 0 1.95.28 2.79.84q.03-.04.07-.07a1.01 1.01 0 1 1 1.35 1.49 5.05 5.05 0 0 1-.64 6.36l-.72.73c-.78.78-1.81 2.21-2.31 3.21l-1.51 3.02c-.25.5-.77.58-1.17.19l-8.56-8.55c-.4-.4-.31-.92.19-1.17l3.02-1.51c.99-.49 2.42-1.53 3.21-2.31zm2.74 9.63c.52-.97 1.57-2.4 2.35-3.18l.73-.73a3.05 3.05 0 0 0 .39-3.83c-.19-.29-.72-.77-.86-.86A3.04 3.04 0 0 0 15.05 6c-.8 0-1.57.31-2.16.89l-.95.95c-.78.79-2.22 1.82-3.2 2.31L7 11.02l6.07 6.07z"/></svg>`
    }, props, {
        newIcon: $4a7fd392ccca7bc3$var$_notification.default
    }));
$4a7fd392ccca7bc3$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
var $4a7fd392ccca7bc3$var$_default = module.exports.default = $4a7fd392ccca7bc3$var$NotificationDirectIcon;

});

parcelRegister("6K5uB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e8b4cb1a24a8233$var$_react = $4e8b4cb1a24a8233$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $4e8b4cb1a24a8233$var$_arrowUpRight = $4e8b4cb1a24a8233$var$_interopRequireDefault((parcelRequire("2Bovf")));
function $4e8b4cb1a24a8233$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4e8b4cb1a24a8233$var$OpenIcon = (props)=>/*#__PURE__*/ $4e8b4cb1a24a8233$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $4e8b4cb1a24a8233$var$_arrowUpRight.default
    }));
$4e8b4cb1a24a8233$var$OpenIcon.displayName = 'OpenIcon';
var $4e8b4cb1a24a8233$var$_default = module.exports.default = $4e8b4cb1a24a8233$var$OpenIcon;

});
parcelRegister("2Bovf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfe67a5a24a2dcfb0853d331aeb2068>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e520b45990e6cb0$var$_react = $1e520b45990e6cb0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1e520b45990e6cb0$var$_UNSAFE_baseNew = $1e520b45990e6cb0$var$_interopRequireDefault((parcelRequire("li861")));
function $1e520b45990e6cb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e520b45990e6cb0$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $1e520b45990e6cb0$var$_react.default.createElement($1e520b45990e6cb0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
    }, props));
$1e520b45990e6cb0$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $1e520b45990e6cb0$var$_default = module.exports.default = $1e520b45990e6cb0$var$ArrowUpRightIcon;

});


parcelRegister("9wrY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6eeccc471f7cff4c$var$_react = $6eeccc471f7cff4c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $6eeccc471f7cff4c$var$_person = $6eeccc471f7cff4c$var$_interopRequireDefault((parcelRequire("glBsg")));
function $6eeccc471f7cff4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6eeccc471f7cff4c$var$PersonIcon = (props)=>/*#__PURE__*/ $6eeccc471f7cff4c$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $6eeccc471f7cff4c$var$_person.default
    }));
$6eeccc471f7cff4c$var$PersonIcon.displayName = 'PersonIcon';
var $6eeccc471f7cff4c$var$_default = module.exports.default = $6eeccc471f7cff4c$var$PersonIcon;

});
parcelRegister("glBsg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42f87835acc0152c23ae77c3bbeeba86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be6ba94149c08df1$var$_react = $be6ba94149c08df1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $be6ba94149c08df1$var$_UNSAFE_baseNew = $be6ba94149c08df1$var$_interopRequireDefault((parcelRequire("li861")));
function $be6ba94149c08df1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be6ba94149c08df1$var$PersonIcon = (props)=>/*#__PURE__*/ $be6ba94149c08df1$var$_react.default.createElement($be6ba94149c08df1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$be6ba94149c08df1$var$PersonIcon.displayName = 'PersonIcon';
var $be6ba94149c08df1$var$_default = module.exports.default = $be6ba94149c08df1$var$PersonIcon;

});


parcelRegister("byd98", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $868d114301a7e1cf$var$_react = $868d114301a7e1cf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $868d114301a7e1cf$var$_personAvatar = $868d114301a7e1cf$var$_interopRequireDefault((parcelRequire("7Vh1m")));
function $868d114301a7e1cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $868d114301a7e1cf$var$PersonCircleIcon = (props)=>/*#__PURE__*/ $868d114301a7e1cf$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
    }, props, {
        newIcon: $868d114301a7e1cf$var$_personAvatar.default
    }));
$868d114301a7e1cf$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
var $868d114301a7e1cf$var$_default = module.exports.default = $868d114301a7e1cf$var$PersonCircleIcon;

});
parcelRegister("7Vh1m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::085a012077682a1c0cc5fd98214b2dfc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c4b0f488c5f2381$var$_react = $5c4b0f488c5f2381$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5c4b0f488c5f2381$var$_UNSAFE_baseNew = $5c4b0f488c5f2381$var$_interopRequireDefault((parcelRequire("li861")));
function $5c4b0f488c5f2381$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c4b0f488c5f2381$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $5c4b0f488c5f2381$var$_react.default.createElement($5c4b0f488c5f2381$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 14.35v-.6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v.6m-.75-7.85a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z"/>`
    }, props));
$5c4b0f488c5f2381$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $5c4b0f488c5f2381$var$_default = module.exports.default = $5c4b0f488c5f2381$var$PersonAvatarIcon;

});


parcelRegister("dOf61", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0dba7a3eac90ad0$var$_react = $a0dba7a3eac90ad0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $a0dba7a3eac90ad0$var$_premium = $a0dba7a3eac90ad0$var$_interopRequireDefault((parcelRequire("1AI78")));
function $a0dba7a3eac90ad0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a0dba7a3eac90ad0$var$PremiumIcon = (props)=>/*#__PURE__*/ $a0dba7a3eac90ad0$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $a0dba7a3eac90ad0$var$_premium.default
    }));
$a0dba7a3eac90ad0$var$PremiumIcon.displayName = 'PremiumIcon';
var $a0dba7a3eac90ad0$var$_default = module.exports.default = $a0dba7a3eac90ad0$var$PremiumIcon;

});
parcelRegister("1AI78", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fda8823cfd2fa0698a55b39e4d174063>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $128b5f604e741634$var$_react = $128b5f604e741634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $128b5f604e741634$var$_UNSAFE_baseNew = $128b5f604e741634$var$_interopRequireDefault((parcelRequire("li861")));
function $128b5f604e741634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $128b5f604e741634$var$PremiumIcon = (props)=>/*#__PURE__*/ $128b5f604e741634$var$_react.default.createElement($128b5f604e741634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 13.75h2.25m0 0H16m-2.25 0V11.5m0 2.25V16M0 2.25h2.25m0 0H4.5m-2.25 0V0m0 2.25V4.5M8 1.75l1.75 4.5L14.25 8l-4.5 1.75L8 14.25l-1.75-4.5L1.75 8l4.5-1.75z"/>`
    }, props));
$128b5f604e741634$var$PremiumIcon.displayName = 'PremiumIcon';
var $128b5f604e741634$var$_default = module.exports.default = $128b5f604e741634$var$PremiumIcon;

});


parcelRegister("69vGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47ac298dde136c19$var$_react = $47ac298dde136c19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $47ac298dde136c19$var$_questionCircle = $47ac298dde136c19$var$_interopRequireDefault((parcelRequire("kHnBx")));
function $47ac298dde136c19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47ac298dde136c19$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $47ac298dde136c19$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $47ac298dde136c19$var$_questionCircle.default
    }));
$47ac298dde136c19$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $47ac298dde136c19$var$_default = module.exports.default = $47ac298dde136c19$var$QuestionCircleIcon;

});
parcelRegister("kHnBx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10497e41582acb6b3539681c38bd8368>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11a2224de2d8e65$var$_react = $f11a2224de2d8e65$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f11a2224de2d8e65$var$_UNSAFE_baseNew = $f11a2224de2d8e65$var$_interopRequireDefault((parcelRequire("li861")));
function $f11a2224de2d8e65$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11a2224de2d8e65$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $f11a2224de2d8e65$var$_react.default.createElement($f11a2224de2d8e65$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f11a2224de2d8e65$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $f11a2224de2d8e65$var$_default = module.exports.default = $f11a2224de2d8e65$var$QuestionCircleIcon;

});


parcelRegister("kTjV6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f358656c1010502e$var$_react = $f358656c1010502e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $f358656c1010502e$var$_clock = $f358656c1010502e$var$_interopRequireDefault((parcelRequire("8zsvu")));
function $f358656c1010502e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f358656c1010502e$var$RecentIcon = (props)=>/*#__PURE__*/ $f358656c1010502e$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
    }, props, {
        newIcon: $f358656c1010502e$var$_clock.default
    }));
$f358656c1010502e$var$RecentIcon.displayName = 'RecentIcon';
var $f358656c1010502e$var$_default = module.exports.default = $f358656c1010502e$var$RecentIcon;

});
parcelRegister("8zsvu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a48a035a6b6ee27b8a00a2b1992b2cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63d7b47a2d508e8c$var$_react = $63d7b47a2d508e8c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $63d7b47a2d508e8c$var$_UNSAFE_baseNew = $63d7b47a2d508e8c$var$_interopRequireDefault((parcelRequire("li861")));
function $63d7b47a2d508e8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63d7b47a2d508e8c$var$ClockIcon = (props)=>/*#__PURE__*/ $63d7b47a2d508e8c$var$_react.default.createElement($63d7b47a2d508e8c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$63d7b47a2d508e8c$var$ClockIcon.displayName = 'ClockIcon';
var $63d7b47a2d508e8c$var$_default = module.exports.default = $63d7b47a2d508e8c$var$ClockIcon;

});


parcelRegister("9Oep5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7243f4d367cade00$var$_react = $7243f4d367cade00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $7243f4d367cade00$var$_screen = $7243f4d367cade00$var$_interopRequireDefault((parcelRequire("5rt9V")));
function $7243f4d367cade00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7243f4d367cade00$var$ScreenIcon = (props)=>/*#__PURE__*/ $7243f4d367cade00$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 13.991zM5 14h14V6H5z"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5v.5H9z"/></g></svg>`
    }, props, {
        newIcon: $7243f4d367cade00$var$_screen.default
    }));
$7243f4d367cade00$var$ScreenIcon.displayName = 'ScreenIcon';
var $7243f4d367cade00$var$_default = module.exports.default = $7243f4d367cade00$var$ScreenIcon;

});
parcelRegister("5rt9V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0406c16c1547ca6882af6f1f2ad852ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f6617bddb904564$var$_react = $3f6617bddb904564$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3f6617bddb904564$var$_UNSAFE_baseNew = $3f6617bddb904564$var$_interopRequireDefault((parcelRequire("li861")));
function $3f6617bddb904564$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f6617bddb904564$var$ScreenIcon = (props)=>/*#__PURE__*/ $3f6617bddb904564$var$_react.default.createElement($3f6617bddb904564$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 11.25h5c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25zm0 0v3m0 0h4m-4 0H4"/>`
    }, props));
$3f6617bddb904564$var$ScreenIcon.displayName = 'ScreenIcon';
var $3f6617bddb904564$var$_default = module.exports.default = $3f6617bddb904564$var$ScreenIcon;

});


parcelRegister("lKhtB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd4b73520b461c85$var$_react = $fd4b73520b461c85$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $fd4b73520b461c85$var$_search = $fd4b73520b461c85$var$_interopRequireDefault((parcelRequire("fU1uL")));
function $fd4b73520b461c85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd4b73520b461c85$var$SearchIcon = (props)=>/*#__PURE__*/ $fd4b73520b461c85$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $fd4b73520b461c85$var$_search.default
    }));
$fd4b73520b461c85$var$SearchIcon.displayName = 'SearchIcon';
var $fd4b73520b461c85$var$_default = module.exports.default = $fd4b73520b461c85$var$SearchIcon;

});
parcelRegister("fU1uL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaf30f230bb1e005401a7fdb410093c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b93d3ee1700581ad$var$_react = $b93d3ee1700581ad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b93d3ee1700581ad$var$_UNSAFE_baseNew = $b93d3ee1700581ad$var$_interopRequireDefault((parcelRequire("li861")));
function $b93d3ee1700581ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b93d3ee1700581ad$var$SearchIcon = (props)=>/*#__PURE__*/ $b93d3ee1700581ad$var$_react.default.createElement($b93d3ee1700581ad$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$b93d3ee1700581ad$var$SearchIcon.displayName = 'SearchIcon';
var $b93d3ee1700581ad$var$_default = module.exports.default = $b93d3ee1700581ad$var$SearchIcon;

});


parcelRegister("30Nbq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $231785f6a446d58e$var$_react = $231785f6a446d58e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $231785f6a446d58e$var$_settings = $231785f6a446d58e$var$_interopRequireDefault((parcelRequire("jAH7O")));
function $231785f6a446d58e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $231785f6a446d58e$var$SettingsIcon = (props)=>/*#__PURE__*/ $231785f6a446d58e$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $231785f6a446d58e$var$_settings.default
    }));
$231785f6a446d58e$var$SettingsIcon.displayName = 'SettingsIcon';
var $231785f6a446d58e$var$_default = module.exports.default = $231785f6a446d58e$var$SettingsIcon;

});
parcelRegister("jAH7O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c415ea6f37a3ed0eb78bc36e015407f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e432d4d622a5e05c$var$_react = $e432d4d622a5e05c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e432d4d622a5e05c$var$_UNSAFE_baseNew = $e432d4d622a5e05c$var$_interopRequireDefault((parcelRequire("li861")));
function $e432d4d622a5e05c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e432d4d622a5e05c$var$SettingsIcon = (props)=>/*#__PURE__*/ $e432d4d622a5e05c$var$_react.default.createElement($e432d4d622a5e05c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$e432d4d622a5e05c$var$SettingsIcon.displayName = 'SettingsIcon';
var $e432d4d622a5e05c$var$_default = module.exports.default = $e432d4d622a5e05c$var$SettingsIcon;

});


parcelRegister("aOoYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7df1f3698fb00e3a$var$_react = $7df1f3698fb00e3a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $7df1f3698fb00e3a$var$_release = $7df1f3698fb00e3a$var$_interopRequireDefault((parcelRequire("gQU84")));
function $7df1f3698fb00e3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7df1f3698fb00e3a$var$ShipIcon = (props)=>/*#__PURE__*/ $7df1f3698fb00e3a$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $7df1f3698fb00e3a$var$_release.default
    }));
$7df1f3698fb00e3a$var$ShipIcon.displayName = 'ShipIcon';
var $7df1f3698fb00e3a$var$_default = module.exports.default = $7df1f3698fb00e3a$var$ShipIcon;

});
parcelRegister("gQU84", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c0c10c2d3ba3d5e3f27d382fa244bae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c44d0ac414ce0628$var$_react = $c44d0ac414ce0628$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c44d0ac414ce0628$var$_UNSAFE_baseNew = $c44d0ac414ce0628$var$_interopRequireDefault((parcelRequire("li861")));
function $c44d0ac414ce0628$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c44d0ac414ce0628$var$ReleaseIcon = (props)=>/*#__PURE__*/ $c44d0ac414ce0628$var$_react.default.createElement($c44d0ac414ce0628$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$c44d0ac414ce0628$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $c44d0ac414ce0628$var$_default = module.exports.default = $c44d0ac414ce0628$var$ReleaseIcon;

});


parcelRegister("irnzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6cd08e60142bc81$var$_react = $d6cd08e60142bc81$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $d6cd08e60142bc81$var$_linkExternal = $d6cd08e60142bc81$var$_interopRequireDefault((parcelRequire("jqhBH")));
function $d6cd08e60142bc81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d6cd08e60142bc81$var$ShortcutIcon = (props)=>/*#__PURE__*/ $d6cd08e60142bc81$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $d6cd08e60142bc81$var$_linkExternal.default
    }));
$d6cd08e60142bc81$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $d6cd08e60142bc81$var$_default = module.exports.default = $d6cd08e60142bc81$var$ShortcutIcon;

});
parcelRegister("jqhBH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79997d69990d173364910f60504b3516>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e23e1a6cafcdc4d9$var$_react = $e23e1a6cafcdc4d9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e23e1a6cafcdc4d9$var$_UNSAFE_baseNew = $e23e1a6cafcdc4d9$var$_interopRequireDefault((parcelRequire("li861")));
function $e23e1a6cafcdc4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e23e1a6cafcdc4d9$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $e23e1a6cafcdc4d9$var$_react.default.createElement($e23e1a6cafcdc4d9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
    }, props));
$e23e1a6cafcdc4d9$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $e23e1a6cafcdc4d9$var$_default = module.exports.default = $e23e1a6cafcdc4d9$var$LinkExternalIcon;

});


parcelRegister("keMWK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebbb153b62bb46e4$var$_react = $ebbb153b62bb46e4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $ebbb153b62bb46e4$var$_logIn = $ebbb153b62bb46e4$var$_interopRequireDefault((parcelRequire("llvOl")));
function $ebbb153b62bb46e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ebbb153b62bb46e4$var$SignInIcon = (props)=>/*#__PURE__*/ $ebbb153b62bb46e4$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0 0 19.006 3z"/><path d="M3.977 11A.99.99 0 0 0 3 12.001c0 .551.437.999.977.999h11.047a.99.99 0 0 0 .976-.999.99.99 0 0 0-.976-1.001z"/><path d="M12.303 8.305a1.053 1.053 0 0 0 0 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 0 0 0 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 0 0 0-1.477l-2.93-2.956a1.034 1.034 0 0 0-1.465 0"/></g></svg>`
    }, props, {
        newIcon: $ebbb153b62bb46e4$var$_logIn.default
    }));
$ebbb153b62bb46e4$var$SignInIcon.displayName = 'SignInIcon';
var $ebbb153b62bb46e4$var$_default = module.exports.default = $ebbb153b62bb46e4$var$SignInIcon;

});
parcelRegister("llvOl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::858dc54045c24a650b3b081a4f812418>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8a43c1fa42ae002$var$_react = $f8a43c1fa42ae002$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f8a43c1fa42ae002$var$_UNSAFE_baseNew = $f8a43c1fa42ae002$var$_interopRequireDefault((parcelRequire("li861")));
function $f8a43c1fa42ae002$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8a43c1fa42ae002$var$LogInIcon = (props)=>/*#__PURE__*/ $f8a43c1fa42ae002$var$_react.default.createElement($f8a43c1fa42ae002$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75h5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H8M5.75 4.5 9.25 8m0 0-3.5 3.5M9.25 8H1"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 4.5 9.25 8l-3.5 3.5"/>`
    }, props));
$f8a43c1fa42ae002$var$LogInIcon.displayName = 'LogInIcon';
var $f8a43c1fa42ae002$var$_default = module.exports.default = $f8a43c1fa42ae002$var$LogInIcon;

});


parcelRegister("9FF03", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70a7bf189b5e05e3$var$_react = $70a7bf189b5e05e3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $70a7bf189b5e05e3$var$_starUnstarred = $70a7bf189b5e05e3$var$_interopRequireDefault((parcelRequire("4OWUk")));
function $70a7bf189b5e05e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $70a7bf189b5e05e3$var$StarIcon = (props)=>/*#__PURE__*/ $70a7bf189b5e05e3$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $70a7bf189b5e05e3$var$_starUnstarred.default
    }));
$70a7bf189b5e05e3$var$StarIcon.displayName = 'StarIcon';
var $70a7bf189b5e05e3$var$_default = module.exports.default = $70a7bf189b5e05e3$var$StarIcon;

});
parcelRegister("4OWUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d7759306dd75de9f8738c35cafb7b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $382986c377e8ae89$var$_react = $382986c377e8ae89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $382986c377e8ae89$var$_UNSAFE_baseNew = $382986c377e8ae89$var$_interopRequireDefault((parcelRequire("li861")));
function $382986c377e8ae89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $382986c377e8ae89$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $382986c377e8ae89$var$_react.default.createElement($382986c377e8ae89$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
    }, props));
$382986c377e8ae89$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $382986c377e8ae89$var$_default = module.exports.default = $382986c377e8ae89$var$StarUnstarredIcon;

});


parcelRegister("c5E0Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cd4fd59db758ee5$var$_react = $8cd4fd59db758ee5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $8cd4fd59db758ee5$var$_starStarred = $8cd4fd59db758ee5$var$_interopRequireDefault((parcelRequire("bNK2y")));
function $8cd4fd59db758ee5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8cd4fd59db758ee5$var$StarFilledIcon = (props)=>/*#__PURE__*/ $8cd4fd59db758ee5$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $8cd4fd59db758ee5$var$_starStarred.default
    }));
$8cd4fd59db758ee5$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $8cd4fd59db758ee5$var$_default = module.exports.default = $8cd4fd59db758ee5$var$StarFilledIcon;

});
parcelRegister("bNK2y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84516badc93a96e757d14d99cc61886d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8977fbeb2af563b2$var$_react = $8977fbeb2af563b2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8977fbeb2af563b2$var$_UNSAFE_baseNew = $8977fbeb2af563b2$var$_interopRequireDefault((parcelRequire("li861")));
function $8977fbeb2af563b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8977fbeb2af563b2$var$StarStarredIcon = (props)=>/*#__PURE__*/ $8977fbeb2af563b2$var$_react.default.createElement($8977fbeb2af563b2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$8977fbeb2af563b2$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $8977fbeb2af563b2$var$_default = module.exports.default = $8977fbeb2af563b2$var$StarStarredIcon;

});


parcelRegister("avNbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a72f326d57d2bbe$var$_react = $7a72f326d57d2bbe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $59EHd = parcelRequire("59EHd");

var $7a72f326d57d2bbe$var$_warning = $7a72f326d57d2bbe$var$_interopRequireDefault((parcelRequire("dCK5y")));
function $7a72f326d57d2bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72f326d57d2bbe$var$WarningIcon = (props)=>/*#__PURE__*/ $7a72f326d57d2bbe$var$_react.default.createElement($59EHd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $7a72f326d57d2bbe$var$_warning.default
    }));
$7a72f326d57d2bbe$var$WarningIcon.displayName = 'WarningIcon';
var $7a72f326d57d2bbe$var$_default = module.exports.default = $7a72f326d57d2bbe$var$WarningIcon;

});
parcelRegister("dCK5y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9ea8e93d14ecb2cc0f36d0ba6200033>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9eb293310babe444$var$_react = $9eb293310babe444$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9eb293310babe444$var$_UNSAFE_baseNew = $9eb293310babe444$var$_interopRequireDefault((parcelRequire("li861")));
function $9eb293310babe444$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9eb293310babe444$var$WarningIcon = (props)=>/*#__PURE__*/ $9eb293310babe444$var$_react.default.createElement($9eb293310babe444$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$9eb293310babe444$var$WarningIcon.displayName = 'WarningIcon';
var $9eb293310babe444$var$_default = module.exports.default = $9eb293310babe444$var$WarningIcon;

});


parcelRegister("cgk27", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $30c91d47ab231e45$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fzIfb = parcelRequire("fzIfb");

var $1ytqa = parcelRequire("1ytqa");
const $30c91d47ab231e45$var$headerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $1ytqa.padding),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlockEnd: `${(0, $1ytqa.padding) - (0, $1ytqa.keylineHeight)}px`
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $30c91d47ab231e45$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $fzIfb.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $30c91d47ab231e45$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $30c91d47ab231e45$export$2e2bcd8739ae039 = $30c91d47ab231e45$var$ModalHeader;

});
parcelRegister("fzIfb", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $d3a3e9bb7348c97f$export$33ffd74ebf07f060);

var $eUqFw = parcelRequire("eUqFw");

var $lsGmf = parcelRequire("lsGmf");
const $d3a3e9bb7348c97f$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $eUqFw.useContext)((0, $lsGmf.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("lsGmf", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $0097f2bccd8babab$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $0097f2bccd8babab$export$dece24112a937f92);

var $eUqFw = parcelRequire("eUqFw");
const $0097f2bccd8babab$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $0097f2bccd8babab$export$dece24112a937f92 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});


parcelRegister("1ytqa", function(module, exports) {

$parcel$export(module.exports, "width", () => $e34bd0541420d45e$export$7e3df82ee760448c);
$parcel$export(module.exports, "gutter", () => $e34bd0541420d45e$export$f2b922cb4a245974);
$parcel$export(module.exports, "borderRadius", () => $e34bd0541420d45e$export$7a57f79000377ca2);
$parcel$export(module.exports, "verticalOffset", () => $e34bd0541420d45e$export$9212741279b5f103);
$parcel$export(module.exports, "padding", () => $e34bd0541420d45e$export$6f98e8eaf0be1996);
$parcel$export(module.exports, "keylineHeight", () => $e34bd0541420d45e$export$4c317248f944c2a9);
$parcel$export(module.exports, "keylineColor", () => $e34bd0541420d45e$export$d901150a4cc83165);
$parcel$export(module.exports, "textColor", () => $e34bd0541420d45e$export$32f78bffcd82ff28);
$parcel$export(module.exports, "iconColor", () => $e34bd0541420d45e$export$3797a580396e3639);


var $3kxa0 = parcelRequire("3kxa0");
const $e34bd0541420d45e$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
const $e34bd0541420d45e$export$f2b922cb4a245974 = 60;
const $e34bd0541420d45e$var$gridSize = (0, $3kxa0.gridSize)();
const $e34bd0541420d45e$export$7a57f79000377ca2 = (0, $3kxa0.borderRadius)();
const $e34bd0541420d45e$export$9212741279b5f103 = $e34bd0541420d45e$var$gridSize * 2;
const $e34bd0541420d45e$export$6f98e8eaf0be1996 = $e34bd0541420d45e$var$gridSize * 3;
const $e34bd0541420d45e$export$4c317248f944c2a9 = 2;
const $e34bd0541420d45e$export$d901150a4cc83165 = `var(--ds-border, ${(0, $753dd713deeb1c87$export$3e51e8f1440314ba)})`;
const $e34bd0541420d45e$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $753dd713deeb1c87$export$fbda843f0a27fe96)})`;
const $e34bd0541420d45e$export$3797a580396e3639 = {
    danger: `var(--ds-icon-danger, ${(0, $753dd713deeb1c87$export$2010d0fb4295b346)})`,
    warning: "var(--ds-icon-warning, #D97008)"
};

});


parcelRegister("h7KeD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $07ab3f31d12a2de5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $txxpD = parcelRequire("txxpD");

var $k86HL = parcelRequire("k86HL");

var $fzIfb = parcelRequire("fzIfb");

var $1ytqa = parcelRequire("1ytqa");
function $07ab3f31d12a2de5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07ab3f31d12a2de5$var$titleStyles = {
    name: "1yaejj3",
    styles: "display:flex;min-width:0;margin:var(--ds-space-0, 0px);gap:var(--ds-space-100, 8px);font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $07ab3f31d12a2de5$var$textStyles = {
    name: "1k30s2j",
    styles: "min-width:0;flex:1 1 auto;word-wrap:break-word"
};
const $07ab3f31d12a2de5$var$iconStyles = {
    name: "1cdsq8b",
    styles: "flex:0 0 auto;color:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit"
};
const $07ab3f31d12a2de5$var$truncatedTextStyles = {
    name: "1h52dri",
    styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $07ab3f31d12a2de5$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($txxpD))) : (0, (/*@__PURE__*/$parcel$interopDefault($k86HL)));
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $07ab3f31d12a2de5$var$iconStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        label: appearance,
        color: (0, $1ytqa.iconColor)[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $07ab3f31d12a2de5$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $fzIfb.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: $07ab3f31d12a2de5$var$titleStyles,
        "data-testid": testId
    }, appearance && /*#__PURE__*/ (0, $byn9U.jsx)($07ab3f31d12a2de5$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: titleId,
        css: [
            $07ab3f31d12a2de5$var$textStyles,
            !isMultiline && $07ab3f31d12a2de5$var$truncatedTextStyles
        ],
        "data-testid": testId && `${testId}-text`
    }, children));
};
var $07ab3f31d12a2de5$export$2e2bcd8739ae039 = $07ab3f31d12a2de5$var$ModalTitle;

});
parcelRegister("txxpD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbfae93167a25d090a93adb983df0b8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $058cb97a6d3f31ae$var$_react = $058cb97a6d3f31ae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $058cb97a6d3f31ae$var$_error = $058cb97a6d3f31ae$var$_interopRequireDefault((parcelRequire("4a9V1")));

var $058cb97a6d3f31ae$var$_error2 = $058cb97a6d3f31ae$var$_interopRequireDefault((parcelRequire("gmIql")));
function $058cb97a6d3f31ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $058cb97a6d3f31ae$var$ErrorIcon = (props)=>/*#__PURE__*/ $058cb97a6d3f31ae$var$_react.default.createElement($058cb97a6d3f31ae$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $058cb97a6d3f31ae$var$_error2.default
    }, props));
$058cb97a6d3f31ae$var$ErrorIcon.Name = 'ErrorIconMigration';
var $058cb97a6d3f31ae$var$_default = module.exports.default = $058cb97a6d3f31ae$var$ErrorIcon;

});

parcelRegister("k86HL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32c0f9819dce5465c87b82feabadd917>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea79c17143900906$var$_react = $ea79c17143900906$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ea79c17143900906$var$_warning = $ea79c17143900906$var$_interopRequireDefault((parcelRequire("dCK5y")));

var $ea79c17143900906$var$_warning2 = $ea79c17143900906$var$_interopRequireDefault((parcelRequire("avNbl")));
function $ea79c17143900906$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ea79c17143900906$var$WarningIcon = (props)=>/*#__PURE__*/ $ea79c17143900906$var$_react.default.createElement($ea79c17143900906$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $ea79c17143900906$var$_warning2.default
    }, props));
$ea79c17143900906$var$WarningIcon.Name = 'WarningIconMigration';
var $ea79c17143900906$var$_default = module.exports.default = $ea79c17143900906$var$WarningIcon;

});


parcelRegister("kYurV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fd5f8e1c1a61ec98$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8MHxr = parcelRequire("8MHxr");

var $fzIfb = parcelRequire("fzIfb");

var $cjy2C = parcelRequire("cjy2C");

var $1ytqa = parcelRequire("1ytqa");

var $jkK0U = parcelRequire("jkK0U");
function $fd5f8e1c1a61ec98$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fd5f8e1c1a61ec98$var$bodyStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer.
 */ const $fd5f8e1c1a61ec98$var$bodyScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $1ytqa.keylineHeight)}px ${(0, $1ytqa.padding)}px`
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ const $fd5f8e1c1a61ec98$var$viewportScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0px ${(0, $1ytqa.padding)}px`
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $fd5f8e1c1a61ec98$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $fzIfb.useModal)();
    const shouldScrollInViewport = (0, $jkK0U.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fd5f8e1c1a61ec98$var$bodyStyles,
            $fd5f8e1c1a61ec98$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8MHxr.TouchScrollable), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cjy2C.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fd5f8e1c1a61ec98$var$bodyStyles,
            $fd5f8e1c1a61ec98$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $fd5f8e1c1a61ec98$export$2e2bcd8739ae039 = $fd5f8e1c1a61ec98$var$ModalBody;

});
parcelRegister("cjy2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc4b2bdacf920d4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $8yx6O = parcelRequire("8yx6O");

var $eOjAl = parcelRequire("eOjAl");

var $hWhcQ = parcelRequire("hWhcQ");

var $cEdk8 = parcelRequire("cEdk8");

var $dK551 = parcelRequire("dK551");

var $5IVbS = parcelRequire("5IVbS");

var $jUY0r = parcelRequire("jUY0r");

var $1ytqa = parcelRequire("1ytqa");
const $4dc4b2bdacf920d4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    [(0, $jUY0r.media).above.xs]: {
        height: 'unset',
        overflowY: 'auto'
    }
});
const $4dc4b2bdacf920d4$var$topKeylineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockStart: `${(0, $1ytqa.keylineHeight)}px solid ${(0, $1ytqa.keylineColor)}`
});
const $4dc4b2bdacf920d4$var$bottomKeylineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `${(0, $1ytqa.keylineHeight)}px solid ${(0, $1ytqa.keylineColor)}`
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $4dc4b2bdacf920d4$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { testId: testId, children: children } = props;
    const [hasSiblings, setSiblings] = (0, $dK551.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eUqFw.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const setLazySiblings = (0, $cEdk8.default)(setSiblings);
    const setLazyContentFocus = (0, $cEdk8.default)((0, $8yx6O.default)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $cEdk8.default)((0, $8yx6O.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $1ytqa.keylineHeight));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $1ytqa.keylineHeight));
        }
    }));
    (0, $eUqFw.useEffect)(()=>{
        const target = scrollableRef.current;
        const unbindWindowEvent = (0, $74BVL.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $74BVL.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $hWhcQ.default);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $5IVbS.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && `${testId}--scrollable`,
        ref: (0, $eOjAl.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $4dc4b2bdacf920d4$var$baseStyles,
            showTopKeyline && $4dc4b2bdacf920d4$var$topKeylineStyles,
            showBottomKeyline && $4dc4b2bdacf920d4$var$bottomKeylineStyles
        ]
    }, children));
});
$4dc4b2bdacf920d4$var$ScrollContainer.displayName = 'ScrollContainer';
var $4dc4b2bdacf920d4$export$2e2bcd8739ae039 = $4dc4b2bdacf920d4$var$ScrollContainer;

});
parcelRegister("eOjAl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0383701aeb4c586a$export$2e2bcd8739ae039);
function $0383701aeb4c586a$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("cEdk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da870f29469550b$export$2e2bcd8739ae039);

var $i2VJB = parcelRequire("i2VJB");
function $9da870f29469550b$export$2e2bcd8739ae039(callback) {
    const ref = (0, $i2VJB.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("i2VJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2860f219d51266$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $5e2860f219d51266$var$uniqueReferencedValue = {};
function $5e2860f219d51266$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $eUqFw.useRef)($5e2860f219d51266$var$uniqueReferencedValue);
    if (ref.current === $5e2860f219d51266$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("dK551", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d60fc4637ed541$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $d8d60fc4637ed541$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $eUqFw.useState)(initialState);
    const valueRef = (0, $eUqFw.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

parcelRegister("jUY0r", function(module, exports) {

$parcel$export(module.exports, "media", () => $eec5a77607b32553$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $eec5a77607b32553$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $eec5a77607b32553$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
const $eec5a77607b32553$export$c881183ca713c214 = $eec5a77607b32553$export$987d49ffe1b0900f;

});


parcelRegister("jkK0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $52f727252da32f45$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lsGmf = parcelRequire("lsGmf");
function $52f727252da32f45$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $eUqFw.useContext)((0, $lsGmf.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("1YWwa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $59b7f48703aff43f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $fzIfb = parcelRequire("fzIfb");

var $1ytqa = parcelRequire("1ytqa");
const $59b7f48703aff43f$var$footerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $1ytqa.padding),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlockStart: `${(0, $1ytqa.padding) - (0, $1ytqa.keylineHeight)}px`
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $59b7f48703aff43f$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $fzIfb.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $59b7f48703aff43f$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $59b7f48703aff43f$export$2e2bcd8739ae039 = $59b7f48703aff43f$var$ModalFooter;

});

parcelRegister("9cyqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d6044468b4af6c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $gbzDZ = parcelRequire("gbzDZ");

var $hWhcQ = parcelRequire("hWhcQ");

var $7ZqNL = parcelRequire("7ZqNL");

var $jmXuS = parcelRequire("jmXuS");

var $9XUBW = parcelRequire("9XUBW");
var $k1zM2 = parcelRequire("k1zM2");

var $bRlz7 = parcelRequire("bRlz7");

var $3jZPB = parcelRequire("3jZPB");

var $kEVkJ = parcelRequire("kEVkJ");

var $3kxa0 = parcelRequire("3kxa0");

var $eYg2Z = parcelRequire("eYg2Z");

var $frgV8 = parcelRequire("frgV8");

var $b1UIz = parcelRequire("b1UIz");

var $1Q3rv = parcelRequire("1Q3rv");

var $3Ld1j = parcelRequire("3Ld1j");
const $93d6044468b4af6c$var$tooltipZIndex = (0, $3kxa0.layers).tooltip();
const $93d6044468b4af6c$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $93d6044468b4af6c$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $93d6044468b4af6c$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $93d6044468b4af6c$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $1Q3rv.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $hWhcQ.default), onHide: onHide = (0, $hWhcQ.default), hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $gbzDZ.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$93d6044468b4af6c$var$analyticsAttributes
    });
    const onHideHandler = (0, $gbzDZ.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$93d6044468b4af6c$var$analyticsAttributes
    });
    const apiRef = (0, $eUqFw.useRef)(null);
    const [state, setState] = (0, $eUqFw.useState)('hide');
    const targetRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $eUqFw.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const lastState = (0, $eUqFw.useRef)(state);
    const lastDelay = (0, $eUqFw.useRef)(delay);
    const lastHandlers = (0, $eUqFw.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    const hasCalledShowHandler = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    const start = (0, $eUqFw.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $eUqFw.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, []);
    const abort = (0, $eUqFw.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $eUqFw.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $eYg2Z.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const showTooltip = (0, $eUqFw.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        const entry = {
            source: source,
            delay: lastDelay.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $frgV8.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    const hideTooltipOnEsc = (0, $eUqFw.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $7ZqNL.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (state === 'hide') return 0, $hWhcQ.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $74BVL.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $eUqFw.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $3Ld1j.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $eUqFw.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $3Ld1j.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $eUqFw.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showTooltip({
            type: 'keyboard'
        });
    }, [
        showTooltip
    ]);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $eUqFw.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && lastState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipContainer = state !== 'hide' && Boolean(content);
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $jmXuS.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipContainer
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipId = (0, $b1UIz.default)('tooltip', shouldRenderTooltipContainer);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $eUqFw.useEffect)(()=>{
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        const target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute('aria-describedby', tooltipId);
        else target.removeAttribute('aria-describedby');
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    const hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === 'function' ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        ...tooltipTriggerProps,
        'aria-describedby': tooltipId,
        ref: setDirectRef
    }), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CastTargetContainer, {
        ...tooltipTriggerProps,
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }, children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kEVkJ.default), {
        zIndex: $93d6044468b4af6c$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3jZPB.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, ({ ref: ref, style: style, update: update, placement: placement })=>{
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        const direction = position === 'mouse' ? undefined : $93d6044468b4af6c$var$invertedDirection[$93d6044468b4af6c$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9XUBW.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k1zM2.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === 'show-immediate' ? 0 : (0, $bRlz7.mediumDurationMs)
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
                ref: ref,
                /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `Tooltip ${className}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...ignoreTooltipPointerEvents && {
                        pointerEvents: 'none'
                    }
                },
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content)));
    })) : null);
}
$93d6044468b4af6c$var$Tooltip.displayName = 'Tooltip';
var $93d6044468b4af6c$export$2e2bcd8739ae039 = $93d6044468b4af6c$var$Tooltip;

});
parcelRegister("7ZqNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2adbd8939d0b7c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

function $b2adbd8939d0b7c5$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $745834324e4b698f$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $745834324e4b698f$export$390330c10ff2b9a1 = 'ArrowUp';
const $745834324e4b698f$export$a80636c6f41931fe = 'ArrowDown';
const $745834324e4b698f$export$4af703091671bc = 'Home';
const $745834324e4b698f$export$e2bc30913faa5db7 = 'End';
const $745834324e4b698f$export$10f6869ed0a7d75b = 'Tab';
const $745834324e4b698f$export$8152f929a25a0ff4 = 'Enter';
const $745834324e4b698f$export$e51a3576c045c8d5 = 'Space';
const $745834324e4b698f$export$2bb790b9008907b4 = 'Escape';


parcelRegister("jmXuS", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $ec9255363b8fb062$export$469bb693f11edc7f);

var $eUqFw = parcelRequire("eUqFw");

var $en7tp = parcelRequire("en7tp");

var $3miKn = parcelRequire("3miKn");
const $ec9255363b8fb062$export$469bb693f11edc7f = ({ isOpen: isOpen = true } = {})=>{
    const context = (0, $eUqFw.useContext)((0, $3miKn.UpdateLayerCount));
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $en7tp.fg)('platform_design_system_team_layering_observer')) return;
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return ()=>{
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
};

});
parcelRegister("3miKn", function(module, exports) {

$parcel$export(module.exports, "UpdateLayerCount", () => $1bde15b49b18161d$export$b5ab070fa74a0383);

var $eUqFw = parcelRequire("eUqFw");
const $1bde15b49b18161d$export$b5ab070fa74a0383 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});


parcelRegister("eYg2Z", function(module, exports) {

$parcel$export(module.exports, "register", () => $ceea209e4ec2faf6$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $74BVL = parcelRequire("74BVL");
const $ceea209e4ec2faf6$var$registrations = new Set();
let $ceea209e4ec2faf6$var$cleanupEndEventListeners = null;
function $ceea209e4ec2faf6$var$onDragStart() {
    if ($ceea209e4ec2faf6$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $ceea209e4ec2faf6$var$cleanupEndEventListeners = (0, $74BVL.bindAll)(window, [
        {
            type: 'dragend',
            listener: $ceea209e4ec2faf6$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $ceea209e4ec2faf6$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $ceea209e4ec2faf6$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($ceea209e4ec2faf6$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $ceea209e4ec2faf6$var$onDragEnd() {
    $ceea209e4ec2faf6$var$cleanupEndEventListeners?.();
    $ceea209e4ec2faf6$var$cleanupEndEventListeners = null;
    const clone = Array.from($ceea209e4ec2faf6$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $ceea209e4ec2faf6$var$bindStartEvents() {
    return (0, $74BVL.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $ceea209e4ec2faf6$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $ceea209e4ec2faf6$var$onDragStart
        }
    ]);
}
let $ceea209e4ec2faf6$var$cleanupStartEventListeners = null;
function $ceea209e4ec2faf6$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$ceea209e4ec2faf6$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $ceea209e4ec2faf6$var$cleanupStartEventListeners = $ceea209e4ec2faf6$var$bindStartEvents();
    $ceea209e4ec2faf6$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $ceea209e4ec2faf6$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $ceea209e4ec2faf6$var$registrations.delete(registration);
        if ($ceea209e4ec2faf6$var$registrations.size === 0) {
            $ceea209e4ec2faf6$var$cleanupStartEventListeners?.();
            $ceea209e4ec2faf6$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("frgV8", function(module, exports) {

$parcel$export(module.exports, "show", () => $ad7d552cfb7b20e0$export$57bf213be019eeb0);

var $5LIyd = parcelRequire("5LIyd");
let $ad7d552cfb7b20e0$var$active = null;
function $ad7d552cfb7b20e0$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($ad7d552cfb7b20e0$var$active && $ad7d552cfb7b20e0$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $5LIyd.clearScheduled)();
            $ad7d552cfb7b20e0$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $5LIyd.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $5LIyd.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $5LIyd.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($ad7d552cfb7b20e0$var$active && $ad7d552cfb7b20e0$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($ad7d552cfb7b20e0$var$active) {
            (0, $5LIyd.clearScheduled)();
            $ad7d552cfb7b20e0$var$active.entry.hide({
                isImmediate: true
            });
            $ad7d552cfb7b20e0$var$active.entry.done();
            $ad7d552cfb7b20e0$var$active = null;
        }
        // this tooltip is now the active tooltip
        $ad7d552cfb7b20e0$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $5LIyd.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("5LIyd", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $d77e7e636a01279e$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $d77e7e636a01279e$export$5f4d6617421d489b);
let $d77e7e636a01279e$var$delayId = null;
function $d77e7e636a01279e$export$eaf678f6f93f5250() {
    if ($d77e7e636a01279e$var$delayId != null) {
        window.clearTimeout($d77e7e636a01279e$var$delayId);
        $d77e7e636a01279e$var$delayId = null;
    }
}
function $d77e7e636a01279e$export$5f4d6617421d489b(fn, delay) {
    $d77e7e636a01279e$export$eaf678f6f93f5250();
    $d77e7e636a01279e$var$delayId = window.setTimeout(()=>{
        $d77e7e636a01279e$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("b1UIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c1d66f7966e79c8$export$2e2bcd8739ae039);

var $agJNB = parcelRequire("agJNB");
function $8c1d66f7966e79c8$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $agJNB.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("agJNB", function(module, exports) {

$parcel$export(module.exports, "useId", () => $e835b0745747693e$export$f680877a34711e37);
$parcel$export(module.exports, "useIdSeed", () => $e835b0745747693e$export$6ee17796e3d70de2);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $en7tp = parcelRequire("en7tp");
// @ts-ignore - useId is not accessible in React 16
const $e835b0745747693e$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useId ?? undefined;
function $e835b0745747693e$export$f680877a34711e37() {
    if ($e835b0745747693e$var$react18UseId && (0, $en7tp.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $e835b0745747693e$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jFtVs.useUID)();
}
function $e835b0745747693e$export$6ee17796e3d70de2() {
    if ($e835b0745747693e$var$react18UseId && (0, $en7tp.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const uid = $e835b0745747693e$var$react18UseId();
        return (id)=>`${uid}-${id.toString()}`;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jFtVs.useUIDSeed)();
}

});


parcelRegister("1Q3rv", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd546082ca93aa4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9VN84 = parcelRequire("9VN84");
function $abd546082ca93aa4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abd546082ca93aa4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    maxWidth: '240px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
    backgroundColor: `var(--ds-background-neutral-bold, ${(0, $753dd713deeb1c87$export$7d61b15e0da132af)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    overflowWrap: 'break-word',
    wordWrap: 'break-word'
});
const $abd546082ca93aa4$var$truncateStyles = {
    name: "1e1ci1f",
    styles: "max-width:420px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $abd546082ca93aa4$var$TooltipContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9VN84.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $abd546082ca93aa4$var$baseStyles,
            truncate ? $abd546082ca93aa4$var$truncateStyles : null
        ]
    }, children);
});
$abd546082ca93aa4$var$TooltipContainer.displayName = 'TooltipContainer';
var $abd546082ca93aa4$export$2e2bcd8739ae039 = $abd546082ca93aa4$var$TooltipContainer;

});
parcelRegister("9VN84", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e3ab851f15a7fa4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3kxa0 = parcelRequire("3kxa0");
const $0e3ab851f15a7fa4$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $0e3ab851f15a7fa4$var$primitiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zindex: `var(${$0e3ab851f15a7fa4$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
/**
 * The lower level component for rendering a tooltip.
 */ const $0e3ab851f15a7fa4$var$TooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$0e3ab851f15a7fa4$var$VAR_PRIMITIVE_ZINDEX]: (0, $3kxa0.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        /* eslint-enable jsx-a11y/mouse-events-have-key-events */ css: $0e3ab851f15a7fa4$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$0e3ab851f15a7fa4$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $0e3ab851f15a7fa4$export$2e2bcd8739ae039 = $0e3ab851f15a7fa4$var$TooltipPrimitive;

});


parcelRegister("3Ld1j", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $10e4a82d2c508d15$export$642213d516a9b928);
function $10e4a82d2c508d15$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("iMQCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $30162f8d6fac6355$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9XUBW = parcelRequire("9XUBW");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $30162f8d6fac6355$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9XUBW.default), {
        appear: true
    }, props.children);
};
var $30162f8d6fac6355$export$2e2bcd8739ae039 = $30162f8d6fac6355$var$ModalTransition;

});

parcelRegister("5h3iy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5f7c7d2504a988$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $en7tp = parcelRequire("en7tp");

var $51h8o = parcelRequire("51h8o");
var $9RTEO = parcelRequire("9RTEO");

var $a4XwB = parcelRequire("a4XwB");
function $bf5f7c7d2504a988$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bf5f7c7d2504a988$var$visitedLinkStyles = (0, $9RTEO.xcss)({
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:hover': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $bf5f7c7d2504a988$var$defaultAppearanceStyles = (0, $9RTEO.xcss)({
    textDecoration: 'underline',
    color: 'color.link',
    ':hover': {
        color: 'color.link',
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed'
    },
    ':focus': {
        textDecoration: 'underline'
    }
});
const $bf5f7c7d2504a988$var$subtleAppearanceStyles = (0, $9RTEO.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtle',
    ':hover': {
        color: 'color.text.subtle',
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text'
    }
});
const $bf5f7c7d2504a988$var$inverseAppearanceStyles = (0, $9RTEO.xcss)({
    textDecoration: 'underline',
    color: 'color.text.inverse',
    ':hover': {
        color: 'color.text.inverse',
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.text.inverse'
    },
    ':focus': {
        textDecoration: 'underline'
    }
});
// Prevent the icon from wrapping onto a new line by itself
// Using this technique involving a zero-width space: https://snook.ca/archives/html_and_css/icon-wrap-after-text
const $bf5f7c7d2504a988$var$iconWrapperStyles = (0, $9RTEO.xcss)({
    display: 'inline',
    whiteSpace: 'nowrap',
    verticalAlign: 'top',
    position: 'relative',
    insetBlockStart: '0.11em'
});
const $bf5f7c7d2504a988$var$iconStyles = {
    name: "7pys7l",
    styles: "width:0.9em;height:0.9em;margin-inline-start:.3em"
};
const $bf5f7c7d2504a988$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $a4XwB.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            appearance === 'default' && $bf5f7c7d2504a988$var$defaultAppearanceStyles,
            appearance === 'subtle' && $bf5f7c7d2504a988$var$subtleAppearanceStyles,
            appearance === 'inverse' && $bf5f7c7d2504a988$var$inverseAppearanceStyles,
            // Visited styles are not supported for inverse links due to contrast issues
            appearance !== 'inverse' && $bf5f7c7d2504a988$var$visitedLinkStyles
        ],
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ (0, $byn9U.jsx)((0, $51h8o.default), {
        as: "span",
        xcss: $bf5f7c7d2504a988$var$iconWrapperStyles,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", (0, $en7tp.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        css: $bf5f7c7d2504a988$var$iconStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        css: $bf5f7c7d2504a988$var$iconStyles,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $bf5f7c7d2504a988$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)($bf5f7c7d2504a988$var$LinkWithoutRef);
var $bf5f7c7d2504a988$export$2e2bcd8739ae039 = $bf5f7c7d2504a988$var$Link;

});
parcelRegister("a4XwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4d204aa8179f33$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8ynlC = parcelRequire("8ynlC");

var $c7ta0 = parcelRequire("c7ta0");

var $dt2tg = parcelRequire("dt2tg");

var $hWhcQ = parcelRequire("hWhcQ");

var $agJNB = parcelRequire("agJNB");

var $kvBX3 = parcelRequire("kvBX3");

var $cSNAv = parcelRequire("cSNAv");

var $fzAhp = parcelRequire("fzAhp");

var $9RTEO = parcelRequire("9RTEO");
function $4f4d204aa8179f33$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $4f4d204aa8179f33$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $fzAhp.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $fzAhp.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $fzAhp.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $4f4d204aa8179f33$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $4f4d204aa8179f33$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $4f4d204aa8179f33$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $4f4d204aa8179f33$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $4f4d204aa8179f33$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $hWhcQ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eUqFw.useContext)((0, $kvBX3.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $agJNB.useId)();
    const onClick = (0, $c7ta0.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $9RTEO.parseXcss)(xcss);
    const RouterLink = (0, $dt2tg.default)();
    const isExternal = typeof href === 'string' && $4f4d204aa8179f33$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $4f4d204aa8179f33$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $8ynlC.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $4f4d204aa8179f33$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $4f4d204aa8179f33$var$baseStyles,
            $4f4d204aa8179f33$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fzAhp.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fzAhp.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fzAhp.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fzAhp.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fzAhp.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fzAhp.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fzAhp.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fzAhp.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $byn9U.jsx)((0, $cSNAv.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $4f4d204aa8179f33$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $4f4d204aa8179f33$var$Anchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)($4f4d204aa8179f33$var$AnchorNoRef);
var $4f4d204aa8179f33$export$2e2bcd8739ae039 = $4f4d204aa8179f33$var$Anchor;

});
parcelRegister("dt2tg", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec884e133b81a01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cmFU = parcelRequire("8cmFU");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $dec884e133b81a01$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $eUqFw.useContext)((0, $8cmFU.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
};
var $dec884e133b81a01$export$2e2bcd8739ae039 = $dec884e133b81a01$var$useRouterLink;

});
parcelRegister("8cmFU", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $70b57a354823a8f3$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $70b57a354823a8f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $70b57a354823a8f3$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $eUqFw.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $70b57a354823a8f3$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b57a354823a8f3$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $70b57a354823a8f3$export$2e2bcd8739ae039 = $70b57a354823a8f3$var$RouterLinkProvider;

});




parcelRegister("73hjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a9acd97c09f2c8$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51h8o = parcelRequire("51h8o");
var $98MGG = parcelRequire("98MGG");
var $9RTEO = parcelRequire("9RTEO");

const $89a9acd97c09f2c8$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $89a9acd97c09f2c8$var$inlineStyles = (0, $9RTEO.xcss)({
    minWidth: '0'
});
const $89a9acd97c09f2c8$var$textStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(${$89a9acd97c09f2c8$var$CSS_VAR_TEXT_COLOR})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    'a, a:visited, a:hover, a:focus, a:active': {
        color: 'currentColor',
        textDecoration: 'underline'
    }
});
const $89a9acd97c09f2c8$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $89a9acd97c09f2c8$var$tokenBackgroundColors = {
    warning: `var(--ds-background-warning-bold, ${(0, $753dd713deeb1c87$export$c6930421db9fa514)})`,
    error: `var(--ds-background-danger-bold, ${(0, $753dd713deeb1c87$export$2010d0fb4295b346)})`,
    announcement: `var(--ds-background-neutral-bold, ${(0, $753dd713deeb1c87$export$c39c0fe0f26207ae)})`
};
const $89a9acd97c09f2c8$var$tokenTextColors = {
    warning: `var(--ds-text-warning-inverse, ${(0, $753dd713deeb1c87$export$ad0bacf983b7ddaa)})`,
    error: `var(--ds-text-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    announcement: `var(--ds-text-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`
};
const $89a9acd97c09f2c8$var$containerStyles = (0, $9RTEO.xcss)({
    height: '3rem',
    alignItems: 'center',
    display: 'flex'
});
const $89a9acd97c09f2c8$var$iconWrapperStyles = (0, $9RTEO.xcss)({
    display: 'block',
    width: '1.5rem',
    height: '1.5rem',
    // This matches Icon's "medium" size, without this the (line-)height is greater than that of the Icon
    flexShrink: '0'
});
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $89a9acd97c09f2c8$var$Banner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $89a9acd97c09f2c8$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51h8o.default), {
        xcss: $89a9acd97c09f2c8$var$containerStyles,
        backgroundColor: $89a9acd97c09f2c8$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $98MGG.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        xcss: $89a9acd97c09f2c8$var$inlineStyles
    }, icon ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $51h8o.default), {
        as: "span",
        xcss: $89a9acd97c09f2c8$var$iconWrapperStyles,
        style: {
            fill: $89a9acd97c09f2c8$var$tokenBackgroundColors[appearanceType],
            color: $89a9acd97c09f2c8$var$tokenTextColors[appearanceType]
        }
    }, icon) : null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$89a9acd97c09f2c8$var$CSS_VAR_TEXT_COLOR]: $89a9acd97c09f2c8$var$tokenTextColors[appearanceType]
        },
        css: $89a9acd97c09f2c8$var$textStyles
    }, children)));
});
var $89a9acd97c09f2c8$export$2e2bcd8739ae039 = $89a9acd97c09f2c8$var$Banner;

});

parcelRegister("3P4kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $69ad1fc9a8625839$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $c7ta0 = parcelRequire("c7ta0");

var $hWhcQ = parcelRequire("hWhcQ");

var $ggR40 = parcelRequire("ggR40");
var $gyabX = parcelRequire("gyabX");

var $en7tp = parcelRequire("en7tp");

var $isvIQ = parcelRequire("isvIQ");
var $3jZPB = parcelRequire("3jZPB");
var $j8oxo = parcelRequire("j8oxo");

var $fLAFV = parcelRequire("fLAFV");

var $e2gjq = parcelRequire("e2gjq");
const $69ad1fc9a8625839$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $69ad1fc9a8625839$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $69ad1fc9a8625839$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $gyabX.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", null);
};
const $69ad1fc9a8625839$var$InlineDialog = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $hWhcQ.default), onContentClick: onContentClick = (0, $hWhcQ.default), onContentFocus: onContentFocus = (0, $hWhcQ.default), onClose: providedOnClose = (0, $hWhcQ.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const onClose = (0, $c7ta0.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $en7tp.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($69ad1fc9a8625839$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $3jZPB.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $e2gjq.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $isvIQ.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j8oxo.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $fLAFV.default), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            },
            hasNodeResolver: !(0, $en7tp.fg)('platform_design_system_team_portal_logic_r18_fix')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $ggR40.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, /*#__PURE__*/ (0, $byn9U.jsx)($69ad1fc9a8625839$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69ad1fc9a8625839$export$2e2bcd8739ae039 = $69ad1fc9a8625839$var$InlineDialog;

});
parcelRegister("ggR40", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $c7697109bca26f08$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $c7697109bca26f08$export$48b383b280e20440);
$parcel$export(module.exports, "UNSAFE_LAYERING", () => $c7697109bca26f08$export$a183686c3f6f4ea8);

var $eUqFw = parcelRequire("eUqFw");

var $hWhcQ = parcelRequire("hWhcQ");
const $c7697109bca26f08$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $c7697109bca26f08$export$48b383b280e20440 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $hWhcQ.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $c7697109bca26f08$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel, topLevelRef: topLevelRef } = (0, $eUqFw.useContext)($c7697109bca26f08$export$48b383b280e20440);
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $eUqFw.useEffect)(()=>{
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return ()=>{
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7697109bca26f08$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $c7697109bca26f08$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $eUqFw.useRef)(0);
    const value = (0, $eUqFw.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            }
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7697109bca26f08$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
const $c7697109bca26f08$export$a183686c3f6f4ea8 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $eUqFw.useContext)($c7697109bca26f08$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7697109bca26f08$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7697109bca26f08$var$LayeringProvider, null, content);
};

});

parcelRegister("gyabX", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $54d1cd66e9358472$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "UNSAFE_useLayering", () => $54d1cd66e9358472$export$cec37b93989366d4);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $ggR40 = parcelRequire("ggR40");
const $54d1cd66e9358472$var$ESCAPE = 'Escape';
function $54d1cd66e9358472$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $54d1cd66e9358472$export$cec37b93989366d4();
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $54d1cd66e9358472$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $54d1cd66e9358472$export$cec37b93989366d4() {
    const currentLevel = (0, $eUqFw.useContext)((0, $ggR40.LevelContext));
    const { topLevelRef: topLevelRef } = (0, $eUqFw.useContext)((0, $ggR40.TopLevelContext));
    const isLayerDisabled = (0, $eUqFw.useCallback)(()=>{
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("fLAFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $610d51602c920d08$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbDTY = parcelRequire("lbDTY");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $610d51602c920d08$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (node)=>innerRef(node)
    }, children);
};
var $610d51602c920d08$export$2e2bcd8739ae039 = $610d51602c920d08$var$NodeResolverWrapper;

});

parcelRegister("e2gjq", function(module, exports) {

$parcel$export(module.exports, "Container", () => $dff09f756f8f7187$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $3kxa0 = parcelRequire("3kxa0");
const $dff09f756f8f7187$var$CSS_THEME_BACKGROUND = '--theme-background';
const $dff09f756f8f7187$var$CSS_THEME_COLOR = '--theme-color';
const $dff09f756f8f7187$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $dff09f756f8f7187$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $3kxa0.layers).dialog(),
    background: `var(${$dff09f756f8f7187$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$dff09f756f8f7187$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$dff09f756f8f7187$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $dff09f756f8f7187$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dff09f756f8f7187$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$dff09f756f8f7187$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
            [$dff09f756f8f7187$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $753dd713deeb1c87$export$fbda843f0a27fe96)})`,
            [$dff09f756f8f7187$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $753dd713deeb1c87$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $753dd713deeb1c87$export$d2d3bedfb276cac0)}`})`,
            ...style
        }
    }, children));
});

});


parcelRegister("bLZzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eec0544762039b3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $8MHxr = parcelRequire("8MHxr");

var $c7ta0 = parcelRequire("c7ta0");

var $3KHL4 = parcelRequire("3KHL4");

var $hWhcQ = parcelRequire("hWhcQ");

var $ggR40 = parcelRequire("ggR40");

var $k1zM2 = parcelRequire("k1zM2");

var $en7tp = parcelRequire("en7tp");

var $kEVkJ = parcelRequire("kEVkJ");

var $3kxa0 = parcelRequire("3kxa0");

var $cP8kh = parcelRequire("cP8kh");

var $bbju3 = parcelRequire("bbju3");

var $dmMmj = parcelRequire("dmMmj");
function $2eec0544762039b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2eec0544762039b3$var$fillScreenStyles = {
    name: "1yerbni",
    styles: "width:100vw;height:100vh;position:fixed;inset-block-start:var(--ds-space-0, 0);inset-inline-start:var(--ds-space-0, 0);overflow-y:auto;-webkit-overflow-scrolling:touch"
};
const $2eec0544762039b3$var$allowlistElements = (element, callback)=>{
    // allows focus to reach elements outside the modal if they contain the data-atlas-extension attribute
    if (element.hasAttribute('data-atlas-extension')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $2eec0544762039b3$var$ModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: onClose = (0, $hWhcQ.default), onStackChange: onStackChange = (0, $hWhcQ.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
    const calculatedStackIndex = (0, $bbju3.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    const FocusLock = (0, $en7tp.fg)('platform_dst_modal-dialog-bump-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $c7ta0.usePlatformLeafEventHandler)({
        fn: onClose,
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onBlanketClicked = (0, $eUqFw.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    const allowListCallback = (0, $eUqFw.useCallback)((element)=>$2eec0544762039b3$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    (0, $dmMmj.default)();
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $byn9U.jsx)((0, $3KHL4.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cP8kh.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    let returnFocus = true;
    let onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ggR40.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kEVkJ.default), {
        zIndex: (0, $3kxa0.layers).modal()
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $k1zM2.default), null, (fadeInProps)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...fadeInProps,
            css: $2eec0544762039b3$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }, /*#__PURE__*/ (0, $byn9U.jsx)(FocusLock, {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null), shouldScrollInViewport ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8MHxr.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
};
var $2eec0544762039b3$export$2e2bcd8739ae039 = $2eec0544762039b3$var$ModalWrapper;

});
parcelRegister("3KHL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d98c437b95253bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $c7ta0 = parcelRequire("c7ta0");

var $hWhcQ = parcelRequire("hWhcQ");


var $3kxa0 = parcelRequire("3kxa0");
function $1d98c437b95253bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1d98c437b95253bb$var$packageName = "platform-pkg";
const $1d98c437b95253bb$var$packageVersion = "0.0.0-use.local";
const $1d98c437b95253bb$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $1d98c437b95253bb$var$packageName,
    packageVersion: $1d98c437b95253bb$var$packageVersion
};
const $1d98c437b95253bb$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: (0, $3kxa0.layers).blanket(),
    inset: 0,
    backgroundColor: `var(--ds-blanket, ${(0, $753dd713deeb1c87$export$486ab785e4bac3c6)})`,
    overflowY: 'auto',
    pointerEvents: 'initial'
});
const $1d98c437b95253bb$var$shouldAllowClickThroughStyles = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $1d98c437b95253bb$var$invisibleStyles = {
    name: "1peqg37",
    styles: "background-color:transparent"
};
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const $1d98c437b95253bb$var$Blanket = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $hWhcQ.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $eUqFw.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $c7ta0.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$1d98c437b95253bb$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $eUqFw.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $eUqFw.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to enable light dismiss functionality instead of creating an
     * inaccessible custom element, we can add role="presentation" so that there
     * are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        css: [
            $1d98c437b95253bb$var$baseStyles,
            shouldAllowClickThrough && $1d98c437b95253bb$var$shouldAllowClickThroughStyles,
            !isTinted && $1d98c437b95253bb$var$invisibleStyles
        ],
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref
    }, children));
}));
$1d98c437b95253bb$var$Blanket.displayName = 'Blanket';
var $1d98c437b95253bb$export$2e2bcd8739ae039 = $1d98c437b95253bb$var$Blanket;

});

parcelRegister("cP8kh", function(module, exports) {

$parcel$export(module.exports, "default", () => $254f97775a80f2cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eOjAl = parcelRequire("eOjAl");

var $6Kvrh = parcelRequire("6Kvrh");

var $agJNB = parcelRequire("agJNB");

var $5IVbS = parcelRequire("5IVbS");

var $gyabX = parcelRequire("gyabX");

var $k1zM2 = parcelRequire("k1zM2");

var $7SeHk = parcelRequire("7SeHk");

var $jUY0r = parcelRequire("jUY0r");


var $jDQ57 = parcelRequire("jDQ57");

var $1ytqa = parcelRequire("1ytqa");

var $lsGmf = parcelRequire("lsGmf");

var $7Setw = parcelRequire("7Setw");

var $6fRSw = parcelRequire("6fRSw");

var $l4f0L = parcelRequire("l4f0L");

var $bnSr3 = parcelRequire("bnSr3");

var $cuEqF = parcelRequire("cuEqF");

var $7N3X2 = parcelRequire("7N3X2");
const $254f97775a80f2cb$var$dialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $1ytqa.textColor),
    [(0, $jDQ57.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    pointerEvents: 'auto',
    [(0, $jUY0r.media).above.xs]: {
        width: 'var(--modal-dialog-width)',
        maxWidth: 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: (0, $1ytqa.borderRadius),
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $753dd713deeb1c87$export$920c0d5c49070351)}, 0 2px 1px ${(0, $753dd713deeb1c87$export$920c0d5c49070351)}, 0 0 20px -6px ${(0, $753dd713deeb1c87$export$d2d3bedfb276cac0)}`})`,
        marginInlineEnd: 'inherit',
        marginInlineStart: 'inherit'
    },
    /**
   * This is to support scrolling if the modal's children are wrapped in
   * a form.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > form:only-child': {
        display: 'inherit',
        maxHeight: 'inherit',
        flexDirection: 'inherit'
    }
});
const $254f97775a80f2cb$var$viewportScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none',
    [(0, $jUY0r.media).above.xs]: {
        minHeight: 'var(--modal-dialog-height)'
    }
});
const $254f97775a80f2cb$var$bodyScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    [(0, $jUY0r.media).above.xs]: {
        height: 'var(--modal-dialog-height)',
        maxHeight: 'inherit'
    }
});
const $254f97775a80f2cb$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, children: children, label: label, testId: testId } = props;
    const id = (0, $agJNB.useId)();
    const titleId = `modal-dialog-title-${id}`;
    (0, $eUqFw.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $7SeHk.combine)((0, $6fRSw.disableDraggingToCrossOriginIFramesForElement)(), (0, $bnSr3.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $l4f0L.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $6Kvrh.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $7Setw.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $eUqFw.useMemo)(()=>({
            testId: testId,
            titleId: titleId,
            onClose: onClose
        }), [
        testId,
        titleId,
        onClose
    ]);
    (0, $gyabX.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $gyabX.UNSAFE_useLayering)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7N3X2.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lsGmf.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lsGmf.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $k1zM2.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, (bottomFadeInProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5IVbS.default), null, /*#__PURE__*/ (0, $byn9U.jsx)("section", {
            ...bottomFadeInProps,
            "aria-label": label,
            ref: (0, $eOjAl.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $cuEqF.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $cuEqF.dialogHeight)(height)
            },
            css: [
                $254f97775a80f2cb$var$dialogStyles,
                shouldScrollInViewport ? $254f97775a80f2cb$var$viewportScrollStyles : $254f97775a80f2cb$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }, children))))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$254f97775a80f2cb$export$2e2bcd8739ae039 = $254f97775a80f2cb$var$ModalDialog;

});
parcelRegister("7Setw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b07fe97215ffbf1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0b07fe97215ffbf1$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $eUqFw.useRef)(null);
    const onMotionFinish = (0, $eUqFw.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("6fRSw", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $513f9320f7b0495e$export$ec28e97c7d8b1b35);

var $74BVL = parcelRequire("74BVL");

var $7SeHk = parcelRequire("7SeHk");

var $1S45o = parcelRequire("1S45o");

var $4zI1a = parcelRequire("4zI1a");
function $513f9320f7b0495e$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $1S45o.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $7SeHk.combine)(unbindEvents, unbindMonitor);
}
function $513f9320f7b0495e$var$watchForInteractionStart({ start: start }) {
    return (0, $74BVL.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $513f9320f7b0495e$var$api = (0, $4zI1a.makeFixForAdapter)({
    watchForInteractionStart: $513f9320f7b0495e$var$watchForInteractionStart,
    watchForInteractionEnd: $513f9320f7b0495e$var$watchForInteractionEnd
});
function $513f9320f7b0495e$export$ec28e97c7d8b1b35() {
    return $513f9320f7b0495e$var$api.registerUsage();
}

});
parcelRegister("4zI1a", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", () => $07278fb93cfa2393$export$a74bff2507e6126b);

var $7SeHk = parcelRequire("7SeHk");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $07278fb93cfa2393$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $07278fb93cfa2393$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $07278fb93cfa2393$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$07278fb93cfa2393$var$hasSameOrigin(window.location.href, iframe.src);
}
const $07278fb93cfa2393$var$registry = new Map();
function $07278fb93cfa2393$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($07278fb93cfa2393$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $07278fb93cfa2393$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $07278fb93cfa2393$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $07278fb93cfa2393$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $07278fb93cfa2393$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $7SeHk.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $07278fb93cfa2393$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $07278fb93cfa2393$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("l4f0L", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $249aa6e6ccf01714$export$27d79116d3a4e7d5);

var $7JsXQ = parcelRequire("7JsXQ");

var $4zI1a = parcelRequire("4zI1a");
function $249aa6e6ccf01714$var$watchForInteractionStart({ start: start }) {
    return (0, $7JsXQ.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $249aa6e6ccf01714$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $7JsXQ.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $249aa6e6ccf01714$var$api = (0, $4zI1a.makeFixForAdapter)({
    watchForInteractionStart: $249aa6e6ccf01714$var$watchForInteractionStart,
    watchForInteractionEnd: $249aa6e6ccf01714$var$watchForInteractionEnd
});
function $249aa6e6ccf01714$export$27d79116d3a4e7d5() {
    return $249aa6e6ccf01714$var$api.registerUsage();
}

});

parcelRegister("bnSr3", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $250e6bfd09ca20b9$export$9c0606fcefb5d1e2);

var $74BVL = parcelRequire("74BVL");

var $7SeHk = parcelRequire("7SeHk");

var $9B6VS = parcelRequire("9B6VS");

var $4zI1a = parcelRequire("4zI1a");
function $250e6bfd09ca20b9$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $9B6VS.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $7SeHk.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $250e6bfd09ca20b9$var$watchForInteractionStart({ start: start }) {
    return (0, $74BVL.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $250e6bfd09ca20b9$var$api = (0, $4zI1a.makeFixForAdapter)({
    watchForInteractionStart: $250e6bfd09ca20b9$var$watchForInteractionStart,
    watchForInteractionEnd: $250e6bfd09ca20b9$var$watchForInteractionEnd
});
function $250e6bfd09ca20b9$export$9c0606fcefb5d1e2() {
    return $250e6bfd09ca20b9$var$api.registerUsage();
}

});

parcelRegister("cuEqF", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", () => $99defcb7da8ee25a$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $99defcb7da8ee25a$export$ceba93bf0bdd16f2);

var $1ytqa = parcelRequire("1ytqa");
const $99defcb7da8ee25a$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $1ytqa.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $1ytqa.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $99defcb7da8ee25a$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("7N3X2", function(module, exports) {

$parcel$export(module.exports, "default", () => $536ea177fbe78325$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /**
                                                                        * @jsxRuntime classic
                                                                        * @jsx jsx
                                                                        */ 
var $byn9U = parcelRequire("byn9U");


var $bRlz7 = parcelRequire("bRlz7");

var $jUY0r = parcelRequire("jUY0r");

var $3kxa0 = parcelRequire("3kxa0");

var $1ytqa = parcelRequire("1ytqa");
function $536ea177fbe78325$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $536ea177fbe78325$var$maxWidthDimensions = `calc(100vw - ${(0, $1ytqa.gutter) * 2}px)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $536ea177fbe78325$var$maxHeightDimensions = `calc(100vh - ${(0, $1ytqa.gutter) * 2 - 1}px)`;
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $536ea177fbe78325$var$positionerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $3kxa0.layers).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
const $536ea177fbe78325$var$viewportScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: 'auto',
    position: 'relative',
    [(0, $jUY0r.media).above.xs]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $1ytqa.gutter)}px auto`,
        pointerEvents: 'none'
    }
});
const $536ea177fbe78325$var$bodyScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    [(0, $jUY0r.media).above.xs]: {
        maxWidth: $536ea177fbe78325$var$maxWidthDimensions,
        maxHeight: $536ea177fbe78325$var$maxHeightDimensions,
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `${(0, $1ytqa.gutter)}px`,
        insetInlineEnd: 0,
        insetInlineStart: 0,
        marginInlineEnd: 'auto',
        marginInlineStart: 'auto',
        pointerEvents: 'none'
    }
});
const $536ea177fbe78325$var$stackTransitionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    transitionDuration: `${(0, $bRlz7.mediumDurationMs)}ms`,
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $7ad1783c91d2c1de$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
const $536ea177fbe78325$var$stackTransformStyles = {
    name: "937ak9",
    styles: "transform:translateY(var(--modal-dialog-translate-y))"
};
const $536ea177fbe78325$var$stackIdleStyles = {
    name: "179q9ic",
    styles: "transform:none"
};
const $536ea177fbe78325$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': `${stackIndex * ((0, $1ytqa.verticalOffset) / 2)}px`
        },
        css: [
            $536ea177fbe78325$var$positionerStyles,
            $536ea177fbe78325$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $536ea177fbe78325$var$stackTransformStyles : $536ea177fbe78325$var$stackIdleStyles,
            shouldScrollInViewport ? $536ea177fbe78325$var$viewportScrollStyles : $536ea177fbe78325$var$bodyScrollStyles
        ],
        "data-testid": testId && `${testId}--positioner`
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$536ea177fbe78325$export$2e2bcd8739ae039 = $536ea177fbe78325$var$Positioner;

});
const $7ad1783c91d2c1de$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $7ad1783c91d2c1de$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $7ad1783c91d2c1de$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';



parcelRegister("bbju3", function(module, exports) {

$parcel$export(module.exports, "default", () => $88a2f5fb89fea066$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEdk8 = parcelRequire("cEdk8");

var $KVBuk = parcelRequire("KVBuk");

var $dK551 = parcelRequire("dK551");

var $9XUBW = parcelRequire("9XUBW");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $88a2f5fb89fea066$var$modalStackRegister = [];
function $88a2f5fb89fea066$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $9XUBW.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $dK551.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $KVBuk.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $cEdk8.default)(()=>{
        const newStackIndex = $88a2f5fb89fea066$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        const currentStackIndex = $88a2f5fb89fea066$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $88a2f5fb89fea066$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $88a2f5fb89fea066$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $88a2f5fb89fea066$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $88a2f5fb89fea066$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $88a2f5fb89fea066$var$modalStackRegister.splice(currentStackIndex, 1);
                $88a2f5fb89fea066$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("KVBuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $046b0b79b5e528da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $046b0b79b5e528da$export$2e2bcd8739ae039(value) {
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});


parcelRegister("dmMmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb8b3c2ea04e300$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $6eb8b3c2ea04e300$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $6eb8b3c2ea04e300$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setScrollTopOffset($6eb8b3c2ea04e300$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $eUqFw.useCallback)(()=>{
        if ($6eb8b3c2ea04e300$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("4GFWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7ad144f5f344cd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("cNx4i")).Popup);

var $cNx4i = parcelRequire("cNx4i");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ad7ad144f5f344cd$export$2e2bcd8739ae039 = (0, $cNx4i.Popup);

});
parcelRegister("cNx4i", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $36a6d8a1ef43ac0f$export$129a32eedafa97c5);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $agJNB = parcelRequire("agJNB");

var $ggR40 = parcelRequire("ggR40");

var $jmXuS = parcelRequire("jmXuS");

var $en7tp = parcelRequire("en7tp");

var $isvIQ = parcelRequire("isvIQ");
var $j8oxo = parcelRequire("j8oxo");

var $kEVkJ = parcelRequire("kEVkJ");

var $51h8o = parcelRequire("51h8o");
var $9RTEO = parcelRequire("9RTEO");

var $3kxa0 = parcelRequire("3kxa0");

var $bycWr = parcelRequire("bycWr");

var $fKXkx = parcelRequire("fKXkx");

var $dIF0q = parcelRequire("dIF0q");

var $i2X3M = parcelRequire("i2X3M");
const $36a6d8a1ef43ac0f$var$defaultLayer = (0, $3kxa0.layers).layer();
const $36a6d8a1ef43ac0f$var$wrapperStyles = (0, $9RTEO.xcss)({
    position: 'relative'
});
const $36a6d8a1ef43ac0f$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $36a6d8a1ef43ac0f$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $eUqFw.useState)(null);
    const getMergedTriggerRef = (0, $dIF0q.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $i2X3M.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $agJNB.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fKXkx.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    (0, $jmXuS.useNotifyOpenLayerObserver)({
        isOpen: isOpen
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $byn9U.jsx)((0, $ggR40.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bycWr.default), {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    const popupContent = /*#__PURE__*/ (0, $byn9U.jsx)((0, $isvIQ.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j8oxo.Reference), null, ({ ref: ref })=>{
        return trigger({
            ref: !(0, $en7tp.fg)('platform-design-system-dsp-20476-dropdown-menu') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $en7tp.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $byn9U.jsx)((0, $kEVkJ.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51h8o.default), {
        xcss: $36a6d8a1ef43ac0f$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $36a6d8a1ef43ac0f$export$2e2bcd8739ae039 = $36a6d8a1ef43ac0f$export$129a32eedafa97c5;

});
parcelRegister("bycWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $de7cbcacc54d198d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5IVbS = parcelRequire("5IVbS");

var $gyabX = parcelRequire("gyabX");

var $en7tp = parcelRequire("en7tp");

var $3jZPB = parcelRequire("3jZPB");


var $3kxa0 = parcelRequire("3kxa0");

var $jDQ57 = parcelRequire("jDQ57");

var $2Cved = parcelRequire("2Cved");

var $hvazB = parcelRequire("hvazB");

var $GXQmr = parcelRequire("GXQmr");
function $de7cbcacc54d198d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $de7cbcacc54d198d$var$fullWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $de7cbcacc54d198d$var$rootStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $3kxa0.layers).layer(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $753dd713deeb1c87$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $753dd713deeb1c87$export$d2d3bedfb276cac0)}`})`,
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)",
    [(0, $jDQ57.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    '&:focus': {
        outline: 'none'
    }
});
const $de7cbcacc54d198d$var$scrollableStyles = {
    name: "1qmr6ab",
    styles: "overflow:auto"
};
const $de7cbcacc54d198d$var$blanketStyles = {
    name: "nsh9jl",
    styles: "position:fixed;inset:0;background-color:var(--ds-blanket, #091E427D)"
};
const $de7cbcacc54d198d$var$modalStyles = {
    name: "1rni9zo",
    styles: "max-height:50vh;position:fixed;inset-block-start:var(--ds-space-050, 4px);inset-inline:var(--ds-space-050, 4px)"
};
const $de7cbcacc54d198d$var$DefaultPopupComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, xcss: xcss, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // We suppress this for now as we can't use the Compiled pragma until this module has migrated to Compiled.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @compiled/jsx-pragma
        className: xcss,
        css: [
            $de7cbcacc54d198d$var$rootStyles,
            appearance === 'UNSAFE_modal-below-sm' && $de7cbcacc54d198d$var$modalStyles,
            !shouldRenderToParent && $de7cbcacc54d198d$var$scrollableStyles,
            shouldFitContainer && $de7cbcacc54d198d$var$fullWidthStyles
        ],
        ...htmlAttributes,
        ref: ref
    }, children);
});
function $de7cbcacc54d198d$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $de7cbcacc54d198d$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $eUqFw.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $eUqFw.useState)(null);
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $GXQmr.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $hvazB.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $gyabX.UNSAFE_useLayering)();
    const mergedModifiers = (0, $eUqFw.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3jZPB.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, ({ ref: ref, style: style, placement: placement, update: update })=>{
        const popupContainer = /*#__PURE__*/ (0, $byn9U.jsx)(PopupContainer, {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setPopupRef(node);
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2Cved.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $en7tp.fg)('platform-design-system-apply-popup-wrapper-focus') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5IVbS.default), null, popupContainer), appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $de7cbcacc54d198d$var$blanketStyles
        })) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $de7cbcacc54d198d$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$de7cbcacc54d198d$export$2e2bcd8739ae039 = $de7cbcacc54d198d$var$PopperWrapper;

});
parcelRegister("2Cved", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $01777d9c5d7fed0e$export$51eddd7655ca235a);

var $eUqFw = parcelRequire("eUqFw");
const $01777d9c5d7fed0e$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);
};

});

parcelRegister("hvazB", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $e110092bf643b59e$export$92dae2778ae88f9d);
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $hWhcQ = parcelRequire("hWhcQ");

var $gyabX = parcelRequire("gyabX");

var $en7tp = parcelRequire("en7tp");

var $biztf = parcelRequire("biztf");

var $Bg2ae = parcelRequire("Bg2ae");
const $e110092bf643b59e$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $gyabX.UNSAFE_useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $Bg2ae.useAnimationFrame)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $hWhcQ.default;
        const closePopup = (event)=>{
            if (onClose) {
                if ((0, $en7tp.fg)('sibling-dropdown-close-issue')) {
                    let currentLevel = null;
                    if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level');
                    currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $en7tp.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                //if it is a disabled layer, and we clicked inside a higher layer
                //we will disable the click event
                if ((0, $en7tp.fg)('design-system-closed-all-when-click-outside')) {
                    if (target instanceof HTMLElement) {
                        const levelOfClickedLayer = target.closest?.(`[data-ds--level]`)?.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) return;
                    }
                } else return;
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $biztf.isInteractiveElement)(document.activeElement) && (0, $en7tp.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onKeyDown = (event)=>{
            if ((0, $en7tp.fg)('platform_dst_popup-disable-focuslock')) {
                const { key: key, shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                const { key: key } = event;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        const unbind = (0, $74BVL.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $hWhcQ.default);
        unbindBlur = (0, $74BVL.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            cancelAllFrames();
            unbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("biztf", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $621b003092345a84$export$3dee5e4542c672d9);
const $621b003092345a84$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $621b003092345a84$export$3dee5e4542c672d9 = (element)=>{
    if ($621b003092345a84$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("Bg2ae", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", () => $a535050b4c444a17$export$641fa9c94086b46e);

var $eUqFw = parcelRequire("eUqFw");
const $a535050b4c444a17$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $eUqFw.useRef)([]);
    const requestFrame = (0, $eUqFw.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $eUqFw.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $eUqFw.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("GXQmr", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", () => $75baca9741b4deb4$export$10c5169755ce7bd7);

var $eUqFw = parcelRequire("eUqFw");

var $a2Ury = parcelRequire("a2Ury");

var $hWhcQ = parcelRequire("hWhcQ");

var $gyabX = parcelRequire("gyabX");

var $en7tp = parcelRequire("en7tp");

var $Bg2ae = parcelRequire("Bg2ae");
const $75baca9741b4deb4$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $Bg2ae.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $gyabX.UNSAFE_useLayering)();
    (0, $eUqFw.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $hWhcQ.default;
        if (shouldDisableFocusTrap && (0, $en7tp.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $hWhcQ.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($a2Ury)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("fKXkx", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", () => $b410ffe5420b2512$export$4065aef1d79a5730);

var $eUqFw = parcelRequire("eUqFw");

var $grdYo = parcelRequire("grdYo");
function $b410ffe5420b2512$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $grdYo.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $eUqFw.useState)(!!mq?.matches);
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("grdYo", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $d092e05dde834e86$export$49e55ae2c03d6045);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $buiBE = parcelRequire("buiBE");

var $jUY0r = parcelRequire("jUY0r");
const $d092e05dde834e86$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jUY0r.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $d092e05dde834e86$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $eUqFw.useRef)(listener);
    (0, $eUqFw.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $d092e05dde834e86$var$queries[queryString];
    (0, $buiBE.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $74BVL.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("buiBE", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $266f618b2b8d8184$export$e5c5a5f917a5871c);

var $eUqFw = parcelRequire("eUqFw");
const $266f618b2b8d8184$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $eUqFw.useEffect) : (0, $eUqFw.useLayoutEffect);

});



parcelRegister("dIF0q", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $61b09f05371b2854$export$7cc5c058dd769dff);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");
const $61b09f05371b2854$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $eUqFw.useState)(()=>(0, $5iWql.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("i2X3M", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $5bdde5a527d01f7e$export$5d3a2de79e07b376);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");
const $5bdde5a527d01f7e$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $eUqFw.useState)(()=>(0, $5iWql.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("8k3N3", function(module, exports) {

$parcel$export(module.exports, "default", () => $896426446aaecc01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dfSow = parcelRequire("dfSow");

var $1UQ4d = parcelRequire("1UQ4d");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $896426446aaecc01$var$Spotlight = ({ dialogWidth: dialogWidth = 400, pulse: pulse = true, testId: testId = 'spotlight', targetNode: targetNode, target: target, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UQ4d.SpotlightConsumer), null, ({ opened: opened, closed: closed, targets: targets })=>{
        // use the targetNode prop or try get the target from context targets using name
        const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
        return actualTargetNode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dfSow.default), {
            ...rest,
            targetNode: actualTargetNode,
            target: target,
            onOpened: opened,
            onClosed: closed,
            testId: testId,
            dialogWidth: dialogWidth,
            pulse: pulse
        }) : null;
    });
var $896426446aaecc01$export$2e2bcd8739ae039 = $896426446aaecc01$var$Spotlight;

});
parcelRegister("dfSow", function(module, exports) {

$parcel$export(module.exports, "default", () => $dada7c31d1c1d7d4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQ44K = parcelRequire("kQ44K");

var $8MHxr = parcelRequire("8MHxr");

var $k7cZh = parcelRequire("k7cZh");

var $ggR40 = parcelRequire("ggR40");

var $en7tp = parcelRequire("en7tp");

var $kEVkJ = parcelRequire("kEVkJ");

var $3kxa0 = parcelRequire("3kxa0");

var $dMJsb = parcelRequire("dMJsb");

var $a8rDe = parcelRequire("a8rDe");

var $5iEW0 = parcelRequire("5iEW0");

var $apXOD = parcelRequire("apXOD");

var $bmyiO = parcelRequire("bmyiO");

var $i2H6B = parcelRequire("i2H6B");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ class $dada7c31d1c1d7d4$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            dialogWidth: 400,
            pulse: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $k7cZh.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $k7cZh.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2H6B.SpotlightTransitionConsumer), null, ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kEVkJ.default), {
                zIndex: (0, $3kxa0.layers).spotlight() + 1
            }, TargetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apXOD.default), {
                hasNodeResolver: !(0, $en7tp.fg)('platform_design_system_team_onboarding_noderesolve'),
                innerRef: (elem)=>this.setState({
                        replacementElement: elem
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dMJsb.ElementBox), {
                element: targetNode
            }, (box)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TargetReplacement, {
                    "data-testid": `${testId}--target`,
                    ...this.getTargetNodeStyle(box)
                }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dMJsb.ElementBox), {
                element: targetNode
            }, (box)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5iEW0.default), {
                    testId: `${testId}--target`,
                    pulse: pulse,
                    target: target,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getTargetNodeStyle(box),
                    targetBgColor: targetBgColor,
                    targetNode: targetNode,
                    targetOnClick: targetOnClick,
                    targetRadius: targetRadius
                })), TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8rDe.Fade), {
                hasEntered: isOpen,
                onExited: onExited
            }, (animationStyles)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ggR40.UNSAFE_LAYERING), {
                    isDisabled: (0, $en7tp.fg)('platform_design_system_team_spotlight_layering') ? false : true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmyiO.default), {
                    testId: `${testId}--dialog`,
                    actions: this.props.actions,
                    actionsBeforeElement: this.props.actionsBeforeElement,
                    children: this.props.children,
                    dialogPlacement: this.props.dialogPlacement,
                    dialogWidth: this.props.dialogWidth,
                    footer: this.props.footer,
                    header: this.props.header,
                    heading: this.props.heading,
                    headingAfterElement: this.props.headingAfterElement,
                    image: this.props.image,
                    targetNode: replacementElement || targetNode,
                    animationStyles: animationStyles
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        };
        this.getTargetNodeStyle = (box)=>{
            if (!(0, $kQ44K.canUseDOM)) return {};
            return {
                ...box,
                position: 'fixed'
            };
        };
    }
}
var $dada7c31d1c1d7d4$export$2e2bcd8739ae039 = $dada7c31d1c1d7d4$var$SpotlightInner;

});
parcelRegister("dMJsb", function(module, exports) {

$parcel$export(module.exports, "ElementBox", () => $4f44167ceede9168$export$1b6719bd7aff3c00);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $en7tp = parcelRequire("en7tp");
// The minimum interval between position updates in milliseconds
const $4f44167ceede9168$var$POSITION_UPDATE_INTERVAL = 200;
const $4f44167ceede9168$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $4f44167ceede9168$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $eUqFw.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') setBox($4f44167ceede9168$var$getElementRect(element));
    }, [
        element,
        updateMethod
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($4f44167ceede9168$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $74BVL.bind)(window, {
            type: 'resize',
            listener: onResize
        });
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $4f44167ceede9168$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $eUqFw.useState)(0);
    const [height, setHeight] = (0, $eUqFw.useState)(0);
    const [left, setLeft] = (0, $eUqFw.useState)(0);
    const [top, setTop] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            const newBox = $4f44167ceede9168$var$getElementRect(element);
            setWidth(newBox.width);
            setHeight(newBox.height);
            setLeft(newBox.left);
            setTop(newBox.top);
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $eUqFw.useRef)();
    const previousUpdateTimeRef = (0, $eUqFw.useRef)();
    const animate = (0, $eUqFw.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $4f44167ceede9168$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $4f44167ceede9168$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $eUqFw.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
const $4f44167ceede9168$export$54f449d89c9b029a = (element)=>{
    const updateMethod = (0, $en7tp.getBooleanFF)('platform.design-system.refresh-spotlight-on-interval') ? 'polling' : 'resizeListener';
    const boxViaResizeListener = $4f44167ceede9168$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $4f44167ceede9168$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $4f44167ceede9168$export$1b6719bd7aff3c00 = (props)=>{
    const box = $4f44167ceede9168$export$54f449d89c9b029a(props.element);
    return props.children(box);
};

});

parcelRegister("a8rDe", function(module, exports) {

$parcel$export(module.exports, "Fade", () => $4d28f50c5ba301f4$export$c983850c6c9d8b0e);

var $eUqFw = parcelRequire("eUqFw");

var $247XK = parcelRequire("247XK");

var $en7tp = parcelRequire("en7tp");
const $4d28f50c5ba301f4$var$duration = {
    enter: 0,
    exit: 100
};
const $4d28f50c5ba301f4$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>{
    const nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $247XK.default), {
        in: hasEntered,
        timeout: $4d28f50c5ba301f4$var$duration,
        onExited: onExited,
        unmountOnExit: true,
        appear: true,
        ...(0, $en7tp.fg)('platform-design-system-dsp-20687-transition-group') && {
            nodeRef: nodeRef
        }
    }, (status)=>{
        const base = {
            transition: `opacity ${$4d28f50c5ba301f4$var$duration.exit}ms`,
            opacity: 0
        };
        const anim = {
            entered: {
                opacity: 1
            },
            exiting: {
                opacity: 0
            }
        };
        const style = {
            ...base,
            ...anim[status]
        };
        return children(style);
    });
};

});

parcelRegister("5iEW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $122fdc4d8a509cf6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $i2FD8 = parcelRequire("i2FD8");

var $gBHJT = parcelRequire("gBHJT");
const $122fdc4d8a509cf6$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $122fdc4d8a509cf6$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $122fdc4d8a509cf6$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $122fdc4d8a509cf6$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $gBHJT.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $eUqFw.useMemo)(()=>$122fdc4d8a509cf6$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2FD8.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: contentHTML
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            height: '100%',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2FD8.TargetOverlay), {
        onClick: targetOnClick ? (event)=>targetOnClick({
                event: event,
                target: target
            }) : undefined
    }));
};
var $122fdc4d8a509cf6$export$2e2bcd8739ae039 = $122fdc4d8a509cf6$var$Clone;

});
parcelRegister("i2FD8", function(module, exports) {

$parcel$export(module.exports, "TargetInner", () => $b88b00945f2acfa7$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $b88b00945f2acfa7$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $b88b00945f2acfa7$export$927d63e2511364c0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $2IuU7 = parcelRequire("2IuU7");

function $b88b00945f2acfa7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $b88b00945f2acfa7$var$baseShadow = `0 0 0 2px ${`var(--ds-border-discovery, ${(0, $753dd713deeb1c87$export$b48405b95304b5a1)})`}`;
const $b88b00945f2acfa7$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $b88b00945f2acfa7$var$pulseKeyframes = (0, $byn9U.keyframes)({
    '0%, 33%': {
        boxShadow: `${$b88b00945f2acfa7$var$baseShadow}, 0 0 0 ${"var(--ds-border-discovery, rgba(101, 84, 192, 1))"}`
    },
    '66%, 100%': {
        boxShadow: `${$b88b00945f2acfa7$var$baseShadow}, 0 0 0 10px rgba(101, 84, 192, 0.01)`
    }
});
const $b88b00945f2acfa7$export$9fd1cab52ce14fd5 = $b88b00945f2acfa7$var$pulseKeyframes.name;
const $b88b00945f2acfa7$var$animationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$b88b00945f2acfa7$var$pulseKeyframes} 3000ms ${$b88b00945f2acfa7$var$easing} infinite`,
    // Keep a purple boxshadow on the Pulse component if `prefers-reduced-motion`
    // is applied so we still have a functioning semantic affordance.
    boxShadow: $b88b00945f2acfa7$var$baseShadow
});
const $b88b00945f2acfa7$var$Base = ({ children: children, bgColor: bgColor, radius: radius, style: style, testId: testId, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? `${radius}px` : undefined
        },
        ...props
    }, children);
const $b88b00945f2acfa7$export$b1542cc928b93af = ({ children: children, pulse: pulse, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)($b88b00945f2acfa7$var$Base, {
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            pulse && $b88b00945f2acfa7$var$animationStyles,
            (0, $2IuU7.reduceMotionAsPerUserPreference)
        ]
    }, children);
const $b88b00945f2acfa7$var$targetOverlayStyles = {
    name: "1ydh0jg",
    styles: "width:100%;height:100%;position:absolute;inset-block-start:0;inset-inline-start:0"
};
const $b88b00945f2acfa7$export$a28a07e0025d709d = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...props,
        css: $b88b00945f2acfa7$var$targetOverlayStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            cursor: props.onClick ? 'pointer' : 'auto'
        }
    });
const $b88b00945f2acfa7$export$927d63e2511364c0 = ({ children: children, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)($b88b00945f2acfa7$var$Base, {
        ...props,
        css: [
            pulse && $b88b00945f2acfa7$var$animationStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $2IuU7.reduceMotionAsPerUserPreference)
        ],
        testId: testId
    }, children);

});

parcelRegister("gBHJT", function(module, exports) {

$parcel$export(module.exports, "useElementObserver", () => $ae9ca4de30b13b19$export$729bafd4e621fba0);

var $eUqFw = parcelRequire("eUqFw");
function $ae9ca4de30b13b19$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $eUqFw.useState)(0);
    const mutationObserver = (0, $eUqFw.useRef)(undefined);
    const cancelIdleCallback1 = (0, $eUqFw.useRef)(undefined);
    const disposer = (0, $eUqFw.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $eUqFw.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $ae9ca4de30b13b19$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
function $ae9ca4de30b13b19$export$12e07a2a9f87578a({ element: element, children: children, onChange: onChange, disableWatch: disableWatch }) {
    $ae9ca4de30b13b19$export$729bafd4e621fba0(element, {
        disableWatch: disableWatch,
        onChange: onChange
    });
    return {
        children: children
    };
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $ae9ca4de30b13b19$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    // eslint-disable-next-line compat/compat
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line compat/compat
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("apXOD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6634dd743fbbb185$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbDTY = parcelRequire("lbDTY");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $6634dd743fbbb185$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: divRef
    }, children);
};
var $6634dd743fbbb185$export$2e2bcd8739ae039 = $6634dd743fbbb185$var$NodeResolverSpotlightInner;

});

parcelRegister("bmyiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ed9c5ddfcfcd5b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $en7tp = parcelRequire("en7tp");

var $3jZPB = parcelRequire("3jZPB");

var $dFIKR = parcelRequire("dFIKR");

var $fYi3y = parcelRequire("fYi3y");

var $jAuF8 = parcelRequire("jAuF8");
const $30ed9c5ddfcfcd5b$var$FocusLock = (0, $en7tp.fg)('platform_dst_onboarding-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ class $30ed9c5ddfcfcd5b$var$SpotlightDialogComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3jZPB.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement
        }, ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jAuF8.default), {
                value: dialogWidth,
                onChange: update
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ed9c5ddfcfcd5b$var$FocusLock, {
                disabled: focusLockDisabled,
                returnFocus: false,
                autoFocus: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                style: {
                    ...style,
                    ...animationStyles
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYi3y.default), {
                testId: testId,
                width: dialogWidth,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                image: image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFIKR.DialogImage), {
                    alt: heading,
                    src: image
                }),
                components: {
                    Header: header,
                    Footer: footer
                },
                heading: heading,
                headingAfterElement: headingAfterElement,
                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                headingLevel: 2
            }, children)))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            focusLockDisabled: true
        };
    }
}
var $30ed9c5ddfcfcd5b$export$2e2bcd8739ae039 = $30ed9c5ddfcfcd5b$var$SpotlightDialogComponent;

});
parcelRegister("dFIKR", function(module, exports) {

$parcel$export(module.exports, "DialogImage", () => $4cca97a97c1662b6$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $4cca97a97c1662b6$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $4cca97a97c1662b6$export$6ae54e00f59e1f33);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $4cca97a97c1662b6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4cca97a97c1662b6$var$imageStyles = {
    name: "1hyxgad",
    styles: "max-width:100%;height:auto"
};
const $4cca97a97c1662b6$var$actionItemContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: `${"var(--ds-space-0, 0px)"} -4px`,
    /* When there is more than one action, place primary action visually on the
   right, but keep it's position as the first focusable element in the DOM */ flexDirection: 'row-reverse'
});
const $4cca97a97c1662b6$var$actionItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
});
const $4cca97a97c1662b6$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        css: $4cca97a97c1662b6$var$imageStyles,
        alt: alt,
        ...props
    });
const $4cca97a97c1662b6$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $4cca97a97c1662b6$var$actionItemContainerStyles
    }, children);
const $4cca97a97c1662b6$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $4cca97a97c1662b6$var$actionItemStyles
    }, children);

});

parcelRegister("fYi3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c16b91404e4e523$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ljMCx = parcelRequire("ljMCx");
var $jpJRW = parcelRequire("jpJRW");

var $1DCtM = parcelRequire("1DCtM");

var $51h8o = parcelRequire("51h8o");
var $3bmcJ = parcelRequire("3bmcJ");
var $9RTEO = parcelRequire("9RTEO");

var $dFIKR = parcelRequire("dFIKR");

var $7mLQr = parcelRequire("7mLQr");
function $8c16b91404e4e523$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c16b91404e4e523$var$bodyStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`,
    flexDirection: 'column'
});
const $8c16b91404e4e523$var$imageStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $8c16b91404e4e523$var$defaultHeaderStyles = {
    name: "8dfjp9",
    styles: "display:flex;align-items:baseline;justify-content:space-between;padding-block-end:var(--ds-space-100, 8px)"
};
const $8c16b91404e4e523$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $8c16b91404e4e523$var$defaultHeaderStyles
    }, children);
const $8c16b91404e4e523$var$defaultFooterStyles = {
    name: "1xj74a2",
    styles: "display:flex;align-items:center;justify-content:space-between;padding-block-start:var(--ds-space-100, 8px)"
};
const $8c16b91404e4e523$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $8c16b91404e4e523$var$defaultFooterStyles
    }, children);
const $8c16b91404e4e523$var$containerStyles = (0, $9RTEO.xcss)({
    height: 'fit-content',
    zIndex: 'spotlight',
    borderRadius: 'border.radius',
    color: 'color.text.inverse',
    overflow: 'auto',
    minWidth: '160px',
    maxWidth: '600px'
});
const $8c16b91404e4e523$var$containerShadowStyles = (0, $9RTEO.xcss)({
    boxShadow: 'elevation.shadow.raised'
});
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 */ const $8c16b91404e4e523$var$SpotlightCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $8c16b91404e4e523$var$DefaultHeader, Footer: Footer = $8c16b91404e4e523$var$DefaultFooter } = components;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jpJRW.default).Provider, {
        value: (0, $7mLQr.spotlightButtonTheme)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $51h8o.default), {
        backgroundColor: "color.background.discovery.bold",
        xcss: [
            $8c16b91404e4e523$var$containerStyles,
            !isFlat && $8c16b91404e4e523$var$containerShadowStyles
        ],
        style: {
            width: width
        },
        ref: ref || innerRef,
        testId: testId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        css: $8c16b91404e4e523$var$imageStyles,
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $8c16b91404e4e523$var$bodyStyles
    }, heading || headingAfterElement ? /*#__PURE__*/ (0, $byn9U.jsx)(Header, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1DCtM.default), {
        id: headingId,
        size: "medium",
        as: `h${headingLevel}`,
        color: "color.text.inverse"
    }, heading), headingAfterElement) : null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $3bmcJ.default), null, children), actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $byn9U.jsx)(Footer, null, actionsBeforeElement || /*#__PURE__*/ (0, $byn9U.jsx)("span", null), /*#__PURE__*/ (0, $byn9U.jsx)((0, $dFIKR.DialogActionItemContainer), null, actions.map(({ text: text, key: key, ...rest }, idx)=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $dFIKR.DialogActionItem), {
            key: key || (typeof text === 'string' ? text : `${idx}`)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ljMCx.default), rest, text));
    }))) : null)));
});
$8c16b91404e4e523$var$SpotlightCard.displayName = 'SpotlightCard';
var $8c16b91404e4e523$export$2e2bcd8739ae039 = $8c16b91404e4e523$var$SpotlightCard;

});
parcelRegister("7mLQr", function(module, exports) {

$parcel$export(module.exports, "spotlightButtonTheme", () => $de8d24ded7159114$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $de8d24ded7159114$export$d131eb21ba4cbd16);

const $de8d24ded7159114$var$spotlightTheme = {
    default: {
        background: {
            default: `var(--ds-background-inverse-subtle, ${$753dd713deeb1c87$export$147899de772240ec})`,
            hover: `var(--ds-background-inverse-subtle-hovered, ${$753dd713deeb1c87$export$a7175d4e9206bc80})`,
            active: `var(--ds-background-inverse-subtle-pressed, ${$753dd713deeb1c87$export$147899de772240ec})`,
            disabled: `var(--ds-background-disabled, ${$753dd713deeb1c87$export$c71e4279dd54a18d})`,
            selected: `var(--ds-background-inverse-subtle-pressed, ${$753dd713deeb1c87$export$2837b5a1a71d5c02})`,
            focus: `var(--ds-background-inverse-subtle, ${$753dd713deeb1c87$export$147899de772240ec})`
        },
        color: {
            default: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            hover: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            active: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            disabled: {
                light: `var(--ds-text-disabled, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
                dark: `var(--ds-text-disabled, ${$753dd713deeb1c87$export$633847cf062b69e0})`
            },
            selected: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            focus: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: `var(--ds-background-inverse-subtle-hovered, ${$753dd713deeb1c87$export$a7175d4e9206bc80})`,
            active: `var(--ds-background-inverse-subtle-pressed, ${$753dd713deeb1c87$export$147899de772240ec})`,
            disabled: 'none',
            selected: {
                light: `var(--ds-background-selected-hovered, ${$753dd713deeb1c87$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected-hovered, ${$753dd713deeb1c87$export$3d4f271a500072a})`
            },
            focusSelected: {
                light: `var(--ds-background-selected-hovered, ${$753dd713deeb1c87$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected-hovered, ${$753dd713deeb1c87$export$3d4f271a500072a})`
            }
        },
        color: {
            default: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            hover: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            active: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            disabled: `var(--ds-text-disabled, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            selected: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            focus: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${`var(--ds-text-inverse, ${$753dd713deeb1c87$export$4b0a4417ed59760f})`}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            hover: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$4b0a4417ed59760f})`,
            active: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$6011520a64d9a187})`,
            disabled: `var(--ds-text-discovery, ${$753dd713deeb1c87$export$147899de772240ec})`,
            selected: `var(--ds-text-selected, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            focus: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`
        }
    }
};
const $de8d24ded7159114$var$modalTheme = {
    primary: {
        background: {
            default: `var(--ds-background-discovery-bold, ${$753dd713deeb1c87$export$c71e4279dd54a18d})`,
            hover: `var(--ds-background-discovery-bold-hovered, ${$753dd713deeb1c87$export$a7175d4e9206bc80})`,
            active: `var(--ds-background-discovery-bold-pressed, ${$753dd713deeb1c87$export$147899de772240ec})`,
            disabled: {
                light: `var(--ds-background-disabled, ${$753dd713deeb1c87$export$3e51e8f1440314ba})`,
                dark: `var(--ds-background-disabled, ${$753dd713deeb1c87$export$d281fbfe3cff2df6})`
            },
            selected: `var(--ds-background-selected-hovered, ${$753dd713deeb1c87$export$2837b5a1a71d5c02})`,
            focus: `var(--ds-background-discovery-bold-hovered, ${$753dd713deeb1c87$export$c71e4279dd54a18d})`
        },
        color: {
            default: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            disabled: {
                light: `var(--ds-text-disabled, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
                dark: `var(--ds-text-disabled, ${$753dd713deeb1c87$export$633847cf062b69e0})`
            },
            selected: `var(--ds-text-selected, ${$753dd713deeb1c87$export$29a4f05edc054374})`,
            focus: `var(--ds-text-inverse, ${$753dd713deeb1c87$export$29a4f05edc054374})`
        }
    }
};
function $de8d24ded7159114$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $de8d24ded7159114$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$de8d24ded7159114$var$extract($de8d24ded7159114$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $de8d24ded7159114$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$de8d24ded7159114$var$extract($de8d24ded7159114$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("jAuF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0199804b2058f415$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $0199804b2058f415$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("i2H6B", function(module, exports) {

$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $77a50f6ba43558be$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $77a50f6ba43558be$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hWhcQ = parcelRequire("hWhcQ");
const $77a50f6ba43558be$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isOpen: true,
    onExited: (0, $hWhcQ.default)
});
// checks if children exist and are truthy
const $77a50f6ba43558be$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ class $77a50f6ba43558be$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $77a50f6ba43558be$var$hasChildren(previousChildren) && !$77a50f6ba43558be$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($77a50f6ba43558be$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $77a50f6ba43558be$var$hasChildren(this.props.children)
            }
        }, this.state.currentChildren);
    }
    constructor(...args){
        super(...args);
        this.state = {
            currentChildren: undefined
        };
        this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $77a50f6ba43558be$export$7d63b19b854c2fe8 = $77a50f6ba43558be$var$SpotlightTransitionContext.Consumer;
var $77a50f6ba43558be$export$2e2bcd8739ae039 = $77a50f6ba43558be$var$SpotlightTransition;

});


parcelRegister("1UQ4d", function(module, exports) {

$parcel$export(module.exports, "TargetConsumer", () => $ef7c82f6e3168b30$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $ef7c82f6e3168b30$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $ef7c82f6e3168b30$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $ef7c82f6e3168b30$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $hWhcQ = parcelRequire("hWhcQ");

var $kEVkJ = parcelRequire("kEVkJ");

var $3kxa0 = parcelRequire("3kxa0");

var $cXnel = parcelRequire("cXnel");

var $a8rDe = parcelRequire("a8rDe");

var $2fFJv = parcelRequire("2fFJv");
const { Consumer: $ef7c82f6e3168b30$export$f643dd64c1952cc8, Provider: $ef7c82f6e3168b30$var$TargetProvider } = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ef7c82f6e3168b30$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    opened: (0, $hWhcQ.default),
    closed: (0, $hWhcQ.default),
    targets: {}
});
const { Consumer: $ef7c82f6e3168b30$export$3503199acd121708, Provider: $ef7c82f6e3168b30$var$SpotlightStateProvider } = $ef7c82f6e3168b30$export$7b5aa0f5b37a336d;
const $ef7c82f6e3168b30$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, children);
class $ef7c82f6e3168b30$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            blanketIsTinted: true
        };
    }
    componentDidMount() {
        typeof $2fFJv;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef7c82f6e3168b30$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef7c82f6e3168b30$var$TargetProvider, {
            value: this.targetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef7c82f6e3168b30$var$Container, {
            component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8rDe.Fade), {
            hasEntered: this.state.spotlightCount > 0
        }, (animationStyles)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kEVkJ.default), {
                zIndex: (0, $3kxa0.layers).spotlight()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cXnel.default), {
                /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: animationStyles,
                isTinted: blanketIsTinted,
                onBlanketClicked: onBlanketClicked
            }))), children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            spotlightCount: 0,
            targets: {}
        };
        this.targetRef = (name)=>(element)=>{
                this.setState((state)=>({
                        targets: {
                            ...state.targets,
                            [name]: element || undefined
                        }
                    }));
            };
        this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        };
        this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        };
        this.getStateProviderValue = (0, $5iWql.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("cXnel", function(module, exports) {

$parcel$export(module.exports, "default", () => $034e0e77587980ca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $3kxa0 = parcelRequire("3kxa0");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $034e0e77587980ca$var$blanketStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: (0, $3kxa0.layers).spotlight(),
    inset: 0,
    transition: 'opacity 220ms'
});
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $034e0e77587980ca$var$Blanket = (props)=>{
    const { onBlanketClicked: onBlanketClicked } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        css: $034e0e77587980ca$var$blanketStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...props.style,
            backgroundColor: props.isTinted ? `var(--ds-blanket, ${0, $753dd713deeb1c87$export$486ab785e4bac3c6})` : 'transparent'
        },
        onClick: onBlanketClicked
    });
};
var $034e0e77587980ca$export$2e2bcd8739ae039 = $034e0e77587980ca$var$Blanket;

});



parcelRegister("jXpX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $02785f860acfc74d$export$2e2bcd8739ae039);



var $gpAdT = parcelRequire("gpAdT");

var $2fFJv = parcelRequire("2fFJv");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $02785f860acfc74d$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $gpAdT.default)[tokenId];
    let tokenValue = fallback;
    typeof $2fFJv;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $02785f860acfc74d$export$2e2bcd8739ae039 = $02785f860acfc74d$var$getTokenValue;

});
parcelRegister("gpAdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b730cbb98162d966$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ const $b730cbb98162d966$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $b730cbb98162d966$export$2e2bcd8739ae039 = $b730cbb98162d966$var$tokens;

});


parcelRegister("i3lo1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8e46278013fc94$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bwLgX = parcelRequire("bwLgX");

var $9cyqT = parcelRequire("9cyqT");

var $bfuYp = parcelRequire("bfuYp");
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/icon-button/examples)
 * - [Code](https://atlassian.design/components/icon-button/code)
 * - [Usage](https://atlassian.design/components/icon-button/usage)
 */ const $2a8e46278013fc94$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    /**
		 * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
		 * buttons. It's currently duplicated and mostly the same.
		 */ const baseProps = (0, $bfuYp.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'button',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cyqT.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwLgX.default), {
            ...saferRest,
            // Top level props
            "aria-labelledby": baseProps['aria-labelledby'],
            type: type,
            testId: testId,
            componentName: "IconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                saferRest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                saferRest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                saferRest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                saferRest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                saferRest.onBlur?.(e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                baseProps?.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (ref)=>{
                baseProps.ref(ref);
                triggerProps?.ref?.(ref);
            },
            // Base props only
            xcss: baseProps.xcss,
            isDisabled: baseProps.isDisabled,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture
        }, baseProps.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwLgX.default), {
        ...saferRest,
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, baseProps.children);
}));
$2a8e46278013fc94$var$IconButton.displayName = 'IconButton';
var $2a8e46278013fc94$export$2e2bcd8739ae039 = $2a8e46278013fc94$var$IconButton;

});
parcelRegister("bfuYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2570b3260489d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cSNAv = parcelRequire("cSNAv");

var $gGqNb = parcelRequire("gGqNb");

var $baaoB = parcelRequire("baaoB");

var $8ZSO9 = parcelRequire("8ZSO9");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ const $6b2570b3260489d8$var$useIconButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shape: shape, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
    const isCircle = shape === 'circle';
    const baseProps = (0, $8ZSO9.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGqNb.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $baaoB.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSNAv.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $6b2570b3260489d8$export$2e2bcd8739ae039 = $6b2570b3260489d8$var$useIconButton;

});
parcelRegister("gGqNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dec24e0683dd774$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $51h8o = parcelRequire("51h8o");
var $9RTEO = parcelRequire("9RTEO");
const $3dec24e0683dd774$var$textStyles = (0, $9RTEO.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $3dec24e0683dd774$var$iconStyles = (0, $9RTEO.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0,
    userSelect: 'none'
});
const $3dec24e0683dd774$var$commonStyles = (0, $9RTEO.xcss)({
    transition: 'opacity 0.3s'
});
const $3dec24e0683dd774$var$fadeStyles = (0, $9RTEO.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $3dec24e0683dd774$var$beforeIconStyles = (0, $9RTEO.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
const $3dec24e0683dd774$var$afterIconStyles = (0, $9RTEO.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $3dec24e0683dd774$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51h8o.default), {
        as: "span",
        xcss: [
            $3dec24e0683dd774$var$commonStyles,
            ...type === 'text' ? [
                $3dec24e0683dd774$var$textStyles
            ] : [
                $3dec24e0683dd774$var$iconStyles
            ],
            ...isLoading ? [
                $3dec24e0683dd774$var$fadeStyles
            ] : [],
            ...position === 'before' ? [
                $3dec24e0683dd774$var$beforeIconStyles
            ] : [],
            ...position === 'after' ? [
                $3dec24e0683dd774$var$afterIconStyles
            ] : []
        ]
    }, children);
};
var $3dec24e0683dd774$export$2e2bcd8739ae039 = $3dec24e0683dd774$var$Content;

});

parcelRegister("baaoB", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a72e7d5fb027b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $59a72e7d5fb027b1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $59a72e7d5fb027b1$var$IconRenderer = ({ icon: Icon })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $59a72e7d5fb027b1$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $59a72e7d5fb027b1$export$2e2bcd8739ae039 = $59a72e7d5fb027b1$var$IconRenderer;

});

parcelRegister("8ZSO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b16ce2bca2312a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eOjAl = parcelRequire("eOjAl");

var $6Kvrh = parcelRequire("6Kvrh");

var $agJNB = parcelRequire("agJNB");

var $en7tp = parcelRequire("en7tp");

var $51h8o = parcelRequire("51h8o");
var $9RTEO = parcelRequire("9RTEO");


var $cSNAv = parcelRequire("cSNAv");

var $3WrnG = parcelRequire("3WrnG");

var $a3ax8 = parcelRequire("a3ax8");


var $hH1ET = parcelRequire("hH1ET");
const $e6b16ce2bca2312a$var$buttonStyles = (0, $9RTEO.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: `${32 / 14}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
const $e6b16ce2bca2312a$var$hardCodedButtonStyles = (0, $9RTEO.xcss)({
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: `${32 / 14}em`,
    paddingBlock: 'space.0'
});
const $e6b16ce2bca2312a$var$tokenizedButtonStyles = (0, $9RTEO.xcss)({
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075'
});
const $e6b16ce2bca2312a$var$defaultInteractiveStyles = (0, $9RTEO.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$753dd713deeb1c87$export$c39c0fe0f26207ae})`
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-neutral-pressed, ${$753dd713deeb1c87$export$8c13c2ee36917869})`,
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$753dd713deeb1c87$export$b3de0ae08da2ce64})`
    }
});
const $e6b16ce2bca2312a$var$defaultInteractiveRefreshedStyles = (0, $9RTEO.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
const $e6b16ce2bca2312a$var$defaultStyles = (0, $9RTEO.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: `var(--ds-background-neutral, ${$753dd713deeb1c87$export$8d43898f60b96a82})`,
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$753dd713deeb1c87$export$c39c0fe0f26207ae})`,
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$753dd713deeb1c87$export$c39c0fe0f26207ae})`
    }
});
const $e6b16ce2bca2312a$var$defaultRefreshedStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
const $e6b16ce2bca2312a$var$primaryStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
const $e6b16ce2bca2312a$var$primaryInteractiveStyles = (0, $9RTEO.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
const $e6b16ce2bca2312a$var$warningStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
const $e6b16ce2bca2312a$var$warningInteractiveStyles = (0, $9RTEO.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
const $e6b16ce2bca2312a$var$dangerStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $e6b16ce2bca2312a$var$dangerInteractiveStyles = (0, $9RTEO.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
const $e6b16ce2bca2312a$var$discoveryStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $e6b16ce2bca2312a$var$discoveryInteractiveStyles = (0, $9RTEO.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
const $e6b16ce2bca2312a$var$subtleStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $e6b16ce2bca2312a$var$subtleRefreshedStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
const $e6b16ce2bca2312a$var$subtleInteractiveStyles = (0, $9RTEO.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $e6b16ce2bca2312a$var$subtleInteractiveRefreshedStyles = (0, $9RTEO.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
const $e6b16ce2bca2312a$var$linkDecorationUnsetStyles = (0, $9RTEO.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
const $e6b16ce2bca2312a$var$disabledStyles = (0, $9RTEO.xcss)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-disabled, ${$753dd713deeb1c87$export$8d43898f60b96a82})`,
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-disabled, ${$753dd713deeb1c87$export$8d43898f60b96a82})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-disabled, ${$753dd713deeb1c87$export$8d43898f60b96a82})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
const $e6b16ce2bca2312a$var$selectedStyles = (0, $9RTEO.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$753dd713deeb1c87$export$ad0bacf983b7ddaa})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`
    }
});
const $e6b16ce2bca2312a$var$selectedRefreshedStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
const $e6b16ce2bca2312a$var$selectedInsideSplitButtonStyles = (0, $9RTEO.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
const $e6b16ce2bca2312a$var$selectedInteractiveStyles = (0, $9RTEO.xcss)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected-hovered, ${$753dd713deeb1c87$export$ad0bacf983b7ddaa})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected-pressed, ${$753dd713deeb1c87$export$ad0bacf983b7ddaa})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $e6b16ce2bca2312a$var$selectedWarningStyles = (0, $9RTEO.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$753dd713deeb1c87$export$59619663aa6500fb})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$7d61b15e0da132af})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$753dd713deeb1c87$export$59619663aa6500fb})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$753dd713deeb1c87$export$59619663aa6500fb})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $e6b16ce2bca2312a$var$selectedDangerStyles = (0, $9RTEO.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$753dd713deeb1c87$export$2837b5a1a71d5c02})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$753dd713deeb1c87$export$2837b5a1a71d5c02})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$753dd713deeb1c87$export$2837b5a1a71d5c02})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $e6b16ce2bca2312a$var$selectedDiscoveryStyles = (0, $9RTEO.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$753dd713deeb1c87$export$9fdfb749e33cdf97})`,
        background: "var(--ds-background-selected, #403294)"
    }
});
const $e6b16ce2bca2312a$var$spacingCompactStyles = (0, $9RTEO.xcss)({
    columnGap: 'space.050',
    height: `${24 / 14}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
const $e6b16ce2bca2312a$var$baseSpacingCompactStyles = (0, $9RTEO.xcss)({
    lineHeight: `${24 / 14}em`
});
const $e6b16ce2bca2312a$var$tokenizedSpacingCompactStyles = (0, $9RTEO.xcss)({
    paddingBlock: 'space.025'
});
const $e6b16ce2bca2312a$var$circleStyles = (0, $9RTEO.xcss)({
    borderRadius: 'border.radius.circle'
});
const $e6b16ce2bca2312a$var$fullWidthStyles = (0, $9RTEO.xcss)({
    width: '100%'
});
const $e6b16ce2bca2312a$var$loadingStyles = (0, $9RTEO.xcss)({
    cursor: 'progress'
});
const $e6b16ce2bca2312a$var$iconButtonStyles = (0, $9RTEO.xcss)({
    height: `${32 / 14}em`,
    width: `${32 / 14}em`,
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
const $e6b16ce2bca2312a$var$iconButtonCompactStyles = (0, $9RTEO.xcss)({
    width: `${24 / 14}em`,
    height: `${24 / 14}em`
});
const $e6b16ce2bca2312a$var$buttonIconBeforeStyles = (0, $9RTEO.xcss)({
    paddingInlineStart: 'space.100'
});
const $e6b16ce2bca2312a$var$buttonIconAfterStyles = (0, $9RTEO.xcss)({
    paddingInlineEnd: 'space.100'
});
const $e6b16ce2bca2312a$var$splitButtonStyles = (0, $9RTEO.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
const $e6b16ce2bca2312a$var$navigationSplitButtonStyles = (0, $9RTEO.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
const $e6b16ce2bca2312a$var$loadingOverlayStyles = (0, $9RTEO.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $e6b16ce2bca2312a$var$useButtonBase = ({ appearance: propAppearance = 'default', autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: // TODO: Separate Icon Button styling from button base
isIconButton = false, isCircle: isCircle = false, hasIconBefore: // TODO: Separate icon slot styling from button base
hasIconBefore = false, hasIconAfter: hasIconAfter = false, children: children, onClick: onClick, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onTouchStartCapture: onTouchStartCapture, onTouchEndCapture: onTouchEndCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, ref: ref, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy })=>{
    const localRef = (0, $eUqFw.useRef)(null);
    const splitButtonContext = (0, $3WrnG.useSplitButtonContext)();
    const loadingLabelId = (0, $agJNB.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton && (0, $en7tp.fg)('platform-component-visual-refresh') ? 'subtle' : splitButtonContext?.appearance || propAppearance;
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $6Kvrh.default)(localRef, autoFocus);
    return {
        ref: (0, $eOjAl.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $en7tp.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $e6b16ce2bca2312a$var$tokenizedButtonStyles : $e6b16ce2bca2312a$var$hardCodedButtonStyles,
            $e6b16ce2bca2312a$var$buttonStyles,
            appearance === 'default' && ((0, $en7tp.fg)('platform-component-visual-refresh') ? $e6b16ce2bca2312a$var$defaultRefreshedStyles : $e6b16ce2bca2312a$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $en7tp.fg)('platform-component-visual-refresh') ? $e6b16ce2bca2312a$var$defaultInteractiveRefreshedStyles : $e6b16ce2bca2312a$var$defaultInteractiveStyles),
            appearance === 'primary' && $e6b16ce2bca2312a$var$primaryStyles,
            appearance === 'primary' && isInteractive && $e6b16ce2bca2312a$var$primaryInteractiveStyles,
            appearance === 'warning' && $e6b16ce2bca2312a$var$warningStyles,
            appearance === 'warning' && isInteractive && $e6b16ce2bca2312a$var$warningInteractiveStyles,
            appearance === 'danger' && $e6b16ce2bca2312a$var$dangerStyles,
            appearance === 'danger' && isInteractive && $e6b16ce2bca2312a$var$dangerInteractiveStyles,
            appearance === 'discovery' && $e6b16ce2bca2312a$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $e6b16ce2bca2312a$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $en7tp.fg)('platform-component-visual-refresh') ? $e6b16ce2bca2312a$var$subtleRefreshedStyles : $e6b16ce2bca2312a$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $en7tp.fg)('platform-component-visual-refresh') ? $e6b16ce2bca2312a$var$subtleInteractiveRefreshedStyles : $e6b16ce2bca2312a$var$subtleInteractiveStyles),
            $e6b16ce2bca2312a$var$linkDecorationUnsetStyles,
            isSelected && ((0, $en7tp.fg)('platform-component-visual-refresh') ? $e6b16ce2bca2312a$var$selectedRefreshedStyles : $e6b16ce2bca2312a$var$selectedStyles),
            isSelected && isSplitButton && $e6b16ce2bca2312a$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $e6b16ce2bca2312a$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $e6b16ce2bca2312a$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $e6b16ce2bca2312a$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $e6b16ce2bca2312a$var$selectedDiscoveryStyles,
            isDisabled && $e6b16ce2bca2312a$var$disabledStyles,
            isCircle && !isSplitButton && $e6b16ce2bca2312a$var$circleStyles,
            spacing === 'compact' && $e6b16ce2bca2312a$var$spacingCompactStyles,
            spacing === 'compact' && ((0, $en7tp.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $e6b16ce2bca2312a$var$tokenizedSpacingCompactStyles : $e6b16ce2bca2312a$var$baseSpacingCompactStyles),
            hasIconBefore && $e6b16ce2bca2312a$var$buttonIconBeforeStyles,
            hasIconAfter && $e6b16ce2bca2312a$var$buttonIconAfterStyles,
            isIconButton && $e6b16ce2bca2312a$var$iconButtonStyles,
            isIconButton && spacing === 'compact' && $e6b16ce2bca2312a$var$iconButtonCompactStyles,
            shouldFitContainer && $e6b16ce2bca2312a$var$fullWidthStyles,
            isLoading && $e6b16ce2bca2312a$var$loadingStyles,
            isSplitButton && $e6b16ce2bca2312a$var$splitButtonStyles,
            isNavigationSplitButton && $e6b16ce2bca2312a$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51h8o.default), {
            as: "span",
            xcss: $e6b16ce2bca2312a$var$loadingOverlayStyles
        }, (0, $hH1ET.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSNAv.default), {
            id: loadingLabelId
        }, (0, $d7fb9960b511054e$export$d4c5499dc806c969))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${0, $d7fb9960b511054e$export$d4c5499dc806c969}` : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        ...(0, $a3ax8.default)(isEffectivelyDisabled, {
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        })
    };
};
var $e6b16ce2bca2312a$export$2e2bcd8739ae039 = $e6b16ce2bca2312a$var$useButtonBase;

});
parcelRegister("3WrnG", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $316c027bcc28f2d7$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $316c027bcc28f2d7$export$47e2c6fdb142d947);

var $eUqFw = parcelRequire("eUqFw");
const $316c027bcc28f2d7$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $316c027bcc28f2d7$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $eUqFw.useContext)($316c027bcc28f2d7$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("a3ax8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e99f3290c5edf271$export$2e2bcd8739ae039);
function $e99f3290c5edf271$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $e99f3290c5edf271$var$tabKeyCode = 9;
function $e99f3290c5edf271$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $e99f3290c5edf271$var$tabKeyCode) return;
    $e99f3290c5edf271$var$abort(event);
}
function $e99f3290c5edf271$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $e99f3290c5edf271$var$abort,
        onMouseUpCapture: $e99f3290c5edf271$var$abort,
        onKeyDownCapture: $e99f3290c5edf271$var$onKey,
        onKeyUpCapture: $e99f3290c5edf271$var$onKey,
        onTouchStartCapture: $e99f3290c5edf271$var$abort,
        onTouchEndCapture: $e99f3290c5edf271$var$abort,
        onPointerDownCapture: $e99f3290c5edf271$var$abort,
        onPointerUpCapture: $e99f3290c5edf271$var$abort,
        onClickCapture: $e99f3290c5edf271$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $e99f3290c5edf271$var$abort
    } : events;
}

});

const $d7fb9960b511054e$export$d4c5499dc806c969 = ', Loading';

parcelRegister("hH1ET", function(module, exports) {

$parcel$export(module.exports, "default", () => $115b505739a5745b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gH0M0 = parcelRequire("gH0M0");
function $115b505739a5745b$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $115b505739a5745b$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $115b505739a5745b$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gH0M0.default), {
        size: $115b505739a5745b$var$getIconSpacing(spacing),
        appearance: $115b505739a5745b$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});




parcelRegister("03qtL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d041ab2f9e4a981eaa8c762be8ed9e47>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00a4d21f059e68dc$var$_react = $00a4d21f059e68dc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $00a4d21f059e68dc$var$_close = $00a4d21f059e68dc$var$_interopRequireDefault((parcelRequire("7p60P")));

var $00a4d21f059e68dc$var$_cross = $00a4d21f059e68dc$var$_interopRequireDefault((parcelRequire("jOLok")));
function $00a4d21f059e68dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00a4d21f059e68dc$var$CloseIcon = (props)=>/*#__PURE__*/ $00a4d21f059e68dc$var$_react.default.createElement($00a4d21f059e68dc$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $00a4d21f059e68dc$var$_cross.default
    }, props));
$00a4d21f059e68dc$var$CloseIcon.Name = 'CloseIconMigration';
var $00a4d21f059e68dc$var$_default = module.exports.default = $00a4d21f059e68dc$var$CloseIcon;

});

parcelRegister("hpb5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $9809036f89b5873a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2mwc3 = parcelRequire("2mwc3");

var $gA7wE = parcelRequire("gA7wE");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9809036f89b5873a$var$svgStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $gA7wE.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ const $9809036f89b5873a$var$SVG = /*#__PURE__*/ (0, $eUqFw.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $2mwc3.getBackground)()
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $9809036f89b5873a$var$svgStyles,
            (0, $gA7wE.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $9809036f89b5873a$export$2e2bcd8739ae039 = $9809036f89b5873a$var$SVG;

});

parcelRegister("4Bhom", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $f3f04bfc775d46a8$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $f3f04bfc775d46a8$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $f3f04bfc775d46a8$export$e2bd4c1faded7921);
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", () => $f3f04bfc775d46a8$export$89a980dfdf90df51);
$parcel$export(module.exports, "CSS_VAR_AVATAR_BGCOLOR", () => $f3f04bfc775d46a8$export$3c061e31594ebabe);
$parcel$export(module.exports, "ICON_SIZES", () => $f3f04bfc775d46a8$export$fdc820179f1f9be4);
$parcel$export(module.exports, "ICON_OFFSET", () => $f3f04bfc775d46a8$export$382610e783aa2ae8);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $3kxa0 = parcelRequire("3kxa0");
const $f3f04bfc775d46a8$export$9a270941bcff7e77 = {
    xsmall: (0, $3kxa0.gridSize)() * 2,
    small: (0, $3kxa0.gridSize)() * 3,
    medium: (0, $3kxa0.gridSize)() * 4,
    large: (0, $3kxa0.gridSize)() * 5,
    xlarge: (0, $3kxa0.gridSize)() * 12,
    xxlarge: (0, $3kxa0.gridSize)() * 16
};
const $f3f04bfc775d46a8$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $f3f04bfc775d46a8$export$e2bd4c1faded7921 = 2;
const $f3f04bfc775d46a8$export$89a980dfdf90df51 = 0.9;
const $f3f04bfc775d46a8$export$3c061e31594ebabe = '--avatar-background-color';
const $f3f04bfc775d46a8$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $f3f04bfc775d46a8$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("brPVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdd205fd21f12a339bebbba4cd2ce1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $855a7fbc1ba3cff3$var$_react = $855a7fbc1ba3cff3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $855a7fbc1ba3cff3$var$_UNSAFE_baseNew = $855a7fbc1ba3cff3$var$_interopRequireDefault((parcelRequire("li861")));
function $855a7fbc1ba3cff3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $855a7fbc1ba3cff3$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $855a7fbc1ba3cff3$var$_react.default.createElement($855a7fbc1ba3cff3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6 8.917.424-.619L6 8.008l-.424.29zM2.597 11.25l-.724-.194a.75.75 0 0 0 1.148.813zm1.07-3.986.724.194.124-.463-.368-.307zM.75 4.834l-.058-.748A.75.75 0 0 0 .27 5.41zm3.792-.292.057.747.473-.036.17-.442zM6 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.458 3.792-.7.269.17.442.473.036zm3.792.291.48.577a.75.75 0 0 0-.423-1.324zm-2.917 2.43-.48-.575-.368.307.124.463zm1.07 3.987-.424.618a.75.75 0 0 0 1.148-.812zM5.576 8.298l-3.403 2.334.848 1.236 3.403-2.333zm-2.254 3.146L4.39 7.458 2.942 7.07l-1.07 3.986zm.825-4.756L1.23 4.258.27 5.41l2.917 2.43zM.807 5.58 4.6 5.29l-.115-1.495-3.792.292zm4.435-.77L6.7 1.019 5.3.481 3.842 4.272zM5.3 1.019l1.458 3.792 1.4-.539L6.7.481zm2.1 4.27 3.793.292.114-1.495-3.791-.292zm3.37-1.032-2.917 2.43.96 1.153 2.917-2.43zM7.609 7.458l1.07 3.986 1.448-.388-1.07-3.986zm2.218 3.174L6.424 8.298l-.848 1.237 3.403 2.333z"/>`,
        type: 'utility'
    }, props));
$855a7fbc1ba3cff3$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $855a7fbc1ba3cff3$var$_default = module.exports.default = $855a7fbc1ba3cff3$var$StarUnstarredIcon;

});

parcelRegister("iLFZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a1dd140d6683a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bwLgX = parcelRequire("bwLgX");

var $ke7sb = parcelRequire("ke7sb");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $08a1dd140d6683a4$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $ke7sb.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwLgX.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }, baseProps.children);
}));
$08a1dd140d6683a4$var$Button.displayName = 'Button';
var $08a1dd140d6683a4$export$2e2bcd8739ae039 = $08a1dd140d6683a4$var$Button;

});
parcelRegister("ke7sb", function(module, exports) {

$parcel$export(module.exports, "default", () => $345722c7f4a137cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gGqNb = parcelRequire("gGqNb");

var $baaoB = parcelRequire("baaoB");

var $8ZSO9 = parcelRequire("8ZSO9");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ const $345722c7f4a137cb$var$useDefaultButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
    const baseProps = (0, $8ZSO9.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGqNb.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $baaoB.default), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGqNb.default), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGqNb.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $baaoB.default), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $345722c7f4a137cb$export$2e2bcd8739ae039 = $345722c7f4a137cb$var$useDefaultButton;

});


parcelRegister("6FoS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39d71a4269817ff$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $beTDx = parcelRequire("beTDx");
function $e39d71a4269817ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e39d71a4269817ff$var$baseStyles = {
    name: "1u0qf12",
    styles: "display:flex;position:static;flex-direction:column;overflow:auto"
};
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $e39d71a4269817ff$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $beTDx.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $beTDx.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $e39d71a4269817ff$var$baseStyles,
        "data-testid": testId,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    })));
var $e39d71a4269817ff$export$2e2bcd8739ae039 = $e39d71a4269817ff$var$MenuGroup;

});
parcelRegister("beTDx", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", () => $84734667a43456c6$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $84734667a43456c6$export$9ca534b70725964d);

var $eUqFw = parcelRequire("eUqFw");
const $84734667a43456c6$export$443076ec7ebce042 = /*#__PURE__*/ (0, $eUqFw.createContext)('cozy');
const $84734667a43456c6$export$9ca534b70725964d = /*#__PURE__*/ (0, $eUqFw.createContext)('border');

});


parcelRegister("2lKfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6949e0194d559e22$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $13Yvw = parcelRequire("13Yvw");

var $hWhcQ = parcelRequire("hWhcQ");

var $kvBX3 = parcelRequire("kvBX3");

var $en7tp = parcelRequire("en7tp");

var $4jL61 = parcelRequire("4jL61");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $6949e0194d559e22$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, cssFn: cssFn = (0, $hWhcQ.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $eUqFw.useContext)((0, $kvBX3.default));
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $hWhcQ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4jL61.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $en7tp.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children));
}));
var $6949e0194d559e22$export$2e2bcd8739ae039 = $6949e0194d559e22$var$ButtonItem;

});
parcelRegister("4jL61", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed436cf0f3677f12$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $13Yvw = parcelRequire("13Yvw");

var $5IVbS = parcelRequire("5IVbS");

var $98MGG = parcelRequire("98MGG");
var $a6rx8 = parcelRequire("a6rx8");
var $9RTEO = parcelRequire("9RTEO");


var $beTDx = parcelRequire("beTDx");
function $ed436cf0f3677f12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ed436cf0f3677f12$var$defaultRender = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)(Component, props);
const $ed436cf0f3677f12$var$beforeAfterElementStyles = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $ed436cf0f3677f12$var$contentStyles = (0, $9RTEO.xcss)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
const $ed436cf0f3677f12$var$truncateStyles = {
    name: "hdknak",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $ed436cf0f3677f12$var$titleStyles = {
    name: "183yev2",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $ed436cf0f3677f12$var$wordBreakStyles = {
    name: "1sdjnkx",
    styles: "word-break:break-word"
};
const $ed436cf0f3677f12$var$descriptionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtlest, ${(0, $753dd713deeb1c87$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $ed436cf0f3677f12$var$disabledDescriptionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $753dd713deeb1c87$export$f563ee71e9ee74cd)})`
});
const $ed436cf0f3677f12$var$positionRelativeStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $ed436cf0f3677f12$var$primitiveStyles = {
    name: "vfenhj",
    styles: "display:flex;box-sizing:border-box;width:100%;min-height:40px;margin:var(--ds-space-0, 0px);align-items:center;border:0;outline:0;text-decoration:none;user-select:none;&::-moz-focus-inner{border:0;}&:hover{text-decoration:none;}"
};
const $ed436cf0f3677f12$var$spacingMapStyles = {
    cozy: {
        name: "1x13z0k",
        styles: "padding-block:var(--ds-space-100, 8px);padding-inline:var(--ds-space-200, 16px)"
    },
    compact: {
        name: "1xdhs5i",
        styles: "min-height:32px;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-150, 12px)"
    }
};
const $ed436cf0f3677f12$var$interactiveStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $ed436cf0f3677f12$var$unselectedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $753dd713deeb1c87$export$9fdfb749e33cdf97)})`,
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $753dd713deeb1c87$export$3e51e8f1440314ba)})`,
        boxShadow: 'none',
        color: 'currentColor'
    }
});
const $ed436cf0f3677f12$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: `var(--ds-text-disabled, ${(0, $753dd713deeb1c87$export$f563ee71e9ee74cd)})`
    }
});
const $ed436cf0f3677f12$var$selectedBorderStyles = {
    name: "1dgy7ry",
    styles: "&::before{width:2px;position:absolute;background:var(--ds-border-selected, transparent);content:\"\";inset-block-end:0;inset-block-start:0;inset-inline-start:0;}"
};
const $ed436cf0f3677f12$var$selectedNotchStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: `0 ${"var(--ds-border-radius, 4px)"} ${"var(--ds-border-radius, 4px)"} 0`,
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
const $ed436cf0f3677f12$var$selectedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${(0, $753dd713deeb1c87$export$9fdfb749e33cdf97)})`,
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $753dd713deeb1c87$export$9fdfb749e33cdf97)})`,
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $753dd713deeb1c87$export$3e51e8f1440314ba)})`,
        color: "var(--ds-text-selected, currentColor)"
    }
});
const $ed436cf0f3677f12$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $ed436cf0f3677f12$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, testId: testId })=>{
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const spacing = (0, $eUqFw.useContext)((0, $beTDx.SpacingContext));
    const selectionStyle = (0, $eUqFw.useContext)((0, $beTDx.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const renderTitle = overrides && overrides.Title && overrides.Title.render || $ed436cf0f3677f12$var$defaultRender;
    const UNSAFE_className = UNSAFE_externalClassName;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: cn, cx: cx })=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $5IVbS.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $ed436cf0f3677f12$var$positionRelativeStyles,
                    $ed436cf0f3677f12$var$primitiveStyles,
                    $ed436cf0f3677f12$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $ed436cf0f3677f12$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $ed436cf0f3677f12$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $ed436cf0f3677f12$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $ed436cf0f3677f12$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $ed436cf0f3677f12$var$disabledStyles : $ed436cf0f3677f12$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $98MGG.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $ed436cf0f3677f12$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-elem-before": true,
                css: $ed436cf0f3677f12$var$beforeAfterElementStyles,
                "data-testid": testId && `${testId}--icon-before`
            }, iconBefore), title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $a6rx8.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: $ed436cf0f3677f12$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn($ed436cf0f3677f12$var$titleStyles, shouldTitleWrap ? $ed436cf0f3677f12$var$wordBreakStyles : $ed436cf0f3677f12$var$truncateStyles),
                'data-item-title': true
            }), description && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-description": true,
                css: [
                    $ed436cf0f3677f12$var$descriptionStyles,
                    isDisabled && $ed436cf0f3677f12$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $ed436cf0f3677f12$var$wordBreakStyles : $ed436cf0f3677f12$var$truncateStyles
                ]
            }, description)), iconAfter && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-elem-after": true,
                css: $ed436cf0f3677f12$var$beforeAfterElementStyles,
                "data-testid": testId && `${testId}--icon-after`
            }, iconAfter))
        }));
    });
};
var $ed436cf0f3677f12$export$2e2bcd8739ae039 = $ed436cf0f3677f12$var$MenuItemPrimitive;

});


parcelRegister("h6Qt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e46a476b13d016$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $13Yvw = parcelRequire("13Yvw");

var $hWhcQ = parcelRequire("hWhcQ");

var $kvBX3 = parcelRequire("kvBX3");

var $en7tp = parcelRequire("en7tp");

var $4jL61 = parcelRequire("4jL61");
const $50e46a476b13d016$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $50e46a476b13d016$var$CustomItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ component: Component, cssFn: cssFn = (0, $hWhcQ.default), isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $eUqFw.useContext)((0, $kvBX3.default));
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $hWhcQ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4jL61.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $50e46a476b13d016$var$preventEvent
            },
            onMouseDown: isDisabled ? $50e46a476b13d016$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $50e46a476b13d016$var$preventEvent : (0, $en7tp.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }, children));
}));
var $50e46a476b13d016$export$2e2bcd8739ae039 = $50e46a476b13d016$var$CustomItem;

});

parcelRegister("ikrXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $302356b5ba2e0b6c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dt2tg = parcelRequire("dt2tg");

var $13Yvw = parcelRequire("13Yvw");

var $hWhcQ = parcelRequire("hWhcQ");

var $kvBX3 = parcelRequire("kvBX3");

var $en7tp = parcelRequire("en7tp");

var $4jL61 = parcelRequire("4jL61");
const $302356b5ba2e0b6c$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $302356b5ba2e0b6c$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $302356b5ba2e0b6c$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $302356b5ba2e0b6c$var$LinkItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, href: href, cssFn: cssFn = (0, $hWhcQ.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $dt2tg.default)();
    const interactionContext = (0, $eUqFw.useContext)((0, $kvBX3.default));
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $302356b5ba2e0b6c$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $302356b5ba2e0b6c$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $hWhcQ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4jL61.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item",
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // @ts-expect-error
            href: isDisabled ? undefined : href,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $302356b5ba2e0b6c$var$preventEvent
            },
            onMouseDown: isDisabled ? $302356b5ba2e0b6c$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $302356b5ba2e0b6c$var$preventEvent : (0, $en7tp.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }, children));
}));
var $302356b5ba2e0b6c$export$2e2bcd8739ae039 = $302356b5ba2e0b6c$var$LinkItem;

});

parcelRegister("bUAoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e60513572ba979$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview */ /**
                                                                                                                                   * @jsxRuntime classic
                                                                                                                                   * @jsx jsx
                                                                                                                                   */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $13Yvw = parcelRequire("13Yvw");

var $en7tp = parcelRequire("en7tp");


var $3kxa0 = parcelRequire("3kxa0");

var $a22zx = parcelRequire("a22zx");

var $86WYw = parcelRequire("86WYw");
function $01e60513572ba979$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01e60513572ba979$var$gridSize = (0, $3kxa0.gridSize)();
const $01e60513572ba979$var$itemHeadingTopMargin = $01e60513572ba979$var$gridSize * 2.5;
const $01e60513572ba979$var$itemHeadingBottomMargin = $01e60513572ba979$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $01e60513572ba979$var$itemHeadingContentHeight = (0, $a22zx.headingSizes).h100.lineHeight;
const $01e60513572ba979$var$skeletonHeadingHeight = $01e60513572ba979$var$gridSize;
const $01e60513572ba979$var$skeletonHeadingMarginOffset = 3;
const $01e60513572ba979$var$skeletonHeadingTopMargin = $01e60513572ba979$var$itemHeadingTopMargin + ($01e60513572ba979$var$itemHeadingContentHeight - $01e60513572ba979$var$skeletonHeadingHeight) - $01e60513572ba979$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $01e60513572ba979$var$skeletonHeadingBottomMargin = $01e60513572ba979$var$itemHeadingBottomMargin + $01e60513572ba979$var$skeletonHeadingMarginOffset;
const $01e60513572ba979$var$sectionPaddingTopBottom = $01e60513572ba979$var$gridSize * 0.75;
const $01e60513572ba979$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
const $01e60513572ba979$var$sectionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $01e60513572ba979$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $01e60513572ba979$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $01e60513572ba979$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $01e60513572ba979$var$itemHeadingTopMargin - $01e60513572ba979$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $01e60513572ba979$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $01e60513572ba979$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $01e60513572ba979$var$skeletonHeadingTopMargin - $01e60513572ba979$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
const $01e60513572ba979$var$scrollableStyles = {
    name: "qji62u",
    styles: "flex-shrink:1;overflow:auto"
};
const $01e60513572ba979$var$unscrollableStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $01e60513572ba979$var$thickSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockStart: `2px solid var(${$01e60513572ba979$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $753dd713deeb1c87$export$920c0d5c49070351)})`})`
});
const $01e60513572ba979$var$thinSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockStart: `1px solid var(${$01e60513572ba979$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $753dd713deeb1c87$export$920c0d5c49070351)})`})`
});
const $01e60513572ba979$var$noSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $01e60513572ba979$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, overrides: overrides, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    const content = isList ? /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $eUqFw.Children).map((0, $eUqFw.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $byn9U.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $86WYw.default), {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: UNSAFE_headingOverrides,
        testId: testId && `${testId}--heading`,
        "aria-hidden": true
    }, title), content) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, content);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        css: [
            $01e60513572ba979$var$sectionStyles,
            isScrollable ? $01e60513572ba979$var$scrollableStyles : $01e60513572ba979$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $en7tp.fg)('platform.design-system-team.section-1px-seperator-borders') ? $01e60513572ba979$var$thinSeparatorStyles : $01e60513572ba979$var$thickSeparatorStyles : $01e60513572ba979$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $01e60513572ba979$export$2e2bcd8739ae039 = $01e60513572ba979$var$Section;

});
parcelRegister("86WYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d429433d6ded23b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $13Yvw = parcelRequire("13Yvw");

var $hWhcQ = parcelRequire("hWhcQ");

const $4d429433d6ded23b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$e2ef2124cf4024b1)})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $4d429433d6ded23b$var$HeadingItem = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, cssFn: cssFn = (0, $hWhcQ.default), // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $hWhcQ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $byn9U.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $4d429433d6ded23b$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    }, children);
});
var $4d429433d6ded23b$export$2e2bcd8739ae039 = $4d429433d6ded23b$var$HeadingItem;

});


parcelRegister("kkFNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d89ac6878708374$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1XW1C = parcelRequire("1XW1C");

var $agJNB = parcelRequire("agJNB");

var $5IVbS = parcelRequire("5IVbS");

var $en7tp = parcelRequire("en7tp");


var $a6GTL = parcelRequire("a6GTL");

var $4Bhom = parcelRequire("4Bhom");

var $6BM5w = parcelRequire("6BM5w");

var $5u5KR = parcelRequire("5u5KR");

var $1ULE3 = parcelRequire("1ULE3");

var $gPV2S = parcelRequire("gPV2S");
const $9d89ac6878708374$var$packageName = "platform-pkg";
const $9d89ac6878708374$var$packageVersion = "0.0.0-use.local";
const $9d89ac6878708374$var$getTestId = (testId, children)=>!children ? {
        'data-testid': `${testId}--inner`
    } : {
        testId: `${testId}--inner`
    };
const $9d89ac6878708374$var$getStyles = (css, { size: size, radius: radius, appearance: appearance, borderColor: borderColor = (0, $en7tp.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-surface-overlay, ${0, $753dd713deeb1c87$export$29a4f05edc054374})`, stackIndex: stackIndex, isInteractive: isInteractive, isDisabled: isDisabled })=>//eslint-disable-next-line @repo/internal/react/no-css-string-literals
    css`
		height: ${size}px;
		width: ${size}px;
		align-items: stretch;
		background-color: ${borderColor};
		border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
		box-sizing: content-box;
		cursor: inherit;
		display: flex;
		flex-direction: column;
		justify-content: center;
		outline: none;
		overflow: hidden;
		position: static;
		transform: translateZ(0);
		transition:
			transform 200ms,
			opacity 200ms;
		box-shadow: 0 0 0 ${0, $4Bhom.BORDER_WIDTH}px ${borderColor};
		border: none;
		margin: ${"var(--ds-space-025, 2px)"};
		padding: ${"var(--ds-space-0, 0px)"};

		&::-moz-focus-inner {
			border: 0;
			margin: ${"var(--ds-space-0, 0px)"};
			padding: ${"var(--ds-space-0, 0px)"};
		}

		&::after {
			background-color: transparent;
			inset: 0px;

			/* Added border-radius style to fix hover issue in safari */
			border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
			content: ' ';
			opacity: 0;
			pointer-events: none;
			position: absolute;
			transition: opacity 200ms;
			width: 100%;
		}

		:focus {
			box-shadow: none;
		}

		${stackIndex && `position: relative;`}

		${isInteractive && `
      cursor: pointer;

      :hover {
        &::after {
          background-color: ${`var(--ds-interaction-hovered, ${0, $753dd713deeb1c87$export$6e5e7499ff054f6d})`};
          opacity: 1;
        }
      }

      :active {
        &::after {
          background-color: ${`var(--ds-interaction-pressed, ${0, $753dd713deeb1c87$export$6e5e7499ff054f6d})`};
          opacity: 1;
        }
      }

      :active {
        transform: scale(${0, $4Bhom.ACTIVE_SCALE_FACTOR});
      }

      @media screen and (forced-colors: active) {
        &:focus-visible {
          outline: 1px solid
        }
      }
    `}

    ${isDisabled && `
        cursor: not-allowed;

        &::after {
          opacity: ${"var(--ds-opacity-disabled, 0.7)"};
          pointer-events: none;
          background-color: ${`var(--ds-surface, ${0, $753dd713deeb1c87$export$29a4f05edc054374})`};
        }
      `}
	`;
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $9d89ac6878708374$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div' }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1XW1C.useAnalyticsEvents)();
    const context = (0, $6BM5w.useAvatarContext)();
    const size = sizeProp ?? context?.size ?? 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $eUqFw.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $eUqFw.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $eUqFw.useRef)(analyticsContext);
    const labelId = (0, $agJNB.useId)();
    (0, $eUqFw.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $9d89ac6878708374$var$packageName,
                packageVersion: $9d89ac6878708374$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $9d89ac6878708374$var$packageName,
            packageVersion: $9d89ac6878708374$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $gPV2S.getLinkProps)(href, target),
            ...onClick && !href ? (0, $gPV2S.getButtonProps)(onClickHandler) : {
                onClick: onClick
            }
        };
    };
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            className: $9d89ac6878708374$var$getStyles(css, {
                size: (0, $4Bhom.AVATAR_SIZES)[size],
                radius: (0, $4Bhom.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && $9d89ac6878708374$var$getTestId(testId, children),
            ...(isInteractive || children) && {
                'aria-label': label || defaultLabel
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $a6GTL.default), {
                // Only pass in the name if an image is provided and the
                // container is not being used as an `img` role
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        };
        if (children) return children(props);
        const element = (0, $gPV2S.getCustomElement)(isDisabled, href, onClick);
        return element === 'a' || element === 'button' ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5IVbS.default), null, /*#__PURE__*/ (0, $eUqFw.createElement)(element, props)) : /*#__PURE__*/ (0, $eUqFw.createElement)(element, props);
    }), isPresence && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5u5KR.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1ULE3.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId && `${testId}--label`,
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined);
});
$9d89ac6878708374$var$Avatar.displayName = 'Avatar';
var $9d89ac6878708374$export$2e2bcd8739ae039 = $9d89ac6878708374$var$Avatar;

});
parcelRegister("a6GTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $20872122087f1856$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $glBsg = parcelRequire("glBsg");

var $gQU84 = parcelRequire("gQU84");

var $9wrY8 = parcelRequire("9wrY8");

var $aOoYP = parcelRequire("aOoYP");

var $en7tp = parcelRequire("en7tp");


var $4Bhom = parcelRequire("4Bhom");
function $20872122087f1856$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $20872122087f1856$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: `var(--ds-icon-subtle, ${(0, $753dd713deeb1c87$export$7c87d337fb91a97d)})`
});
const $20872122087f1856$var$avatarDefaultIconVisualRefreshStyles = {
    name: "dg8dij",
    styles: "display:block;width:100%;height:100%;background-color:var(--ds-background-accent-gray-subtler, #DCDFE4)"
};
const $20872122087f1856$var$nestedAvatarStyles = Object.entries((0, $4Bhom.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size}px`
            }
        })
    };
}, {});
const $20872122087f1856$var$avatarImageStyles = {
    name: "1gr7gcv",
    styles: "display:flex;width:100%;height:100%;flex:1 1 100%"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $20872122087f1856$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
    const borderRadius = appearance === 'circle' ? '50%' : `${(0, $4Bhom.AVATAR_RADIUS)[size]}px`;
    const isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $eUqFw.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $en7tp.fg)('platform-component-visual-refresh') ? $20872122087f1856$var$avatarDefaultIconVisualRefreshStyles : $20872122087f1856$var$avatarDefaultIconStyles,
            $20872122087f1856$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? (0, $en7tp.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($glBsg))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && `${testId}--person`,
        spacing: "spacious"
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9wrY8))), {
        label: alt,
        primaryColor: `var(--ds-icon-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
        secondaryColor: `var(--ds-icon-subtle, ${(0, $753dd713deeb1c87$export$7c87d337fb91a97d)})`,
        testId: testId && `${testId}--person`,
        "aria-hidden": isHidden
    }) : (0, $en7tp.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gQU84))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && `${testId}--ship`,
        spacing: "spacious"
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOoYP))), {
        label: alt,
        primaryColor: `var(--ds-icon-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
        secondaryColor: `var(--ds-icon-subtle, ${(0, $753dd713deeb1c87$export$7c87d337fb91a97d)})`,
        testId: testId && `${testId}--ship`,
        "aria-hidden": isHidden
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $20872122087f1856$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": isHidden,
        "data-vc": testId ? `${testId}--image` : 'avatar-image'
    });
};
var $20872122087f1856$export$2e2bcd8739ae039 = $20872122087f1856$var$AvatarImage;

});

parcelRegister("6BM5w", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", () => $cb79bfe8dcbf4a48$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $cb79bfe8dcbf4a48$export$b50b87a1c4086b23);

var $eUqFw = parcelRequire("eUqFw");
const $cb79bfe8dcbf4a48$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $cb79bfe8dcbf4a48$export$b50b87a1c4086b23 = ()=>(0, $eUqFw.useContext)($cb79bfe8dcbf4a48$export$a20dad690e1279e2);

});

parcelRegister("5u5KR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bcde9278f69cdc5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PresenceWrapper", () => $8bcde9278f69cdc5$export$972c5e90200fa0ef);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");


var $4Bhom = parcelRequire("4Bhom");

var $dnrta = parcelRequire("dnrta");
const $8bcde9278f69cdc5$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-danger, ${(0, $753dd713deeb1c87$export$4a7404f376229999)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
const $8bcde9278f69cdc5$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-icon-discovery, ${(0, $753dd713deeb1c87$export$b48405b95304b5a1)})`,
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
const $8bcde9278f69cdc5$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-text-subtlest, ${(0, $753dd713deeb1c87$export$f563ee71e9ee74cd)})`,
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$1ce2d1575d444ceb)})`,
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
const $8bcde9278f69cdc5$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-success, ${(0, $753dd713deeb1c87$export$940e1f69e873f202)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $8bcde9278f69cdc5$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $8bcde9278f69cdc5$var$BusyIndicator;
        case 'focus':
            return $8bcde9278f69cdc5$var$FocusIndicator;
        case 'offline':
            return $8bcde9278f69cdc5$var$OfflineIndicator;
        case 'online':
            return $8bcde9278f69cdc5$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $8bcde9278f69cdc5$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnrta.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $8bcde9278f69cdc5$var$getPresence(presence)) : children);
var $8bcde9278f69cdc5$export$2e2bcd8739ae039 = $8bcde9278f69cdc5$var$AvatarPresence;
const $8bcde9278f69cdc5$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    const position = appearance === 'square' ? -4 : (0, $4Bhom.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            bottom: `${position}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${(0, $4Bhom.ICON_SIZES)[size]}px`,
            right: `${position}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $4Bhom.ICON_SIZES)[size]}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bcde9278f69cdc5$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("dnrta", function(module, exports) {

$parcel$export(module.exports, "default", () => $049bc33fa4e8ba95$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $byn9U = parcelRequire("byn9U");


var $4Bhom = parcelRequire("4Bhom");
function $049bc33fa4e8ba95$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $049bc33fa4e8ba95$var$iconWrapperStyles = {
    name: "1kwqznv",
    styles: "display:flex;box-sizing:border-box;width:100%;height:100%;align-items:center;align-content:center;border-radius:var(--ds-border-radius-circle, 50%);overflow:hidden"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $049bc33fa4e8ba95$var$IconWrapper = ({ bgColor: bgColor = `var(--ds-surface-overlay, ${0, $753dd713deeb1c87$export$29a4f05edc054374})`, children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $049bc33fa4e8ba95$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: `${(0, $4Bhom.BORDER_WIDTH)}px solid ${bgColor}`,
            backgroundColor: bgColor
        }
    }, children);
var $049bc33fa4e8ba95$export$2e2bcd8739ae039 = $049bc33fa4e8ba95$var$IconWrapper;

});


parcelRegister("1ULE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bea0c92ddc20472$export$2e2bcd8739ae039);
$parcel$export(module.exports, "StatusWrapper", () => $9bea0c92ddc20472$export$8045894f255f9726);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");


var $4Bhom = parcelRequire("4Bhom");

var $dnrta = parcelRequire("dnrta");
const $9bea0c92ddc20472$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-success, ${(0, $753dd713deeb1c87$export$a49394138f7b8e85)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
const $9bea0c92ddc20472$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-danger, ${(0, $753dd713deeb1c87$export$2010d0fb4295b346)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
const $9bea0c92ddc20472$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-text-subtlest, ${(0, $753dd713deeb1c87$export$1ce2d1575d444ceb)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $753dd713deeb1c87$export$c39c0fe0f26207ae)})`,
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $9bea0c92ddc20472$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $9bea0c92ddc20472$var$ApprovedIndicator;
        case 'declined':
            return $9bea0c92ddc20472$var$DeclinedIndicator;
        case 'locked':
            return $9bea0c92ddc20472$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $9bea0c92ddc20472$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnrta.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $9bea0c92ddc20472$var$getStatus(status)) : children);
var $9bea0c92ddc20472$export$2e2bcd8739ae039 = $9bea0c92ddc20472$var$AvatarStatus;
const $9bea0c92ddc20472$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    const position = appearance === 'square' ? 0 : (0, $4Bhom.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${(0, $4Bhom.ICON_SIZES)[size]}px`,
            right: `${position}px`,
            top: `${position}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $4Bhom.ICON_SIZES)[size]}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bea0c92ddc20472$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("gPV2S", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", () => $ab6c5b52476a2718$export$60113ebe1cf0ecf);
$parcel$export(module.exports, "getButtonProps", () => $ab6c5b52476a2718$export$cca6f1bef43616d3);
$parcel$export(module.exports, "getCustomElement", () => $ab6c5b52476a2718$export$83ee468102cdf04c);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
const $ab6c5b52476a2718$export$60113ebe1cf0ecf = (href, target)=>({
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    });
const $ab6c5b52476a2718$export$cca6f1bef43616d3 = (onClick)=>({
        type: 'button',
        onClick: onClick
    });
const $ab6c5b52476a2718$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});


parcelRegister("cWB9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b51039939daec4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $en7tp = parcelRequire("en7tp");

var $51h8o = parcelRequire("51h8o");
var $9RTEO = parcelRequire("9RTEO");
function $83b51039939daec4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $83b51039939daec4$var$baseStylesOld = (0, $9RTEO.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $83b51039939daec4$var$styles = {
    container: {
        name: "1s8rs5f",
        styles: "display:inline-flex;box-sizing:border-box;position:static;block-size:min-content;border-radius:3px;overflow:hidden;padding-inline:var(--ds-space-050, 4px)"
    },
    background: {
        bold: {
            default: {
                name: "1007ca",
                styles: "background-color:#DDDEE1"
            },
            inprogress: {
                name: "5nwhd8",
                styles: "background-color:#8FB8F6"
            },
            moved: {
                name: "1v45608",
                styles: "background-color:#F9C84E"
            },
            new: {
                name: "1ra4w2w",
                styles: "background-color:#D8A0F7"
            },
            removed: {
                name: "1y25gsq",
                styles: "background-color:#FD9891"
            },
            success: {
                name: "2bpbki",
                styles: "background-color:#B3DF72"
            }
        },
        subtle: {
            default: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            inprogress: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            moved: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            new: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            removed: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            success: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    },
    border: {
        subtle: {
            default: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #94C748`
            })
        }
    },
    text: {
        subtle: {
            name: "nws7uq",
            styles: "color:var(--ds-text, #172B4D)"
        },
        bold: {
            name: "14qj9ca",
            styles: "color:#292A2E"
        }
    }
};
const $83b51039939daec4$var$textStyles = {
    name: "1bkq1y7",
    styles: "font-family:ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif;font-size:11px;font-style:normal;font-weight:var(--ds-font-weight-bold, 700);line-height:16px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $83b51039939daec4$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $83b51039939daec4$var$styles.background[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $en7tp.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $83b51039939daec4$var$styles.container,
            $83b51039939daec4$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && $83b51039939daec4$var$styles.border.subtle[appearanceType]
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $83b51039939daec4$var$textStyles,
            $83b51039939daec4$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
    const appearanceTypeOld = appearance in $83b51039939daec4$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51h8o.default), {
        as: "span",
        backgroundColor: $83b51039939daec4$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $83b51039939daec4$var$baseStylesOld,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $83b51039939daec4$var$textStyles,
            $83b51039939daec4$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$83b51039939daec4$var$Lozenge.displayName = 'Lozenge';
var $83b51039939daec4$export$2e2bcd8739ae039 = $83b51039939daec4$var$Lozenge;
const $83b51039939daec4$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $83b51039939daec4$var$textColorsOld = {
    bold: {
        default: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        inprogress: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        moved: {
            name: "tgubtb",
            styles: "color:var(--ds-text-warning-inverse, #172B4D)"
        },
        new: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        removed: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        success: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        default: {
            name: "kmxsjg",
            styles: "color:var(--ds-text-subtle, #42526E)"
        },
        inprogress: {
            name: "3j31nl",
            styles: "color:var(--ds-text-information, #0052CC)"
        },
        moved: {
            name: "1g2i1rp",
            styles: "color:var(--ds-text-warning, #974F0C)"
        },
        new: {
            name: "3juofh",
            styles: "color:var(--ds-text-discovery, #403294)"
        },
        removed: {
            name: "18zo14t",
            styles: "color:var(--ds-text-danger, #DE350B)"
        },
        success: {
            name: "1ychrch",
            styles: "color:var(--ds-text-success, #006644)"
        }
    }
};

});

parcelRegister("fk75J", function(module, exports) {

$parcel$export(module.exports, "default", () => $724be2f0d1349ccf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $13Yvw = parcelRequire("13Yvw");

var $hWhcQ = parcelRequire("hWhcQ");


var $3kxa0 = parcelRequire("3kxa0");

var $gNpMk = parcelRequire("gNpMk");
function $724be2f0d1349ccf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $724be2f0d1349ccf$var$gridSize = (0, $3kxa0.gridSize)();
const $724be2f0d1349ccf$var$borderRadius = (0, $3kxa0.borderRadius)();
const $724be2f0d1349ccf$var$itemElemSpacing = $724be2f0d1349ccf$var$gridSize * 1.5;
const $724be2f0d1349ccf$var$itemExpectedElemSize = $724be2f0d1349ccf$var$gridSize * 3;
const $724be2f0d1349ccf$var$itemMinHeight = $724be2f0d1349ccf$var$gridSize * 5;
const $724be2f0d1349ccf$var$skeletonItemElemSize = $724be2f0d1349ccf$var$gridSize * 2.5;
const $724be2f0d1349ccf$var$itemElemSkeletonOffset = ($724be2f0d1349ccf$var$itemExpectedElemSize - $724be2f0d1349ccf$var$skeletonItemElemSize) / 2;
const $724be2f0d1349ccf$var$skeletonTextBorderRadius = 100;
const $724be2f0d1349ccf$var$skeletonContentHeight = 9;
const $724be2f0d1349ccf$var$skeletonColor = `var(--ds-skeleton, ${(0, $753dd713deeb1c87$export$8d43898f60b96a82)})`;
const $724be2f0d1349ccf$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: $724be2f0d1349ccf$var$itemMinHeight,
    padding: `0 ${"var(--ds-space-250, 20px)"}`,
    alignItems: 'center',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        height: $724be2f0d1349ccf$var$skeletonContentHeight,
        backgroundColor: $724be2f0d1349ccf$var$skeletonColor,
        borderRadius: $724be2f0d1349ccf$var$skeletonTextBorderRadius,
        content: '""',
        // This is a little bespoke but we need to push everything down 1px
        // because the skeleton content should align to the bottom of the text.
        // Confirm VR test failures before accepting a change.
        marginBlockStart: 1
    }
});
const $724be2f0d1349ccf$var$defaultWidthStyles = {
    name: "sljcv5",
    styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
};
const $724be2f0d1349ccf$var$customWidthStyles = {
    name: "nsk3fe",
    styles: "::after{flex-basis:var(--width);}"
};
const $724be2f0d1349ccf$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: $724be2f0d1349ccf$var$skeletonItemElemSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $724be2f0d1349ccf$var$skeletonItemElemSize,
        flexShrink: 0,
        backgroundColor: $724be2f0d1349ccf$var$skeletonColor,
        content: '""',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginInlineEnd: $724be2f0d1349ccf$var$itemElemSpacing + $724be2f0d1349ccf$var$itemElemSkeletonOffset,
        marginInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $724be2f0d1349ccf$var$avatarStyles = {
    name: "lz1zvf",
    styles: "::before{border-radius:100%;}"
};
const $724be2f0d1349ccf$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $724be2f0d1349ccf$var$borderRadius
    }
});
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $724be2f0d1349ccf$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $hWhcQ.default) })=>{
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $hWhcQ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $byn9U.css)(cssFn());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gNpMk.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $724be2f0d1349ccf$var$skeletonStyles,
                (hasAvatar || hasIcon) && $724be2f0d1349ccf$var$beforeElementStyles,
                hasAvatar && $724be2f0d1349ccf$var$avatarStyles,
                hasIcon && $724be2f0d1349ccf$var$iconStyles,
                width ? $724be2f0d1349ccf$var$customWidthStyles : $724be2f0d1349ccf$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-testid": testId
        }));
};
var $724be2f0d1349ccf$export$2e2bcd8739ae039 = $724be2f0d1349ccf$var$SkeletonItem;

});
parcelRegister("gNpMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $85c3af9e913482a4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

/**
 * These keyframes are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $85c3af9e913482a4$var$shimmerKeyframes = (0, $byn9U.keyframes)({
    from: {
        backgroundColor: `var(--ds-skeleton, ${(0, $753dd713deeb1c87$export$8d43898f60b96a82)})`
    },
    to: {
        backgroundColor: `var(--ds-skeleton-subtle, ${(0, $753dd713deeb1c87$export$920c0d5c49070351)})`
    }
});
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $85c3af9e913482a4$var$shimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before, ::after': {
        animationDirection: 'alternate',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationName: `${$85c3af9e913482a4$var$shimmerKeyframes}`,
        animationTimingFunction: 'linear',
        backgroundColor: `var(--ds-skeleton, ${(0, $753dd713deeb1c87$export$8d43898f60b96a82)})`
    }
});
/**
 * __Skeleton shimmer__
 *
 * A skeleton shimmer is the animation shown on loading skeletons for
 * perceived performance and user satisfaction.
 *
 * This component provides a `className` through render props. This value will
 * have type:
 * + `string`, when `isShimmering={true}`.
 * + `undefined`, when `isShimmering={false}`.
 *
 * @internal
 */ const $85c3af9e913482a4$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
            className: isShimmering ? css($85c3af9e913482a4$var$shimmerStyles) : undefined
        }));
};
var $85c3af9e913482a4$export$2e2bcd8739ae039 = $85c3af9e913482a4$var$SkeletonShimmer;

});


parcelRegister("4Ud4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e3ed40eab0bfe7$export$2e2bcd8739ae039);

var $en7tp = parcelRequire("en7tp");

var $jDQ57 = parcelRequire("jDQ57");

var $e6GUV = parcelRequire("e6GUV");

var $8bL6n = parcelRequire("8bL6n");

var $bzjm2 = parcelRequire("bzjm2");

var $5rhS8 = parcelRequire("5rhS8");
const $f5e3ed40eab0bfe7$var$defaultColorMode = 'light';
const $f5e3ed40eab0bfe7$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $f5e3ed40eab0bfe7$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $e6GUV.themeStateDefaults)['colorMode'], dark: dark = (0, $e6GUV.themeStateDefaults)['dark'], light: light = (0, $e6GUV.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $e6GUV.themeStateDefaults)['contrastMode'], shape: shape = (0, $e6GUV.themeStateDefaults)['shape'], spacing: spacing = (0, $e6GUV.themeStateDefaults)['spacing'], typography: typography = (0, $e6GUV.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $e6GUV.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $8bL6n.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $jDQ57.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $jDQ57.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $f5e3ed40eab0bfe7$var$defaultColorMode : colorMode
    };
    if ((0, $en7tp.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $jDQ57.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $f5e3ed40eab0bfe7$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $bzjm2.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $5rhS8.hash)(optionString);
        result[0, $jDQ57.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $f5e3ed40eab0bfe7$export$2e2bcd8739ae039 = $f5e3ed40eab0bfe7$var$getThemeHtmlAttrs;

});
parcelRegister("bzjm2", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $5bc06edc36efed60$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $5bc06edc36efed60$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $5bc06edc36efed60$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $5bc06edc36efed60$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $5bc06edc36efed60$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $5bc06edc36efed60$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $5bc06edc36efed60$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $5bc06edc36efed60$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $5bc06edc36efed60$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $5bc06edc36efed60$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $5bc06edc36efed60$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $5bc06edc36efed60$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $5bc06edc36efed60$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $5bc06edc36efed60$export$b36dbdb4f463f05c(hex) {
    if (!$5bc06edc36efed60$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $5bc06edc36efed60$export$1212645cf40ebf71(hex)
    ];
}
function $5bc06edc36efed60$export$5a544e13ad4e1fa5(hex) {
    if (!$5bc06edc36efed60$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $5bc06edc36efed60$export$47ea145a83f50dc0(hex) {
    if (!$5bc06edc36efed60$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $5bc06edc36efed60$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $5bc06edc36efed60$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $5bc06edc36efed60$export$d061e26956a60b0a(foreground, background) {
    if (!$5bc06edc36efed60$var$isValidHex(foreground) || !$5bc06edc36efed60$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $5bc06edc36efed60$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $5bc06edc36efed60$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $5bc06edc36efed60$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $5bc06edc36efed60$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $5bc06edc36efed60$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $5bc06edc36efed60$var$rgbToLab(rgbA);
    let labB = $5bc06edc36efed60$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $5bc06edc36efed60$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("5rhS8", function(module, exports) {

$parcel$export(module.exports, "hash", () => $cdd596130d266377$export$d6af199866bfb566);
const $cdd596130d266377$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("cmU61", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", () => $44449afc432d98d3$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $44449afc432d98d3$export$5d76d7014f4a5d08);

var $en7tp = parcelRequire("en7tp");

var $eg3uU = parcelRequire("eg3uU");
const $44449afc432d98d3$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $en7tp.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $eg3uU.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $en7tp.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $eg3uU.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $44449afc432d98d3$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("eg3uU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe9e8441d4f31d9f$export$2e2bcd8739ae039);

var $e6GUV = parcelRequire("e6GUV");
function $fe9e8441d4f31d9f$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $e6GUV.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("6K9n3", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", () => $dfbde982b6068d7e$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $dfbde982b6068d7e$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $dfbde982b6068d7e$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $dfbde982b6068d7e$export$8662df6937d86fcb);

var $en7tp = parcelRequire("en7tp");

var $2WT6V = parcelRequire("2WT6V");

var $jDQ57 = parcelRequire("jDQ57");
const $dfbde982b6068d7e$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $jDQ57.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $jDQ57.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $dfbde982b6068d7e$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $dfbde982b6068d7e$export$8a48286ed7df6720 = async (themeId)=>{
    if ((themeId === 'light' || themeId === 'dark') && (0, $en7tp.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
    const { default: themeCss } = await (0, $2WT6V.default)[themeId]();
    return themeCss;
};
const $dfbde982b6068d7e$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $dfbde982b6068d7e$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("2WT6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c186103be3820e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














const $a8c186103be3820e$var$themeImportsMap = {
    'light': ()=>(parcelRequire("8REdP")),
    'light-future': ()=>(parcelRequire("iIwgI")),
    'light-increased-contrast': ()=>(parcelRequire("8micn")),
    'dark': ()=>(parcelRequire("1ZPjW")),
    'dark-future': ()=>(parcelRequire("helue")),
    'dark-increased-contrast': ()=>(parcelRequire("2oKdj")),
    'legacy-light': ()=>(parcelRequire("c62v8")),
    'legacy-dark': ()=>(parcelRequire("lD1l1")),
    'spacing': ()=>(parcelRequire("kZ84F")),
    'typography-adg3': ()=>(parcelRequire("aEiYj")),
    'shape': ()=>(parcelRequire("gDf7r")),
    'typography-modernized': ()=>(parcelRequire("crf1Q")),
    'typography-refreshed': ()=>(parcelRequire("dpAWL")),
    'light-brand-refresh': ()=>(parcelRequire("1iqC7")),
    'dark-brand-refresh': ()=>(parcelRequire("ao56R"))
};
var $a8c186103be3820e$export$2e2bcd8739ae039 = $a8c186103be3820e$var$themeImportsMap;

});
parcelRegister("8REdP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("97hx2").then(()=>parcelRequire('k2gZk'));

});
parcelRegister("d1Cng", function(module, exports) {
"use strict";

function $97b922b3683b5ed5$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("2MVa4")).resolve(id));
}
module.exports = $97b922b3683b5ed5$var$load;

});
parcelRegister("2MVa4", function(module, exports) {

$parcel$export(module.exports, "register", () => $207c67878e5e04f0$export$6503ec6e8aabbaf, (v) => $207c67878e5e04f0$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $207c67878e5e04f0$export$f7ad0328861e2f03, (v) => $207c67878e5e04f0$export$f7ad0328861e2f03 = v);
var $207c67878e5e04f0$export$6503ec6e8aabbaf;
var $207c67878e5e04f0$export$f7ad0328861e2f03;
"use strict";
var $207c67878e5e04f0$var$mapping = new Map();
function $207c67878e5e04f0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$207c67878e5e04f0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $207c67878e5e04f0$var$resolve(id) {
    var resolved = $207c67878e5e04f0$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$207c67878e5e04f0$export$6503ec6e8aabbaf = $207c67878e5e04f0$var$register;
$207c67878e5e04f0$export$f7ad0328861e2f03 = $207c67878e5e04f0$var$resolve;

});



parcelRegister("iIwgI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dL1bL").then(()=>parcelRequire('dPLEd'));

});

parcelRegister("8micn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("Syoj1").then(()=>parcelRequire('dmwL4'));

});

parcelRegister("1ZPjW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6GEwm").then(()=>parcelRequire('a8k5A'));

});

parcelRegister("helue", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("i5ePE").then(()=>parcelRequire('glWD4'));

});

parcelRegister("2oKdj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7jtDU").then(()=>parcelRequire('gBwfR'));

});

parcelRegister("c62v8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("346mp").then(()=>parcelRequire('jkBTb'));

});

parcelRegister("lD1l1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gd1Sy").then(()=>parcelRequire('fSakz'));

});

parcelRegister("kZ84F", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2jtSi").then(()=>parcelRequire('ftCau'));

});

parcelRegister("aEiYj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kj4zL").then(()=>parcelRequire('ahUkx'));

});

parcelRegister("gDf7r", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dihCl").then(()=>parcelRequire('lzOur'));

});

parcelRegister("crf1Q", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gUBTK").then(()=>parcelRequire('4razn'));

});

parcelRegister("dpAWL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iJWy7").then(()=>parcelRequire('7pZje'));

});

parcelRegister("1iqC7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2Bk7E").then(()=>parcelRequire('6ysZE'));

});

parcelRegister("ao56R", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fdq0Y").then(()=>parcelRequire('33jGP'));

});



parcelRegister("7WVnf", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $30222fed45f71a3a$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $30222fed45f71a3a$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $30222fed45f71a3a$export$e673f367da2ff23e);

var $gpAdT = parcelRequire("gpAdT");

var $jDQ57 = parcelRequire("jDQ57");

var $5rhS8 = parcelRequire("5rhS8");
function $30222fed45f71a3a$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $5rhS8.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $jDQ57.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $jDQ57.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $30222fed45f71a3a$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $jDQ57.CUSTOM_THEME_ATTRIBUTE)}][${(0, $jDQ57.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $30222fed45f71a3a$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $gpAdT.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});

parcelRegister("cI4cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb9f9d5addebf15$export$2e2bcd8739ae039);

var $en7tp = parcelRequire("en7tp");

var $e6GUV = parcelRequire("e6GUV");

var $bzjm2 = parcelRequire("bzjm2");

var $g8Dlj = parcelRequire("g8Dlj");

var $7WVnf = parcelRequire("7WVnf");

var $cmU61 = parcelRequire("cmU61");

var $6K9n3 = parcelRequire("6K9n3");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $bbb9f9d5addebf15$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $e6GUV.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $e6GUV.themeStateDefaults)['contrastMode'], dark: dark = (0, $e6GUV.themeStateDefaults)['dark'], light: light = (0, $e6GUV.themeStateDefaults)['light'], shape: shape = (0, $e6GUV.themeStateDefaults)['shape'], spacing: spacing = (0, $e6GUV.themeStateDefaults)['spacing'], typography: typography = (0, $e6GUV.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $e6GUV.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $en7tp.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $cmU61.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $6K9n3.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $bzjm2.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $e6GUV.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $7WVnf.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("gQgwW"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $cmU61.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $g8Dlj.default)(themeState);
    return autoUnbind;
};
var $bbb9f9d5addebf15$export$2e2bcd8739ae039 = $bbb9f9d5addebf15$var$setGlobalTheme;

});
parcelRegister("g8Dlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbdf9122d4d79e7c$export$2e2bcd8739ae039);

var $en7tp = parcelRequire("en7tp");

var $4Ud4A = parcelRequire("4Ud4A");

var $eN4yW = parcelRequire("eN4yW");

var $aBvSc = parcelRequire("aBvSc");
function $cbdf9122d4d79e7c$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $eN4yW.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $eN4yW.default).bind();
    } else (0, $eN4yW.default).unbind();
    if ((0, $en7tp.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $aBvSc.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $aBvSc.default).bind();
        } else (0, $aBvSc.default).unbind();
    }
    const themeAttributes = (0, $4Ud4A.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $eN4yW.default).unbind();
        if ((0, $en7tp.fg)('platform_increased-contrast-themes')) (0, $aBvSc.default).unbind();
    };
}

});
parcelRegister("eN4yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba3a70238d9c5978$export$2e2bcd8739ae039);

var $74BVL = parcelRequire("74BVL");

var $jDQ57 = parcelRequire("jDQ57");

var $6K9n3 = parcelRequire("6K9n3");
const $ba3a70238d9c5978$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $ba3a70238d9c5978$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $jDQ57.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $ba3a70238d9c5978$var$darkModeMql = $ba3a70238d9c5978$var$isMatchMediaAvailable && window.matchMedia((0, $6K9n3.darkModeMediaQuery));
class $ba3a70238d9c5978$var$ColorModeObserver {
    getColorMode() {
        if (!$ba3a70238d9c5978$var$darkModeMql) return 'light';
        return $ba3a70238d9c5978$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($ba3a70238d9c5978$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $74BVL.bind)($ba3a70238d9c5978$var$darkModeMql, {
            type: 'change',
            listener: $ba3a70238d9c5978$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $ba3a70238d9c5978$var$SingletonColorModeObserver = new $ba3a70238d9c5978$var$ColorModeObserver();
var $ba3a70238d9c5978$export$2e2bcd8739ae039 = $ba3a70238d9c5978$var$SingletonColorModeObserver;

});

parcelRegister("aBvSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85ec424d9f2b351$export$2e2bcd8739ae039);

var $74BVL = parcelRequire("74BVL");

var $jDQ57 = parcelRequire("jDQ57");

var $6K9n3 = parcelRequire("6K9n3");
const $c85ec424d9f2b351$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $c85ec424d9f2b351$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $jDQ57.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $c85ec424d9f2b351$var$contrastModeMql = $c85ec424d9f2b351$var$isMatchMediaAvailable && window.matchMedia((0, $6K9n3.moreContrastMediaQuery));
class $c85ec424d9f2b351$var$ContrastModeObserver {
    getContrastMode() {
        if (!$c85ec424d9f2b351$var$contrastModeMql) return 'no-preference';
        return $c85ec424d9f2b351$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($c85ec424d9f2b351$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $74BVL.bind)($c85ec424d9f2b351$var$contrastModeMql, {
            type: 'change',
            listener: $c85ec424d9f2b351$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $c85ec424d9f2b351$var$SingletonContrastModeObserver = new $c85ec424d9f2b351$var$ContrastModeObserver();
var $c85ec424d9f2b351$export$2e2bcd8739ae039 = $c85ec424d9f2b351$var$SingletonContrastModeObserver;

});


parcelRegister("gQgwW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("H6b39").then(()=>parcelRequire('4JOsW'));

});


parcelRegister("jCx8W", function(module, exports) {

$parcel$export(module.exports, "NestedContext", () => $f79bea1819e0bddf$export$46b2c2071c8c725a);
$parcel$export(module.exports, "useNestedContext", () => $f79bea1819e0bddf$export$f24166abe9ed712b);
$parcel$export(module.exports, "useShouldNestedElementRender", () => $f79bea1819e0bddf$export$37e8646a1abfc3e6);

var $eUqFw = parcelRequire("eUqFw");
const $f79bea1819e0bddf$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $f79bea1819e0bddf$export$f24166abe9ed712b = ()=>{
    const context = (0, $eUqFw.useContext)($f79bea1819e0bddf$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $f79bea1819e0bddf$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $eUqFw.useContext)($f79bea1819e0bddf$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});

parcelRegister("iEJ3y", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $def1177ac01be89d$export$b2ad68b9bc407b80);

var $eUqFw = parcelRequire("eUqFw");

var $6MS5V = parcelRequire("6MS5V");
const $def1177ac01be89d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6MS5V.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $def1177ac01be89d$export$2e2bcd8739ae039 = $def1177ac01be89d$export$b2ad68b9bc407b80;

});
parcelRegister("6MS5V", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $4cc9c06527893786$export$ff983d2a2b6112ea);

var $eUqFw = parcelRequire("eUqFw");

var $kH1QC = parcelRequire("kH1QC");
const $4cc9c06527893786$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $kH1QC.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("kH1QC", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $e07bae8ff2de2fc0$export$2f62ee6831462844);

var $eUqFw = parcelRequire("eUqFw");
function $e07bae8ff2de2fc0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("i5dAO", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $833bdf7f68c2d804$export$21bfbeb62fdcce8d);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Edzt = parcelRequire("4Edzt");

var $aj9D5 = parcelRequire("aj9D5");

var $l87sQ = parcelRequire("l87sQ");

var $3axaQ = parcelRequire("3axaQ");
const $833bdf7f68c2d804$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $l87sQ.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $833bdf7f68c2d804$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $aj9D5.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $aj9D5.defaultLogoParams).iconColor, textColor: textColor = (0, $aj9D5.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4Edzt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3axaQ.default), {
        appearance: appearance,
        label: label,
        svg: $833bdf7f68c2d804$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iUUx1", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $8c72b94180b2da24$export$3c6158790f5e01c4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Edzt = parcelRequire("4Edzt");

var $aj9D5 = parcelRequire("aj9D5");

var $l87sQ = parcelRequire("l87sQ");

var $3axaQ = parcelRequire("3axaQ");
const $8c72b94180b2da24$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $l87sQ.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $8c72b94180b2da24$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $aj9D5.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $aj9D5.defaultLogoParams).iconColor, textColor: textColor = (0, $aj9D5.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4Edzt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3axaQ.default), {
        appearance: appearance,
        label: label,
        svg: $8c72b94180b2da24$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iTe8V", function(module, exports) {

$parcel$export(module.exports, "HasCustomThemeContext", () => $fd1e5acbcd7bde4b$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $fd1e5acbcd7bde4b$export$abfcaeeca4ae7a55);

var $eUqFw = parcelRequire("eUqFw");
const $fd1e5acbcd7bde4b$export$d158fa15757a1890 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $fd1e5acbcd7bde4b$export$abfcaeeca4ae7a55() {
    return (0, $eUqFw.useContext)($fd1e5acbcd7bde4b$export$d158fa15757a1890);
}

});

parcelRegister("a6Oct", function(module, exports) {

$parcel$export(module.exports, "themedLogoIcon", () => $f39c24b0ff70ab60$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $f39c24b0ff70ab60$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $f39c24b0ff70ab60$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $a4XwB = parcelRequire("a4XwB");

var $iTe8V = parcelRequire("iTe8V");
const $f39c24b0ff70ab60$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $f39c24b0ff70ab60$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $f39c24b0ff70ab60$var$navLogoStyles = {
    root: "_1e0c1txw _4cvr1h6o _4t3izwfg _2rkoiti9",
    icon: "_1e0c1txw _18zr1b66 _10y4glyw",
    logo: "_1e0cglyw _18zru2gc _10y41txw"
};
const $f39c24b0ff70ab60$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label = 'Home' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4XwB.default), {
        "aria-label": label,
        href: href,
        xcss: $f39c24b0ff70ab60$var$navLogoStyles.root,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $f39c24b0ff70ab60$var$navLogoStyles.icon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f39c24b0ff70ab60$var$NavLogoRenderer, {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $f39c24b0ff70ab60$var$navLogoStyles.logo
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f39c24b0ff70ab60$var$NavLogoRenderer, {
        logoOrIcon: logo
    })));
function $f39c24b0ff70ab60$var$NavLogoRenderer({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $iTe8V.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: `var(${$f39c24b0ff70ab60$export$24328117f1132113})`,
        textColor: `var(${$f39c24b0ff70ab60$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("ewVnN", function(module, exports) {

$parcel$export(module.exports, "themedButtonBackground", () => $1bdaed872e086b8f$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $1bdaed872e086b8f$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $1bdaed872e086b8f$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $1bdaed872e086b8f$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $1bdaed872e086b8f$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $1bdaed872e086b8f$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $1bdaed872e086b8f$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $1bdaed872e086b8f$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $1bdaed872e086b8f$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $1bdaed872e086b8f$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $1bdaed872e086b8f$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $1bdaed872e086b8f$export$c5c0213472126c08);
$parcel$export(module.exports, "ThemedButton", () => $1bdaed872e086b8f$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedIconButton", () => $1bdaed872e086b8f$export$d9c2d067feb61447);
/* button.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2Eyt5 = parcelRequire("2Eyt5");

var $bwLgX = parcelRequire("bwLgX");

var $9cyqT = parcelRequire("9cyqT");

var $cSNAv = parcelRequire("cSNAv");
const $1bdaed872e086b8f$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
const $1bdaed872e086b8f$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
const $1bdaed872e086b8f$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
const $1bdaed872e086b8f$export$2b00bded80635cbb = '--ds-top-bar-button-border';
const $1bdaed872e086b8f$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
const $1bdaed872e086b8f$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
const $1bdaed872e086b8f$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
const $1bdaed872e086b8f$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
const $1bdaed872e086b8f$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
const $1bdaed872e086b8f$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
const $1bdaed872e086b8f$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
const $1bdaed872e086b8f$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
// TODO: use codegen to ensure these don't get stale
const $1bdaed872e086b8f$var$styles = {
    root: "_1e0c1txw _zulp1b66 _4cvr1h6o _1bah1h6o _11c81oud _4t3i5r7u _1rjcze3t _2rkosqtm _v5649dqc _kqswh2mm",
    border: "_aetrb3bt _14mj1kw7 _1tv3nqa1 _39yqe4h9 _18postnw _9v7aze3t",
    selected: "_syazw5ct _11q71qds _8l3m1yqz _19lcjrv1 _j6xtnh62",
    hasIconBefore: "_bozgu2gc",
    iconBefore: "_bozg1b66 _y4tiv77o _vwz4idpf",
    text: "_k48p1wq8",
    textButton: "_18zrutpp",
    iconButton: "_1bsb5r7u _18zrze3t _vwz4idpf"
};
const $1bdaed872e086b8f$var$appearanceStyles = {
    default: "_syaz1r31 _11q7pkxg _8l3maykr _19lc1rps _j6xtqtgh",
    subtle: "_syaz1r31 _11q7pkxg _19lc1rps _j6xtqtgh",
    primary: "_syaz15o7 _11q7esko _19lcp6hf _j6xt5sko"
};
const $1bdaed872e086b8f$var$BaseThemedButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function BaseThemedButton({ appearance: appearance = 'default', type: type, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, iconBefore: IconBefore, children: children }, ref) {
    const isTextButton = type === 'Button';
    const isIconButton = type === 'IconButton';
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ $eUqFw.createElement((0, $bwLgX.default), {
        ref: ref,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $2Eyt5.cx)($1bdaed872e086b8f$var$styles.root, isTextButton && $1bdaed872e086b8f$var$styles.textButton, isIconButton && $1bdaed872e086b8f$var$styles.iconButton, hasBorder && $1bdaed872e086b8f$var$styles.border, $1bdaed872e086b8f$var$appearanceStyles[appearance], isSelected && $1bdaed872e086b8f$var$styles.selected, IconBefore && $1bdaed872e086b8f$var$styles.hasIconBefore),
        onClick: onClick,
        interactionName: interactionName,
        testId: testId
    }, IconBefore && /*#__PURE__*/ $eUqFw.createElement("span", {
        className: (0, $7JEyt.default)([
            $1bdaed872e086b8f$var$styles.iconBefore
        ])
    }, /*#__PURE__*/ $eUqFw.createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), isTextButton ? /*#__PURE__*/ $eUqFw.createElement("span", {
        className: (0, $7JEyt.default)([
            $1bdaed872e086b8f$var$styles.text
        ])
    }, children) : children);
});
const $1bdaed872e086b8f$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function ThemedButton({ appearance: appearance = 'default', iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId }, ref) {
    return /*#__PURE__*/ $eUqFw.createElement($1bdaed872e086b8f$var$BaseThemedButton, {
        type: "Button",
        ref: ref,
        appearance: appearance,
        onClick: onClick,
        interactionName: interactionName,
        testId: testId,
        iconBefore: iconBefore,
        isSelected: isSelected
    }, children);
});
const $1bdaed872e086b8f$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function ThemedIconButton({ appearance: appearance = 'default', icon: Icon, label: label, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId }, ref) {
    return(// TODO: look at using render props API
    // or introduce an API that only uses ref
    /*#__PURE__*/ $eUqFw.createElement((0, $9cyqT.default), {
        content: label
    }, /*#__PURE__*/ $eUqFw.createElement($1bdaed872e086b8f$var$BaseThemedButton, {
        ref: ref,
        onClick: onClick,
        type: "IconButton",
        appearance: appearance,
        interactionName: interactionName,
        testId: testId,
        isSelected: isSelected
    }, /*#__PURE__*/ $eUqFw.createElement(Icon, {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ $eUqFw.createElement((0, $cSNAv.default), null, label))));
});

});

parcelRegister("6rzP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3980895feb4eb90c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fzAhp = parcelRequire("fzAhp");

var $9RTEO = parcelRequire("9RTEO");
function $3980895feb4eb90c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3980895feb4eb90c$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $3980895feb4eb90c$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $3980895feb4eb90c$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $3980895feb4eb90c$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $3980895feb4eb90c$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $3980895feb4eb90c$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $3980895feb4eb90c$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $3980895feb4eb90c$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$3980895feb4eb90c$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$3980895feb4eb90c$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$3980895feb4eb90c$var$gridTemplateRowsVar})`
});
const $3980895feb4eb90c$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3980895feb4eb90c$var$Grid = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $9RTEO.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $eUqFw.useMemo)(()=>({
            [$3980895feb4eb90c$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$3980895feb4eb90c$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$3980895feb4eb90c$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $3980895feb4eb90c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $fzAhp.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $fzAhp.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $fzAhp.spaceStylesMap).rowGap[rowGap],
            alignItems && $3980895feb4eb90c$var$alignItemsMap[alignItems],
            alignContent && $3980895feb4eb90c$var$alignContentMap[alignContent],
            justifyContent && $3980895feb4eb90c$var$justifyContentMap[justifyContent],
            autoFlow && $3980895feb4eb90c$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$3980895feb4eb90c$var$Grid.displayName = 'Grid';
var $3980895feb4eb90c$export$2e2bcd8739ae039 = $3980895feb4eb90c$var$Grid;

});

parcelRegister("2gplD", function(module, exports) {

$parcel$export(module.exports, "default", () => $545efe3f24cfeddf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $en7tp = parcelRequire("en7tp");

var $9GF3j = parcelRequire("9GF3j");

var $1UQ4d = parcelRequire("1UQ4d");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $545efe3f24cfeddf$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UQ4d.TargetConsumer), null, (targetRef)=>targetRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GF3j.default), {
            name: name,
            hasNodeResolver: !(0, $en7tp.fg)('platform_design_system_team_onboarding_noderesolve'),
            targetRef: targetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)) : children);
var $545efe3f24cfeddf$export$2e2bcd8739ae039 = $545efe3f24cfeddf$var$SpotlightTarget;

});
parcelRegister("9GF3j", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84bdf30479bfcbd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbDTY = parcelRequire("lbDTY");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.targetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $a84bdf30479bfcbd$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, targetRef: targetRef, name: name })=>{
    const divRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasNodeResolver) targetRef(name)(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(name)(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        targetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: targetRef(name)
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: divRef
    }, children);
};
var $a84bdf30479bfcbd$export$2e2bcd8739ae039 = $a84bdf30479bfcbd$var$NodeResolverSpotlightTarget;

});


parcelRegister("9ThMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6287e76d2500b18d5de227ad18c549a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73370a3257af7237$var$_react = $73370a3257af7237$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $73370a3257af7237$var$_UNSAFE_baseNew = $73370a3257af7237$var$_interopRequireDefault((parcelRequire("li861")));
function $73370a3257af7237$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarStarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starred or favourited objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73370a3257af7237$var$StarStarredIcon = (props)=>/*#__PURE__*/ $73370a3257af7237$var$_react.default.createElement($73370a3257af7237$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 8.917 2.597 11.25l1.07-3.986L.75 4.834l3.792-.292L6 .75l1.458 3.792 3.792.291-2.917 2.43 1.07 3.987z"/><path fill="currentcolor" d="m6 8.917.424-.619L6 8.008l-.424.29zM2.597 11.25l-.724-.194a.75.75 0 0 0 1.148.813zm1.07-3.986.724.194.124-.463-.368-.307zM.75 4.834l-.058-.748A.75.75 0 0 0 .27 5.41zm3.792-.292.057.747.473-.036.17-.442zM6 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.458 3.792-.7.269.17.442.473.036zm3.792.291.48.577a.75.75 0 0 0-.423-1.324zm-2.917 2.43-.48-.575-.368.307.124.463zm1.07 3.987-.424.618a.75.75 0 0 0 1.148-.812zM5.576 8.298l-3.403 2.334.848 1.236 3.403-2.333zm-2.254 3.146L4.39 7.458 2.942 7.07l-1.07 3.986zm.825-4.756L1.23 4.258.27 5.41l2.917 2.43zM.807 5.58 4.6 5.29l-.115-1.495-3.792.292zm4.435-.77L6.7 1.019 5.3.481 3.842 4.272zM5.3 1.019l1.458 3.792 1.4-.539L6.7.481zm2.1 4.27 3.793.292.114-1.495-3.791-.292zm3.37-1.032-2.917 2.43.96 1.153 2.917-2.43zM7.609 7.458l1.07 3.986 1.448-.388-1.07-3.986zm2.218 3.174L6.424 8.298l-.848 1.237 3.403 2.333z"/>`,
        type: 'utility'
    }, props));
$73370a3257af7237$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $73370a3257af7237$var$_default = module.exports.default = $73370a3257af7237$var$StarStarredIcon;

});

parcelRegister("gWoAY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad87156590fc2488d82f04be39044b80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c55524388aa556a4$var$_react = $c55524388aa556a4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c55524388aa556a4$var$_search = $c55524388aa556a4$var$_interopRequireDefault((parcelRequire("fU1uL")));

var $c55524388aa556a4$var$_search2 = $c55524388aa556a4$var$_interopRequireDefault((parcelRequire("lKhtB")));
function $c55524388aa556a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "SearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c55524388aa556a4$var$SearchIcon = (props)=>/*#__PURE__*/ $c55524388aa556a4$var$_react.default.createElement($c55524388aa556a4$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c55524388aa556a4$var$_search2.default
    }, props));
$c55524388aa556a4$var$SearchIcon.Name = 'SearchIconMigration';
var $c55524388aa556a4$var$_default = module.exports.default = $c55524388aa556a4$var$SearchIcon;

});

parcelRegister("hgYbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7c960c00c1c528$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7mdYn = parcelRequire("7mdYn");

var $4Edzt = parcelRequire("4Edzt");
function $6f7c960c00c1c528$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6f7c960c00c1c528$var$baseImageStyles = {
    name: "1hyxgad",
    styles: "max-width:100%;height:auto"
};
const $6f7c960c00c1c528$var$themedImageStyles = /*#__PURE__*/ (0, $byn9U.css)({
    content: `var(--img-source)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'html[data-color-mode=dark] &': {
        content: `var(--img-source-dark)`
    }
});
function $6f7c960c00c1c528$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, ...props }) {
    const imgRef = (0, $eUqFw.useRef)(null);
    const providedColorMode = (0, $7mdYn.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $4Edzt.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $eUqFw.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--img-source': `url(${src})`,
            '--img-source-dark': `url(${srcDark || src})`
        },
        css: [
            $6f7c960c00c1c528$var$baseImageStyles,
            $6f7c960c00c1c528$var$themedImageStyles
        ],
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("7mdYn", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $c350a9d367b7bf7d$export$ce91654eb9fea460);
$parcel$export(module.exports, "useColorMode", () => $c350a9d367b7bf7d$export$20f3076712c8dfa);
$parcel$export(module.exports, "default", () => $c350a9d367b7bf7d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $cI4cw = parcelRequire("cI4cw");
const $c350a9d367b7bf7d$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing'
};
const $c350a9d367b7bf7d$var$ColorModeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $c350a9d367b7bf7d$var$SetColorModeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $c350a9d367b7bf7d$var$ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $c350a9d367b7bf7d$var$SetThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
function $c350a9d367b7bf7d$export$ce91654eb9fea460() {
    const value = (0, $eUqFw.useContext)($c350a9d367b7bf7d$var$ColorModeContext);
    return value;
}
function $c350a9d367b7bf7d$export$20f3076712c8dfa() {
    const value = (0, $eUqFw.useContext)($c350a9d367b7bf7d$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $c350a9d367b7bf7d$export$e2afe7397c3d11c7() {
    const value = (0, $eUqFw.useContext)($c350a9d367b7bf7d$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $c350a9d367b7bf7d$export$93d4e7f90805808f() {
    const value = (0, $eUqFw.useContext)($c350a9d367b7bf7d$var$ThemeContext);
    if (!value) throw new Error('useTheme must be used within AppProvider.');
    return value;
}
function $c350a9d367b7bf7d$export$501aa0dcd5527a48() {
    const value = (0, $eUqFw.useContext)($c350a9d367b7bf7d$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $c350a9d367b7bf7d$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $c350a9d367b7bf7d$var$prefersDarkModeMql = $c350a9d367b7bf7d$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $c350a9d367b7bf7d$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $c350a9d367b7bf7d$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
function $c350a9d367b7bf7d$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode, defaultTheme: { dark: dark = 'dark', light: light = 'light', spacing: spacing = 'spacing', typography: typography, shape: shape } = $c350a9d367b7bf7d$var$defaultThemeSettings }) {
    const [chosenColorMode, setChosenColorMode] = (0, $eUqFw.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $eUqFw.useState)($c350a9d367b7bf7d$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $eUqFw.useState)({
        dark: dark,
        light: light,
        spacing: spacing,
        typography: typography,
        shape: shape
    });
    const setColorMode = (0, $eUqFw.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($c350a9d367b7bf7d$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $eUqFw.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cI4cw.default)({
            ...theme,
            colorMode: reconciledColorMode
        });
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!$c350a9d367b7bf7d$var$prefersDarkModeMql) return;
        const unbindListener = (0, $74BVL.bind)($c350a9d367b7bf7d$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c350a9d367b7bf7d$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c350a9d367b7bf7d$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c350a9d367b7bf7d$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c350a9d367b7bf7d$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $c350a9d367b7bf7d$export$2e2bcd8739ae039 = $c350a9d367b7bf7d$export$d8964aec282183a3;

});


parcelRegister("icgU6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::600b5c09ed784ac65af53b6373ac5c89>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3f675c1683021c9$var$_react = $d3f675c1683021c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d3f675c1683021c9$var$_UNSAFE_baseNew = $d3f675c1683021c9$var$_interopRequireDefault((parcelRequire("li861")));
function $d3f675c1683021c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3f675c1683021c9$var$WarningIcon = (props)=>/*#__PURE__*/ $d3f675c1683021c9$var$_react.default.createElement($d3f675c1683021c9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.702 9.137A1.25 1.25 0 0 1 10.612 11H1.388a1.25 1.25 0 0 1-1.09-1.863l4.614-8.2a1.25 1.25 0 0 1 2.178 0zM6.75 2.75V6.5h-1.5V2.75zm-.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$d3f675c1683021c9$var$WarningIcon.displayName = 'WarningIcon';
var $d3f675c1683021c9$var$_default = module.exports.default = $d3f675c1683021c9$var$WarningIcon;

});

parcelRegister("dKxC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d9bd259eff2514$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a4XwB = parcelRequire("a4XwB");

var $9cyqT = parcelRequire("9cyqT");

var $bfuYp = parcelRequire("bfuYp");
const $27d9bd259eff2514$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $bfuYp.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cyqT.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4XwB.default), {
            ...saferRest,
            "aria-labelledby": baseProps['aria-labelledby'],
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                saferRest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                saferRest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                saferRest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                saferRest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                saferRest.onBlur?.(e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                baseProps?.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (ref)=>{
                baseProps.ref(ref);
                triggerProps?.ref?.(ref);
            },
            // Base props only
            xcss: baseProps.xcss,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            /**
						 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
						 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
						 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined
        }, baseProps.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4XwB.default), {
        ...saferRest,
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $27d9bd259eff2514$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($27d9bd259eff2514$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/link-icon-button/usage)
 */ const $27d9bd259eff2514$var$LinkIconButton = /*#__PURE__*/ (0, $eUqFw.memo)($27d9bd259eff2514$var$WithRef);
var $27d9bd259eff2514$export$2e2bcd8739ae039 = $27d9bd259eff2514$var$LinkIconButton;

});

parcelRegister("20q3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc06335530c848e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9RTEO = parcelRequire("9RTEO");
function $2dc06335530c848e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2dc06335530c848e$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $2dc06335530c848e$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $2dc06335530c848e$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $2dc06335530c848e$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $9RTEO.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $2dc06335530c848e$var$baseStyles,
            (inline || all) && $2dc06335530c848e$var$inlineBleedMap[inline || all],
            (block || all) && $2dc06335530c848e$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$2dc06335530c848e$var$Bleed.displayName = 'Bleed';
var $2dc06335530c848e$export$2e2bcd8739ae039 = $2dc06335530c848e$var$Bleed;

});

parcelRegister("6inDB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afa9e628c62349c2fcc5869541a25b90>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4956c2767b65668d$var$_react = $4956c2767b65668d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4956c2767b65668d$var$_UNSAFE_baseNew = $4956c2767b65668d$var$_interopRequireDefault((parcelRequire("li861")));
function $4956c2767b65668d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4956c2767b65668d$var$TeamsIcon = (props)=>/*#__PURE__*/ $4956c2767b65668d$var$_react.default.createElement($4956c2767b65668d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M6 14.25H2c-.69 0-1.25-.56-1.25-1.25v-1.25a3 3 0 0 1 3-3h1.149a3 3 0 0 1 2.82 1.975l.563 1.55a3 3 0 0 0 2.82 1.975H14c.69 0 1.25-.56 1.25-1.25v-1.25a3 3 0 0 0-3-3H12c-1.625 0-2.125.25-2.125.25M6.25 4a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm8 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$4956c2767b65668d$var$TeamsIcon.displayName = 'TeamsIcon';
var $4956c2767b65668d$var$_default = module.exports.default = $4956c2767b65668d$var$TeamsIcon;

});

parcelRegister("2wpNR", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $445e298959c5c6b6$export$17d3acb0b4379d02);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Edzt = parcelRequire("4Edzt");

var $aj9D5 = parcelRequire("aj9D5");

var $l87sQ = parcelRequire("l87sQ");

var $3axaQ = parcelRequire("3axaQ");
const $445e298959c5c6b6$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $l87sQ.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $445e298959c5c6b6$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $aj9D5.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $aj9D5.defaultLogoParams).iconColor, textColor: textColor = (0, $aj9D5.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4Edzt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3axaQ.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $445e298959c5c6b6$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ihxx8", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $e2c2de805860d708$export$dabef2be6cd28c20);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Edzt = parcelRequire("4Edzt");

var $aj9D5 = parcelRequire("aj9D5");

var $l87sQ = parcelRequire("l87sQ");

var $3axaQ = parcelRequire("3axaQ");
const $e2c2de805860d708$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $l87sQ.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $e2c2de805860d708$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $aj9D5.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $aj9D5.defaultLogoParams).iconColor, textColor: textColor = (0, $aj9D5.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4Edzt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3axaQ.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e2c2de805860d708$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lq5Yx", function(module, exports) {

$parcel$export(module.exports, "default", () => $28085dd507b21421$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $13Yvw = parcelRequire("13Yvw");

var $hWhcQ = parcelRequire("hWhcQ");


var $gNpMk = parcelRequire("gNpMk");
function $28085dd507b21421$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $28085dd507b21421$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'block',
        width: '30%',
        height: "var(--ds-space-100, 8px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $753dd713deeb1c87$export$8d43898f60b96a82)})`,
        borderRadius: 100,
        content: '""'
    }
});
const $28085dd507b21421$var$defaultWidthStyles = {
    name: "me8tg7",
    styles: "::after{width:30%;}"
};
const $28085dd507b21421$var$customWidthStyles = {
    name: "ms0ivw",
    styles: "::after{width:var(--width);}"
};
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $28085dd507b21421$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $hWhcQ.default) })=>{
    (0, $13Yvw.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $hWhcQ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $byn9U.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gNpMk.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $28085dd507b21421$var$skeletonStyles,
                width ? $28085dd507b21421$var$customWidthStyles : $28085dd507b21421$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-ds--menu--skeleton-heading-item": true,
            "data-testid": testId
        }));
};
var $28085dd507b21421$export$2e2bcd8739ae039 = $28085dd507b21421$var$SkeletonHeadingItem;

});

parcelRegister("e7NBx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b1290bc5816db04bbec0542a218c285>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a488328d9531c268$var$_react = $a488328d9531c268$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a488328d9531c268$var$_UNSAFE_baseNew = $a488328d9531c268$var$_interopRequireDefault((parcelRequire("li861")));
function $a488328d9531c268$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a488328d9531c268$var$ProjectIcon = (props)=>/*#__PURE__*/ $a488328d9531c268$var$_react.default.createElement($a488328d9531c268$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
    }, props));
$a488328d9531c268$var$ProjectIcon.displayName = 'ProjectIcon';
var $a488328d9531c268$var$_default = module.exports.default = $a488328d9531c268$var$ProjectIcon;

});

parcelRegister("1cNqV", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $82f6d00b55d7fd36$export$c49a2b642fe9eef4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Edzt = parcelRequire("4Edzt");

var $aj9D5 = parcelRequire("aj9D5");

var $l87sQ = parcelRequire("l87sQ");

var $3axaQ = parcelRequire("3axaQ");
const $82f6d00b55d7fd36$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $l87sQ.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $82f6d00b55d7fd36$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $aj9D5.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $aj9D5.defaultLogoParams).iconColor, textColor: textColor = (0, $aj9D5.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4Edzt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3axaQ.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $82f6d00b55d7fd36$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fthbB", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $9d79abff4565e4ca$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jbVLq = parcelRequire("jbVLq");

var $en7tp = parcelRequire("en7tp");



var $cx6x1 = parcelRequire("cx6x1");
var $dRJFq = parcelRequire("dRJFq");

var $jVMRe = parcelRequire("jVMRe");

var $b7LtD = parcelRequire("b7LtD");
function $9d79abff4565e4ca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9d79abff4565e4ca$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $c53d70cdc95328f7$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $753dd713deeb1c87$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $9d79abff4565e4ca$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $9d79abff4565e4ca$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $9d79abff4565e4ca$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $9d79abff4565e4ca$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $9d79abff4565e4ca$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $cx6x1.defaultTheme), testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $dRJFq.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jbVLq.NavigationAnalyticsContext), {
        data: $9d79abff4565e4ca$var$analyticsData
    }, /*#__PURE__*/ (0, $byn9U.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $9d79abff4565e4ca$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": "atlassian-navigation"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
        css: $9d79abff4565e4ca$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $byn9U.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $byn9U.jsx)(ProductHome, null), (0, $en7tp.fg)('platform.design-system-team.navigation-v2-no-jank_5yhbd') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b7LtD.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $jVMRe.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9d79abff4565e4ca$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $byn9U.jsx)(Search, null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "list",
        css: [
            $9d79abff4565e4ca$var$rightStyles,
            $9d79abff4565e4ca$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $byn9U.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $byn9U.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $byn9U.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $byn9U.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $byn9U.jsx)(Profile, null))))));
};
var $9d79abff4565e4ca$export$2e2bcd8739ae039 = $9d79abff4565e4ca$export$f66ccb39f60980e5;

});
const $c53d70cdc95328f7$export$30fa7cc5f2690a43 = 56;
const $c53d70cdc95328f7$export$4033a111ca79977d = 1280;
const $c53d70cdc95328f7$export$24ec62cee78b7042 = 1130;
const $c53d70cdc95328f7$export$d8bde68ac946124f = '--ds--ans--fbc';
const $c53d70cdc95328f7$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $c53d70cdc95328f7$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $c53d70cdc95328f7$export$d81606c1fc5119bc = '--ds--ans--c';
const $c53d70cdc95328f7$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("cx6x1", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $95db0339bc236f94$export$164de7ab8df77ef0);


var $9XXr3 = parcelRequire("9XXr3");

var $kYYoP = parcelRequire("kYYoP");
const $95db0339bc236f94$export$eeee8619e1b91cb0 = (0, $kYYoP.generateTheme)({
    name: (0, $9XXr3.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $753dd713deeb1c87$export$29a4f05edc054374),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $753dd713deeb1c87$export$b3de0ae08da2ce64)
});
const $95db0339bc236f94$export$164de7ab8df77ef0 = $95db0339bc236f94$export$eeee8619e1b91cb0;

});
parcelRegister("9XXr3", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $37dbadbf31dca701$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $37dbadbf31dca701$export$2e2bcd8739ae039);


var $7aquy = parcelRequire("7aquy");
const $37dbadbf31dca701$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$b3de0ae08da2ce64), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$b3de0ae08da2ce64), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $753dd713deeb1c87$export$f563ee71e9ee74cd)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
            color: `var(--ds-text, ${(0, $753dd713deeb1c87$export$ad0bacf983b7ddaa)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$f563ee71e9ee74cd), 0.3)})`}`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: '#357DE8' // TODO: replace with token after brand refresh
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $7aquy.hexToRGBA)((0, $753dd713deeb1c87$export$226de0355ed012f8), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $753dd713deeb1c87$export$b3de0ae08da2ce64)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`,
                color: `var(--ds-text-subtlest, ${(0, $753dd713deeb1c87$export$f563ee71e9ee74cd)})`,
                borderColor: `var(--ds-border-input, ${(0, $753dd713deeb1c87$export$d6447c357493214f)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $753dd713deeb1c87$export$215b7063051591f1)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $753dd713deeb1c87$export$29a4f05edc054374)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $753dd713deeb1c87$export$9fdfb749e33cdf97)})`,
            opacity: 1
        }
    }
};
const $37dbadbf31dca701$export$2491e13b198e597d = 'atlassian';
var $37dbadbf31dca701$export$2e2bcd8739ae039 = $37dbadbf31dca701$var$defaultTheme;

});
parcelRegister("7aquy", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $97ca87c6cf5a236a$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $97ca87c6cf5a236a$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $97ca87c6cf5a236a$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $97ca87c6cf5a236a$export$77a1051494882576);

var $taXj4 = parcelRequire("taXj4");
const $97ca87c6cf5a236a$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $taXj4.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $97ca87c6cf5a236a$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $97ca87c6cf5a236a$var$hex = '[a-z0-9]';
const $97ca87c6cf5a236a$var$shortHandHexColorPattern = new RegExp(`#(${$97ca87c6cf5a236a$var$hex})(${$97ca87c6cf5a236a$var$hex})(${$97ca87c6cf5a236a$var$hex})`, 'i');
const $97ca87c6cf5a236a$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $97ca87c6cf5a236a$var$isShortHexColor = (color)=>color && color.length === 4;
const $97ca87c6cf5a236a$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$97ca87c6cf5a236a$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $97ca87c6cf5a236a$var$completeTriplet = (colors)=>`#${$97ca87c6cf5a236a$var$repeat(colors[1], 6)}`;
const $97ca87c6cf5a236a$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $97ca87c6cf5a236a$export$db8d2130677f868c = (color)=>{
    if ($97ca87c6cf5a236a$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($97ca87c6cf5a236a$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($97ca87c6cf5a236a$var$isTriplet(colors)) return $97ca87c6cf5a236a$var$completeTriplet(colors);
            else return $97ca87c6cf5a236a$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $97ca87c6cf5a236a$export$10a10e7cd1193377 = (color)=>{
    const converted = $97ca87c6cf5a236a$export$db8d2130677f868c(color);
    return (0, $taXj4.default).contrastRatio(converted).hex;
};
const $97ca87c6cf5a236a$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$97ca87c6cf5a236a$export$7229be6d7219ee6a((0, $taXj4.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("kYYoP", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $66e4ae0c47be9ffd$export$2e4ecffaca289a18);

var $9XXr3 = parcelRequire("9XXr3");

var $7aquy = parcelRequire("7aquy");
const $66e4ae0c47be9ffd$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $66e4ae0c47be9ffd$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $66e4ae0c47be9ffd$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $7aquy.hexToRGBA)(backgroundColor, 0.65) : (0, $7aquy.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $7aquy.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $7aquy.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $7aquy.hexToRGBA)(backgroundColor, 0.8) : (0, $7aquy.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $7aquy.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $7aquy.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $7aquy.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $7aquy.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $7aquy.getBoxShadow)('transparent')
        }
    };
};
const $66e4ae0c47be9ffd$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $7aquy.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $66e4ae0c47be9ffd$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $7aquy.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $9XXr3.DEFAULT_THEME_NAME)) return 0, $9XXr3.default;
    return {
        mode: {
            create: $66e4ae0c47be9ffd$var$generateButtonCSSStates($66e4ae0c47be9ffd$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $66e4ae0c47be9ffd$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $66e4ae0c47be9ffd$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $7aquy.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $7aquy.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $7aquy.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $7aquy.getBoxShadow)((0, $7aquy.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $7aquy.getContrastColor)(0.1, $66e4ae0c47be9ffd$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $66e4ae0c47be9ffd$export$2e2bcd8739ae039 = $66e4ae0c47be9ffd$export$2e4ecffaca289a18;

});


parcelRegister("dRJFq", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $2d3381d5b91e26cf$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $2d3381d5b91e26cf$export$d8964aec282183a3);

var $eUqFw = parcelRequire("eUqFw");

var $cx6x1 = parcelRequire("cx6x1");
const $2d3381d5b91e26cf$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $cx6x1.defaultTheme));
const $2d3381d5b91e26cf$export$d8964aec282183a3 = $2d3381d5b91e26cf$export$2c657da244d00bd6.Provider;

});

parcelRegister("jVMRe", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $624519b5d63bb734$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4GFWl = parcelRequire("4GFWl");


var $iEJ3y = parcelRequire("iEJ3y");

var $cQDB0 = parcelRequire("cQDB0");

var $92B4R = parcelRequire("92B4R");
function $624519b5d63bb734$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $624519b5d63bb734$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $624519b5d63bb734$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $624519b5d63bb734$var$overflowItemsStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text, ${(0, $753dd713deeb1c87$export$ad0bacf983b7ddaa)})`
});
const $624519b5d63bb734$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cQDB0.useOverflowController)(items);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $92B4R.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $cQDB0.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $624519b5d63bb734$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $624519b5d63bb734$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cQDB0.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $4GFWl.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $byn9U.jsx)(Create, null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $624519b5d63bb734$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iEJ3y.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("cQDB0", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", () => $afb6ea18507cd6aa$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowStatus", () => $afb6ea18507cd6aa$export$3fcfc71fab3314f2);
$parcel$export(module.exports, "useOverflowController", () => $afb6ea18507cd6aa$export$705aa66a39c35bf7);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hWhcQ = parcelRequire("hWhcQ");
// Prevent width detector from triggering too many re-renders
const $afb6ea18507cd6aa$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $afb6ea18507cd6aa$var$ITEM_APPROX_MINWIDTH = 70;
const $afb6ea18507cd6aa$var$calculateHash = (w, n)=>w + '#' + n;
const $afb6ea18507cd6aa$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $afb6ea18507cd6aa$var$OverflowContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $hWhcQ.default),
    closeOverflowMenu: (0, $hWhcQ.default)
});
const $afb6ea18507cd6aa$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $afb6ea18507cd6aa$var$OverflowContext;
    const value = (0, $eUqFw.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Provider, {
        value: value
    }, children);
};
const $afb6ea18507cd6aa$export$3fcfc71fab3314f2 = ()=>(0, $eUqFw.useContext)($afb6ea18507cd6aa$var$OverflowContext);
const $afb6ea18507cd6aa$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(nodes);
    const [width, setWidth] = (0, $eUqFw.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $eUqFw.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $eUqFw.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $eUqFw.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $eUqFw.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, $afb6ea18507cd6aa$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $afb6ea18507cd6aa$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $afb6ea18507cd6aa$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $afb6ea18507cd6aa$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $afb6ea18507cd6aa$var$ITEM_APPROX_MINWIDTH * 2), $afb6ea18507cd6aa$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $afb6ea18507cd6aa$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $afb6ea18507cd6aa$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $afb6ea18507cd6aa$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
		 * This is not necessarily equal to `lastItemWidth` because the
		 * ```js
		 * if (wasJustLimited) {}
		 * ```
		 * branch above modifies `itemsWidths`.
		 *
		 * Using `lastItemWidth` here can cause collapsing behavior to fail,
		 * such as the issue reported in DSP-7329.
		 */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $afb6ea18507cd6aa$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $afb6ea18507cd6aa$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $afb6ea18507cd6aa$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$afb6ea18507cd6aa$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("92B4R", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $6eed100ce5f516e0$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $56VCK = parcelRequire("56VCK");

var $8iF3A = parcelRequire("8iF3A");

var $en7tp = parcelRequire("en7tp");

var $20q3a = parcelRequire("20q3a");
var $9RTEO = parcelRequire("9RTEO");

var $iYzbA = parcelRequire("iYzbA");
const $6eed100ce5f516e0$var$chevronIconStylesWithSpacingFixStyles = (0, $9RTEO.xcss)({
    marginInlineEnd: 'space.negative.050'
});
const $6eed100ce5f516e0$export$bb3af89fb196520d = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iYzbA.PrimaryButton), {
        iconAfter: (0, $en7tp.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8iF3A))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $20q3a.default), {
            xcss: $6eed100ce5f516e0$var$chevronIconStylesWithSpacingFixStyles,
            inline: "space.100"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($56VCK))), {
            label: ""
        })),
        ref: ref,
        ...props
    });
});
var $6eed100ce5f516e0$export$2e2bcd8739ae039 = $6eed100ce5f516e0$export$bb3af89fb196520d;

});
parcelRegister("iYzbA", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $73f5ef7b8e0a988e$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ljMCx = parcelRequire("ljMCx");

var $9cyqT = parcelRequire("9cyqT");

var $fpHUQ = parcelRequire("fpHUQ");

var $63uIz = parcelRequire("63uIz");
function $73f5ef7b8e0a988e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $73f5ef7b8e0a988e$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $73f5ef7b8e0a988e$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $73f5ef7b8e0a988e$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $73f5ef7b8e0a988e$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$73f5ef7b8e0a988e$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$73f5ef7b8e0a988e$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $73f5ef7b8e0a988e$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, tooltip: tooltip, isSelected: isSelected, isHighlighted: isHighlighted, ...buttonProps } = props;
    const theme = (0, $fpHUQ.useTheme)();
    const button = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$73f5ef7b8e0a988e$var$VAR_BUTTON_SELECTED_COLOR]: theme.mode.primaryButton.selected.color,
            [$73f5ef7b8e0a988e$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: theme.mode.primaryButton.selected.borderColor
        },
        css: [
            $73f5ef7b8e0a988e$var$buttonBaseStyles,
            isHighlighted && $73f5ef7b8e0a988e$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ljMCx.default), {
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $63uIz.getPrimaryButtonTheme)(theme),
        ...buttonProps
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9cyqT.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $73f5ef7b8e0a988e$export$2e2bcd8739ae039 = $73f5ef7b8e0a988e$export$ac16a6a04d9b7c84;

});
parcelRegister("fpHUQ", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $1515c28e7772369e$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $dRJFq = parcelRequire("dRJFq");
const $1515c28e7772369e$export$93d4e7f90805808f = ()=>(0, $eUqFw.useContext)((0, $dRJFq.ThemeContext));

});

parcelRegister("63uIz", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $bec2806d39dd0357$export$14dd6915caf431fe);
const $bec2806d39dd0357$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});




parcelRegister("b7LtD", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $9d5465a3de469858$export$43e704064d596a9e);

var $eUqFw = parcelRequire("eUqFw");

var $4GFWl = parcelRequire("4GFWl");

var $51h8o = parcelRequire("51h8o");
var $98MGG = parcelRequire("98MGG");
var $9RTEO = parcelRequire("9RTEO");

var $jUY0r = parcelRequire("jUY0r");
var $grdYo = parcelRequire("grdYo");

var $cQDB0 = parcelRequire("cQDB0");

var $92B4R = parcelRequire("92B4R");
const $9d5465a3de469858$var$containerWrapperStyles = (0, $9RTEO.xcss)({
    height: '100%'
});
const $9d5465a3de469858$var$sharedContainerStyles = (0, $9RTEO.xcss)({
    height: '100%',
    alignItems: 'stretch',
    paddingInlineEnd: 'space.050',
    gap: 'space.100'
});
const $9d5465a3de469858$var$smallContainerStyles = (0, $9RTEO.xcss)({
    [(0, $jUY0r.media).above.sm]: {
        display: 'none'
    }
});
const $9d5465a3de469858$var$mediumContainerStyles = (0, $9RTEO.xcss)({
    display: 'none',
    [(0, $jUY0r.media).above.sm]: {
        display: 'flex'
    },
    [(0, $jUY0r.media).above.lg]: {
        display: 'none'
    }
});
const $9d5465a3de469858$var$largeContainerStyles = (0, $9RTEO.xcss)({
    display: 'none',
    [(0, $jUY0r.media).above.lg]: {
        display: 'flex'
    }
});
const $9d5465a3de469858$var$overflowItemsStyles = (0, $9RTEO.xcss)({
    color: 'color.text'
});
const $9d5465a3de469858$var$MoreItemsPopup = ({ moreLabel: moreLabel, testId: testId, items: items })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
    const onMoreClose = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(false), []);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>setIsMoreOpen((current)=>!current), []);
    const openOverflowMenu = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(true), []);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92B4R.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQDB0.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51h8o.default), {
            xcss: $9d5465a3de469858$var$overflowItemsStyles
        }, items)), [
        items,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GFWl.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        content: content,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    });
};
const $9d5465a3de469858$export$43e704064d596a9e = /*#__PURE__*/ (0, $eUqFw.memo)(({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    // We render a CSS media query based nav at first to handle SSR, then use
    // our useMediaQuery hook once we are hydrated so there is only one set of nav items
    const [isClient, setIsClient] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setIsClient(true);
    }, []);
    // Setting up our media queries to use once app is hydrated
    const mqSm = (0, $grdYo.UNSAFE_useMediaQuery)('above.sm', (event)=>setIsAboveSm(event.matches));
    const [isAboveSm, setIsAboveSm] = (0, $eUqFw.useState)(mqSm?.matches);
    const mqLg = (0, $grdYo.UNSAFE_useMediaQuery)('above.lg', (event)=>setIsAboveLg(event.matches));
    const [isAboveLg, setIsAboveLg] = (0, $eUqFw.useState)(mqLg?.matches);
    // Filter out any falsy items passed in
    const filteredItems = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(items).filter((item)=>!!item), [
        items
    ]);
    // NOTE: we could make these max items configurable in the future. For now
    // we are using sensible defaults. Anything over the max gets put in the
    // overflow menu for that screen size.
    // While it may be tempting to use more than 3 items for the medium nav when
    // you see the available space, you need to consider internationalistion.
    // 3 is the safe, defensive choice across many languages and scripts.
    const smallMaxItems = 0;
    const mediumMaxItems = 3;
    const largeMaxItems = 8;
    // We re-use this in both the CSS media query nav that loads in for SSR,
    // and the JS/hook media query nav that is used once hydrated
    const navItems = (0, $eUqFw.useMemo)(()=>{
        return {
            small: {
                navBarItems: [],
                overflowItems: filteredItems
            },
            medium: {
                navBarItems: filteredItems.slice(0, mediumMaxItems),
                overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
            },
            large: {
                navBarItems: filteredItems.slice(0, largeMaxItems),
                overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
            }
        };
    }, [
        filteredItems
    ]);
    const hydratedNavItems = (0, $eUqFw.useMemo)(()=>{
        if (isAboveLg) return navItems.large;
        if (isAboveSm && !isAboveLg) return navItems.medium;
        return navItems.small;
    }, [
        isAboveLg,
        isAboveSm,
        navItems.large,
        navItems.medium,
        navItems.small
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isClient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51h8o.default), {
        role: "list",
        xcss: $9d5465a3de469858$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98MGG.default), {
        testId: testId && `${testId}-primary-actions`,
        xcss: $9d5465a3de469858$var$sharedContainerStyles
    }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d5465a3de469858$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        items: hydratedNavItems.overflowItems,
        testId: testId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51h8o.default), {
        role: "list",
        xcss: $9d5465a3de469858$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98MGG.default), {
        xcss: [
            $9d5465a3de469858$var$sharedContainerStyles,
            $9d5465a3de469858$var$smallContainerStyles
        ]
    }, filteredItems.length > smallMaxItems && // We don't need to pass items into popup, it won't be interactive (SSR only)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d5465a3de469858$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98MGG.default), {
        xcss: [
            $9d5465a3de469858$var$sharedContainerStyles,
            $9d5465a3de469858$var$mediumContainerStyles
        ]
    }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d5465a3de469858$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98MGG.default), {
        xcss: [
            $9d5465a3de469858$var$sharedContainerStyles,
            $9d5465a3de469858$var$largeContainerStyles
        ]
    }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d5465a3de469858$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    }))), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Create, null));
});

});


parcelRegister("96Fan", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $69354518b9b6a35e$export$9923361bd43fa030);
$parcel$export(module.exports, "AppSwitcherNav4", () => $69354518b9b6a35e$export$28833e0dfbd2ac80);

var $eUqFw = parcelRequire("eUqFw");

var $4bym0 = parcelRequire("4bym0");

var $4IX1h = parcelRequire("4IX1h");

var $eosIa = parcelRequire("eosIa");
const $69354518b9b6a35e$export$9923361bd43fa030 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eosIa.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4IX1h))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        tooltip: tooltip,
        ref: ref,
        ...iconButtonProps
    });
});
const $69354518b9b6a35e$export$28833e0dfbd2ac80 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eosIa.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bym0))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
            color: "var(--ds-icon, #44546F)"
        }),
        tooltip: tooltip,
        ref: ref,
        ...iconButtonProps
    });
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$69354518b9b6a35e$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("eosIa", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $6f3f92d317196c83$export$c25acd513dcc8062);

var $eUqFw = parcelRequire("eUqFw");

var $ljMCx = parcelRequire("ljMCx");

var $9cyqT = parcelRequire("9cyqT");

var $fpHUQ = parcelRequire("fpHUQ");

var $3AhKY = parcelRequire("3AhKY");
const $6f3f92d317196c83$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, ...buttonProps } = props;
    const theme = (0, $fpHUQ.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ljMCx.default), {
        appearance: "primary",
        "aria-label": label,
        testId: testId,
        iconBefore: icon,
        ref: ref,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $3AhKY.getIconButtonTheme)(theme),
        ...buttonProps
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cyqT.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("3AhKY", function(module, exports) {

$parcel$export(module.exports, "getIconButtonTheme", () => $70106775e8eb62dc$export$f32bddcb857301f3);
const $70106775e8eb62dc$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("j6LRa", function(module, exports) {

$parcel$export(module.exports, "SkeletonSwitcherButton", () => $58f631f61ca9cc45$export$41b1bb24b7702cc2);
$parcel$export(module.exports, "Nav4SkeletonSwitcherButton", () => $58f631f61ca9cc45$export$68afc1d9d20a7bd8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4bym0 = parcelRequire("4bym0");

var $4IX1h = parcelRequire("4IX1h");

var $2SbPj = parcelRequire("2SbPj");

var $fpHUQ = parcelRequire("fpHUQ");
const $58f631f61ca9cc45$var$skeletonSwitcherButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:only-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        marginRight: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $58f631f61ca9cc45$export$41b1bb24b7702cc2 = ({ label: label = '', testId: testId })=>{
    const theme = (0, $fpHUQ.useTheme)();
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $58f631f61ca9cc45$var$skeletonSwitcherButtonStyles,
        type: "button"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4IX1h))), {
        label: label
    })));
};
const $58f631f61ca9cc45$export$68afc1d9d20a7bd8 = ({ label: label = '', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2SbPj.SkeletonIconButton), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4bym0))), {
        label: label,
        color: "var(--ds-icon, #44546F)"
    }));

});
parcelRegister("2SbPj", function(module, exports) {

$parcel$export(module.exports, "SkeletonIconButton", () => $2a769b5ff8e79ac8$export$7b398af37f6177e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fpHUQ = parcelRequire("fpHUQ");
function $2a769b5ff8e79ac8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2a769b5ff8e79ac8$var$skeletonIconButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: 0,
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $2a769b5ff8e79ac8$var$buttonWrapperStyles = {
    name: "khzvr",
    styles: "margin-inline-end:var(--ds-space-050, 4px);&:only-of-type{margin-inline-end:0;}"
};
const $2a769b5ff8e79ac8$export$7b398af37f6177e = ({ children: children, testId: testId })=>{
    const theme = (0, $fpHUQ.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "listitem",
        css: $2a769b5ff8e79ac8$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $2a769b5ff8e79ac8$var$skeletonIconButtonStyles,
        type: "button"
    }, children));
};

});


parcelRegister("dxEez", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $3cb976ebf2f16faa$export$36ba2f559d49a8f6);

var $eUqFw = parcelRequire("eUqFw");

var $2eQxx = parcelRequire("2eQxx");

var $9voA6 = parcelRequire("9voA6");

var $eosIa = parcelRequire("eosIa");
const $3cb976ebf2f16faa$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $3cb976ebf2f16faa$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9voA6.BadgeContainer), {
        id: $3cb976ebf2f16faa$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eosIa.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2eQxx))), {
            label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
        }),
        tooltip: tooltip,
        ref: ref,
        "aria-describedby": $3cb976ebf2f16faa$var$NOTIFICATIONS_BADGE_ID,
        ...iconButtonProps
    }));
});
var $3cb976ebf2f16faa$export$2e2bcd8739ae039 = $3cb976ebf2f16faa$export$36ba2f559d49a8f6;

});
parcelRegister("9voA6", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $5bdfa561cce6dd38$export$f710265eb5a003da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $5bdfa561cce6dd38$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5bdfa561cce6dd38$var$badgeContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $5bdfa561cce6dd38$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $5bdfa561cce6dd38$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5bdfa561cce6dd38$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5bdfa561cce6dd38$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Badge, null)));
};

});


parcelRegister("e9YZW", function(module, exports) {

$parcel$export(module.exports, "SkeletonNotificationButton", () => $553a8515e11ba9c4$export$a14f01df37978534);
$parcel$export(module.exports, "Nav4SkeletonNotificationButton", () => $553a8515e11ba9c4$export$6df5583c56de301f);

var $eUqFw = parcelRequire("eUqFw");

var $25Z5d = parcelRequire("25Z5d");

var $2eQxx = parcelRequire("2eQxx");

var $2SbPj = parcelRequire("2SbPj");
const $553a8515e11ba9c4$export$a14f01df37978534 = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2SbPj.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2eQxx))), {
        label: label
    }));
const $553a8515e11ba9c4$export$6df5583c56de301f = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2SbPj.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($25Z5d))), {
        label: label,
        color: "var(--ds-icon, #44546F)"
    }));

});

parcelRegister("bwJHg", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $d0961c015f85ba97$export$36ba2f559d49a8f6);
/* notifications.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $25Z5d = parcelRequire("25Z5d");

var $23jWX = parcelRequire("23jWX");

var $64HLz = parcelRequire("64HLz");
const $d0961c015f85ba97$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $d0961c015f85ba97$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ badge: badge, onClick: onClick, label: label = 'Notifications', isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23jWX.BadgeContainer), {
        id: $d0961c015f85ba97$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64HLz.IconButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($25Z5d))),
        label: label,
        onClick: onClick,
        appearance: "subtle",
        isSelected: isSelected,
        ref: forwardedRef,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName
    })));

});
parcelRegister("23jWX", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $4ab89926bb3ed6d5$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4ab89926bb3ed6d5$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $4ab89926bb3ed6d5$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, role: role })=>/*#__PURE__*/ $eUqFw.createElement("div", {
        role: role,
        className: (0, $7JEyt.default)([
            $4ab89926bb3ed6d5$var$styles.root
        ])
    }, children, /*#__PURE__*/ $eUqFw.createElement("div", {
        id: badgeId,
        "aria-hidden": true,
        className: (0, $7JEyt.default)([
            $4ab89926bb3ed6d5$var$styles.badgeContainer
        ])
    }, /*#__PURE__*/ $eUqFw.createElement(Badge, null)));

});

parcelRegister("64HLz", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $050674d813127a72$export$c25acd513dcc8062);
$parcel$export(module.exports, "Button", () => $050674d813127a72$export$353f5b6fc5456de1);

var $eUqFw = parcelRequire("eUqFw");

var $iLFZl = parcelRequire("iLFZl");
var $i3lo1 = parcelRequire("i3lo1");

var $ewVnN = parcelRequire("ewVnN");

var $iTe8V = parcelRequire("iTe8V");
// Needs explicit types, otherwise the inferred types reach into `/dist` and cause lint errors.
const $050674d813127a72$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $iTe8V.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $ewVnN.ThemedIconButton) : (0, $i3lo1.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ref: ref,
        ...props
    });
});
// Needs explicit types, otherwise the inferred types reach into `/dist` and cause lint errors.
const $050674d813127a72$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $iTe8V.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $ewVnN.ThemedButton) : (0, $iLFZl.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ref: ref,
        ...props
    });
});

});


parcelRegister("5Fl1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $112f2e084d4c13dc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $en7tp = parcelRequire("en7tp");



var $fpHUQ = parcelRequire("fpHUQ");

var $2b2UA = parcelRequire("2b2UA");
function $112f2e084d4c13dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $112f2e084d4c13dc$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $c53d70cdc95328f7$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $112f2e084d4c13dc$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $112f2e084d4c13dc$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $c53d70cdc95328f7$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $112f2e084d4c13dc$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $753dd713deeb1c87$export$215b7063051591f1)})`}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $c53d70cdc95328f7$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $c53d70cdc95328f7$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $112f2e084d4c13dc$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
const $112f2e084d4c13dc$var$hideSiteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $c53d70cdc95328f7$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
/**
 * __Custom product home__
 *
 * Use `CustomProductHome` to provide a custom logo and icon with URLs.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#custom-product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $112f2e084d4c13dc$var$CustomProductHome = (props)=>{
    const { iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoUrl: logoUrl, href: href, onClick: onClick, siteTitle: siteTitle, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest } = props;
    const theme = (0, $fpHUQ.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const Tag = (0, $2b2UA.getTag)(onClick, href);
    const preventFocusRing = (event)=>{
        event.preventDefault();
        onMouseDown && onMouseDown(event);
    };
    const productHomeButtonDynamicStyles = {
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$112f2e084d4c13dc$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $112f2e084d4c13dc$var$productHomeButtonStyles,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, logoUrl && /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $112f2e084d4c13dc$var$customMaxHeightStyles,
            $112f2e084d4c13dc$var$productLogoStyles
        ],
        src: logoUrl,
        alt: logoAlt,
        "data-testid": testId && `${testId}-logo`
    }), iconUrl && /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $112f2e084d4c13dc$var$customMaxHeightStyles,
            $112f2e084d4c13dc$var$productIconStyles
        ],
        src: iconUrl,
        alt: iconAlt,
        "data-testid": testId && `${testId}-icon`
    })), siteTitle && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $112f2e084d4c13dc$var$siteTitleStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $en7tp.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $112f2e084d4c13dc$var$hideSiteTitleStyles
        ],
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $112f2e084d4c13dc$export$2e2bcd8739ae039 = $112f2e084d4c13dc$var$CustomProductHome;

});
parcelRegister("2b2UA", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $3f1e57bf01f0b39d$export$dad497fe1f6e27c0);
const $3f1e57bf01f0b39d$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("2rOHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba5eea66aa1fb1b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $en7tp = parcelRequire("en7tp");


var $fpHUQ = parcelRequire("fpHUQ");

var $24F2s = parcelRequire("24F2s");

var $2b2UA = parcelRequire("2b2UA");
function $aba5eea66aa1fb1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aba5eea66aa1fb1b$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $aba5eea66aa1fb1b$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $c53d70cdc95328f7$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $c53d70cdc95328f7$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $aba5eea66aa1fb1b$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$aba5eea66aa1fb1b$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$aba5eea66aa1fb1b$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $c53d70cdc95328f7$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $aba5eea66aa1fb1b$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $aba5eea66aa1fb1b$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $c53d70cdc95328f7$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $aba5eea66aa1fb1b$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
// When cleaning up feature flag, these styles can be moved into the above block
const $aba5eea66aa1fb1b$var$featureFlaggedSiteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Under the FF, we've made the site title handle it's spacing, with the
    // PrimaryItemsContainer not needing to worry about its paddingInlineStart.
    // This makes it cleaner for the title styles to appear and disappear with mq's
    marginInlineEnd: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $c53d70cdc95328f7$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $aba5eea66aa1fb1b$var$ProductHome = ({ icon: Icon, logo: Logo, siteTitle: siteTitle, onClick: onClick, href: href, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest })=>{
    const theme = (0, $fpHUQ.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const { iconColor: iconColor = 'inherit', textColor: textColor = theme.mode.productHome.color } = theme.mode.productHome;
    const Tag = (0, $2b2UA.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $24F2s.stripEmptyProperties)({
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$aba5eea66aa1fb1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$aba5eea66aa1fb1b$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $aba5eea66aa1fb1b$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $aba5eea66aa1fb1b$var$customMaxHeightStyles,
            $aba5eea66aa1fb1b$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $aba5eea66aa1fb1b$var$customMaxHeightStyles,
            $aba5eea66aa1fb1b$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        iconColor: iconColor
    }))), siteTitle && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $aba5eea66aa1fb1b$var$siteTitleStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $en7tp.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $aba5eea66aa1fb1b$var$featureFlaggedSiteTitleStyles
        ],
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $aba5eea66aa1fb1b$export$2e2bcd8739ae039 = $aba5eea66aa1fb1b$var$ProductHome;

});
parcelRegister("24F2s", function(module, exports) {

$parcel$export(module.exports, "stripEmptyProperties", () => $5ee9c6c6c4686246$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $5ee9c6c6c4686246$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("hcOFq", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $b916d6493c17edba$export$5120f2d0b8d4cab8);

var $eUqFw = parcelRequire("eUqFw");

var $eosIa = parcelRequire("eosIa");
const $b916d6493c17edba$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { label: labelProp, tooltip: tooltip } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    // All other implementations of IconButton within the components are using spread props, so
    // to use explicit props could cause regressions.
    // TODO: Remove these spread props for better static analysis
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eosIa.IconButton), {
        label: label,
        ref: ref,
        ...props
    }));
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$b916d6493c17edba$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("jykT7", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $3a16587d9cfd931e$export$c72f6eaae7b9adff);

var $eUqFw = parcelRequire("eUqFw");

var $30Nbq = parcelRequire("30Nbq");

var $eosIa = parcelRequire("eosIa");
const $3a16587d9cfd931e$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eosIa.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($30Nbq))), {
            label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
        }),
        ref: ref,
        tooltip: tooltip,
        ...iconButtonProps
    }));
});
var $3a16587d9cfd931e$export$2e2bcd8739ae039 = $3a16587d9cfd931e$export$c72f6eaae7b9adff;

});

parcelRegister("a0q7j", function(module, exports) {

$parcel$export(module.exports, "SkeletonSettingsButton", () => $d7f5a7320e5d8a64$export$914093d4d181ff4d);
$parcel$export(module.exports, "Nav4SkeletonSettingsButton", () => $d7f5a7320e5d8a64$export$beac98f336d7b14f);

var $eUqFw = parcelRequire("eUqFw");

var $jAH7O = parcelRequire("jAH7O");

var $30Nbq = parcelRequire("30Nbq");

var $2SbPj = parcelRequire("2SbPj");
const $d7f5a7320e5d8a64$export$914093d4d181ff4d = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2SbPj.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($30Nbq))), {
        label: label
    }));
const $d7f5a7320e5d8a64$export$beac98f336d7b14f = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2SbPj.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jAH7O))), {
        label: label,
        color: "var(--ds-icon, #44546F)"
    }));

});

parcelRegister("ib8Vh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0fb82c686cea11c3a4213528eb90200c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3c02cf4ba01df4d$var$_react = $d3c02cf4ba01df4d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d3c02cf4ba01df4d$var$_UNSAFE_baseNew = $d3c02cf4ba01df4d$var$_interopRequireDefault((parcelRequire("li861")));
function $d3c02cf4ba01df4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3c02cf4ba01df4d$var$AppsIcon = (props)=>/*#__PURE__*/ $d3c02cf4ba01df4d$var$_react.default.createElement($d3c02cf4ba01df4d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12 9v6m-3-3h6M3 14.25h2c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm8-8h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm-8 0h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$d3c02cf4ba01df4d$var$AppsIcon.displayName = 'AppsIcon';
var $d3c02cf4ba01df4d$var$_default = module.exports.default = $d3c02cf4ba01df4d$var$AppsIcon;

});

parcelRegister("3BepC", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $d400d257e3e2aabe$export$b64708c6f1b3ed96);

var $eUqFw = parcelRequire("eUqFw");

var $keMWK = parcelRequire("keMWK");

var $eosIa = parcelRequire("eosIa");
const $d400d257e3e2aabe$export$b64708c6f1b3ed96 = (props)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eosIa.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($keMWK))), {
            label: typeof tooltip === 'string' ? tooltip : 'Sign-in Icon'
        }),
        tooltip: tooltip,
        ...iconButtonProps
    }));
};
var $d400d257e3e2aabe$export$2e2bcd8739ae039 = $d400d257e3e2aabe$export$b64708c6f1b3ed96;

});

parcelRegister("7wT0s", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $469d50cde857d70d$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");
function $469d50cde857d70d$var$_ListItem({ children: children, xcss: xcss }, ref) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $eUqFw.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss
    }, children));
}
const $469d50cde857d70d$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($469d50cde857d70d$var$_ListItem);

});

parcelRegister("jmbZJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::364579bb5f63ee44481456e5460f4477>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03a2fd6c6f5c3259$var$_react = $03a2fd6c6f5c3259$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $03a2fd6c6f5c3259$var$_creditCard = $03a2fd6c6f5c3259$var$_interopRequireDefault((parcelRequire("W8S5m")));

var $03a2fd6c6f5c3259$var$_creditcardFilled = $03a2fd6c6f5c3259$var$_interopRequireDefault((parcelRequire("aQ2zk")));
function $03a2fd6c6f5c3259$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CreditCardIcon.
 * This component is CreditCardIcon, with `UNSAFE_fallbackIcon` set to "CreditcardFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03a2fd6c6f5c3259$var$CreditCardIcon = (props)=>/*#__PURE__*/ $03a2fd6c6f5c3259$var$_react.default.createElement($03a2fd6c6f5c3259$var$_creditCard.default, Object.assign({
        LEGACY_fallbackIcon: $03a2fd6c6f5c3259$var$_creditcardFilled.default
    }, props));
$03a2fd6c6f5c3259$var$CreditCardIcon.Name = 'CreditCardIconMigration';
var $03a2fd6c6f5c3259$var$_default = module.exports.default = $03a2fd6c6f5c3259$var$CreditCardIcon;

});

parcelRegister("c8CCd", function(module, exports) {

$parcel$export(module.exports, "SkeletonPrimaryButton", () => $6c05a946a06592ef$export$4a3049f952d3f130);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fpHUQ = parcelRequire("fpHUQ");

var $24F2s = parcelRequire("24F2s");
function $6c05a946a06592ef$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6c05a946a06592ef$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
const $6c05a946a06592ef$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
const $6c05a946a06592ef$var$primaryButtonSkeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `0 ${"var(--ds-space-075, 6px)"}`,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    position: 'relative',
    appearance: 'none',
    border: 0,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::-moz-focus-inner': {
        border: 0
    }
});
const $6c05a946a06592ef$var$isHighlightedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$6c05a946a06592ef$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $6c05a946a06592ef$var$isHighlightedAndDropdownButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        insetInlineEnd: -10
    }
});
const $6c05a946a06592ef$var$isHighlightedNotDropdownButtonStyles = {
    name: "1sue5tp",
    styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
};
const $6c05a946a06592ef$var$isDropdownButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginInlineEnd: 18,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        display: 'inline-block',
        width: 4,
        height: 4,
        position: 'absolute',
        borderBlockEnd: '2px solid',
        borderColor: `var(${$6c05a946a06592ef$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
        borderInlineEnd: '2px solid',
        borderRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockStart: 'calc(50% - 4px)',
        insetInlineStart: 'calc(100% - 3px)',
        marginInlineStart: "var(--ds-space-050, 4px)",
        transform: 'rotate(45deg) scale(1.05)',
        verticalAlign: 'middle'
    }
});
const $6c05a946a06592ef$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $6c05a946a06592ef$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
    const theme = (0, $fpHUQ.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const dynamicStyles = (0, $24F2s.stripEmptyProperties)({
        ...primaryButton.default,
        ...isHighlighted && {
            color: primaryButton.selected.color
        },
        [$6c05a946a06592ef$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
        [$6c05a946a06592ef$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "listitem",
        css: $6c05a946a06592ef$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: [
            $6c05a946a06592ef$var$primaryButtonSkeletonStyles,
            isHighlighted && $6c05a946a06592ef$var$isHighlightedStyles,
            isDropdownButton && $6c05a946a06592ef$var$isDropdownButtonStyles,
            isHighlighted && (isDropdownButton ? $6c05a946a06592ef$var$isHighlightedAndDropdownButtonStyles : $6c05a946a06592ef$var$isHighlightedNotDropdownButtonStyles)
        ],
        "data-testid": testId
    }, text || children));
};

});

parcelRegister("8gocn", function(module, exports) {

$parcel$export(module.exports, "Create", () => $45b743a0dbd9813f$export$8ade6fcbf3a7de5d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ljMCx = parcelRequire("ljMCx");

var $8qoI9 = parcelRequire("8qoI9");

var $9cyqT = parcelRequire("9cyqT");


var $fpHUQ = parcelRequire("fpHUQ");

var $eosIa = parcelRequire("eosIa");

var $fMgtS = parcelRequire("fMgtS");
const $45b743a0dbd9813f$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-smallscreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${(0, $c53d70cdc95328f7$export$24ec62cee78b7042) - 1}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-largescreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (min-width: ${0, $c53d70cdc95328f7$export$24ec62cee78b7042}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $45b743a0dbd9813f$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $9cyqT.default), {
        content: buttonTooltip,
        hideTooltipOnClick: true
    }, children) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
const $45b743a0dbd9813f$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
    const theme = (0, $fpHUQ.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $45b743a0dbd9813f$var$wrapperStyles,
        role: "listitem",
        "data-testid": "create-button-wrapper"
    }, /*#__PURE__*/ (0, $byn9U.jsx)($45b743a0dbd9813f$var$TooltipSwitch, {
        buttonTooltip: buttonTooltip
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ljMCx.default), {
        id: "createGlobalItem",
        "aria-label": label,
        onClick: onClick,
        href: href,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $fMgtS.getCreateButtonTheme)(theme),
        testId: testId && `${testId}-button`,
        "data-hide-on-smallscreens": true
    }, text)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eosIa.IconButton), {
        id: "createGlobalItemIconButton",
        testId: testId && `${testId}-icon-button`,
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8qoI9))), {
            label: text
        }),
        onClick: onClick,
        href: href,
        tooltip: iconButtonTooltip,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $fMgtS.getCreateButtonTheme)(theme),
        "aria-label": text,
        "data-hide-on-largescreens": true
    }));
};
var $45b743a0dbd9813f$export$2e2bcd8739ae039 = $45b743a0dbd9813f$export$8ade6fcbf3a7de5d;

});
parcelRegister("fMgtS", function(module, exports) {

$parcel$export(module.exports, "getCreateButtonTheme", () => $82a06c9ba0613de5$export$256eebed8e934f30);
const $82a06c9ba0613de5$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...create.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': create.hover,
                ':focus': create.focus,
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && create.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("hEon7", function(module, exports) {

$parcel$export(module.exports, "SkeletonCreateButton", () => $b080c3a9dd3928d5$export$e321b2260435e302);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fpHUQ = parcelRequire("fpHUQ");
function $b080c3a9dd3928d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b080c3a9dd3928d5$var$skeletonCreateButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: 32,
    padding: `0 ${"var(--ds-space-150, 12px)"}`,
    alignSelf: 'center',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $b080c3a9dd3928d5$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $b080c3a9dd3928d5$export$e321b2260435e302 = ({ text: text, testId: testId })=>{
    const theme = (0, $fpHUQ.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "listitem",
        css: $b080c3a9dd3928d5$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.create.default,
        css: $b080c3a9dd3928d5$var$skeletonCreateButtonStyles,
        "data-testid": testId,
        type: "button"
    }, text));
};

});

parcelRegister("1vpGO", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $8e079dd7477361c6$export$6d3c345ce7c38fd9);

var $eUqFw = parcelRequire("eUqFw");

var $jUKjH = parcelRequire("jUKjH");

var $64HLz = parcelRequire("64HLz");
const $8e079dd7477361c6$export$6d3c345ce7c38fd9 = ({ children: children, onClick: onClick, testId: testId, interactionName: interactionName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64HLz.Button), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jUKjH))),
        onClick: onClick,
        testId: testId,
        interactionName: interactionName
    }, children);

});

parcelRegister("immgn", function(module, exports) {

$parcel$export(module.exports, "Help", () => $8cbcb3bce355cbbe$export$1be7516c0280bee8);

var $eUqFw = parcelRequire("eUqFw");

var $69vGB = parcelRequire("69vGB");

var $fpHUQ = parcelRequire("fpHUQ");

var $9voA6 = parcelRequire("9voA6");

var $eosIa = parcelRequire("eosIa");
const $8cbcb3bce355cbbe$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $8cbcb3bce355cbbe$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
    const { mode: { navigation: navigation } } = (0, $fpHUQ.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eosIa.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($69vGB))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            secondaryColor: navigation.backgroundColor
        }),
        ref: ref,
        tooltip: tooltip,
        ...iconButtonProps
    });
    return badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9voA6.BadgeContainer), {
        id: $8cbcb3bce355cbbe$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, button);
});
var $8cbcb3bce355cbbe$export$2e2bcd8739ae039 = $8cbcb3bce355cbbe$export$1be7516c0280bee8;

});

parcelRegister("2HKsW", function(module, exports) {

$parcel$export(module.exports, "SkeletonHelpButton", () => $a23e1160ebaabbd0$export$9ee5d6e291d4e456);
$parcel$export(module.exports, "Nav4SkeletonHelpButton", () => $a23e1160ebaabbd0$export$c25bc9ca782b25f4);

var $eUqFw = parcelRequire("eUqFw");

var $kHnBx = parcelRequire("kHnBx");

var $69vGB = parcelRequire("69vGB");

var $2SbPj = parcelRequire("2SbPj");

var $fpHUQ = parcelRequire("fpHUQ");
const $a23e1160ebaabbd0$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
    const { mode: { navigation: navigation } } = (0, $fpHUQ.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2SbPj.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($69vGB))), {
        label: label,
        secondaryColor: navigation.backgroundColor
    }));
};
const $a23e1160ebaabbd0$export$c25bc9ca782b25f4 = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2SbPj.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kHnBx))), {
        label: label,
        color: "var(--ds-icon, #44546F)"
    }));

});

parcelRegister("1rrcc", function(module, exports) {

$parcel$export(module.exports, "Help", () => $2669e87447042607$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $kHnBx = parcelRequire("kHnBx");

var $23jWX = parcelRequire("23jWX");

var $7wT0s = parcelRequire("7wT0s");

var $64HLz = parcelRequire("64HLz");
const $2669e87447042607$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $2669e87447042607$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>{
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64HLz.IconButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kHnBx))),
        label: label,
        onClick: onClick,
        appearance: "subtle",
        isSelected: isSelected,
        ref: forwardedRef,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName
    });
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7wT0s.ListItem), null, button);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23jWX.BadgeContainer), {
        id: $2669e87447042607$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button);
});

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $0e331d2ddf763060$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $43d733b06b5bd9fe$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $43d733b06b5bd9fe$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $43d733b06b5bd9fe$export$13f57c02915787b3 = 'atlaskit-portal';

const $f36b986fdaae127a$export$ed5835cc67e87f72 = 'akPortalMount';
const $f36b986fdaae127a$export$80816bd900e5bd00 = 'akPortalUnmount';

// same types defined in analytics-web-client but avoid creating dependency with that
const $0c542478b701cf34$export$a1562d08625f5d7e = 'ui';
const $0c542478b701cf34$export$947dac6c72b26f81 = 'track';
const $0c542478b701cf34$export$f1d537d508d2945a = 'screen';
const $0c542478b701cf34$export$12346a674644c156 = 'operational';
const $0c542478b701cf34$export$b055de0e665cb20c = 'unknown';

const $ead1cbbbe8a91b1e$export$d6830277b06edd6 = 'normal';
const $ead1cbbbe8a91b1e$export$4f8f13a66ae77bdd = '--color';
const $ead1cbbbe8a91b1e$export$e9244ec13bd422b5 = '--bg-color';
const $ead1cbbbe8a91b1e$export$97e78d9745006c11 = '--bg-color-hover';
const $ead1cbbbe8a91b1e$export$291d63757828f290 = '--bg-color-active';


$parcel$global.rlb("bYT2S")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.f214a082.js.map
